// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Jost:ital,wght@0,100..900;1,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*====================== CSS Index Here =======================*/
/*
01. Abstracts
    1.1. Classes
    1.2. Extend
    1.3. Functions
    1.4. Mixins
    1.5. Variable
    1.6. Wordpress Default

02. Base
    2.1. Margin
    2.2. Padding
    2.3. Typography

03. Components
    3.1. Accordion
    3.2. Button
    3.3. Form
    3.4. Pagination
    3.6. Tab

04. Layout
    4.1. Blog Sidebar
    4.2. Breadcrumb
    4.3. Comment
    4.4. Footer
    4.5. Header Top
    4.6. Header
    4.7. Preloader
    4.8. Scroll Top
    4.9. Section Heading
    4.10. Slick
    4.11. Social Icon
*/
/*======================== CSS Index End ======================*/
/* ======================== Functions Css End ======================= */
/* ======================== Functions Css End ======================= */
/* Font Family*/

/* ========================= Variable Css Start ======================== */
:root {
    /* Font Family Variable */
    --heading-font: "Jost", sans-serif;
    --body-font: "Inter", sans-serif;
    /* Font Size Variable Start */
    /* --heading-color: #1e1d1d; */
    --heading-one: clamp(1.875rem, -2.0093rem + 8.3527vw, 4.25rem);
    --heading-two: clamp(1.75rem, -0.8115rem + 5.3364vw, 3.1875rem);
    --heading-three: clamp(1.5rem, -0.0592rem + 3.2483vw, 2.375rem);
    --heading-four: clamp(1.375rem, 0.7068rem + 1.3921vw, 1.75rem);
    --heading-five: clamp(1.125rem, 0.4568rem + 1.3921vw, 1.5rem);
    --heading-six: clamp(1rem, 0.7773rem + 0.464vw, 1.125rem);
    /* Font Size End */
    /* Gray Color */
    --main: #FF7A00;
    --main-bg: #FF7A00;
    --body-bg: #F9F5F2;
    --gray-seven: #FFFFFF;
    --white: #fff;
    --black-three: #1e1d1d;
    --white-one: #fff;
    --black: #000;
    --gray-five: 252 10% 90%;
    --gray-seven: 210 25% 97%;
    --body-color: var(--black-three);
    --static-black: var(--black);
    --black-two-h: 234;
    --black-two-s: 69%;
    --black-two-l: 9%;
    --black-two: var(--black-two-h) var(--black-two-s) var(--black-two-l);
    --black-three-h: 235;
    --black-three-s: 5%;
    --black-three-l: 43%;
    --black-three: var(--black-three-h) var(--black-three-s) var(--black-three-l);
    --body_dashboard: #F5F6F8;
    --button-secondary: #666;
}



/* ========================= Variable Css End ======================== */
/* ============================ Mixins Css Start ============================ */
/* Media Breakpoint for Each Device Start */
/* Media Breakpoint for Each Device End */
/* Font Size For responsive devices Start */
/* Font Size For responsive devices End */
/* ============================ Mixins Css End ============================ */
/* ================================= Classes Css Start =========================== */
@media (min-width: 1199px) {
    .container-full {
        max-width: 1792px;
    }
}

@media (min-width: 1199px) {
    .container-two {
        max-width: 1296px;
    }
}

@media (min-width: 1199px) {
    .container-three {
        max-width: 1590px;
    }
}

body {
    /* background: var(--body-bg) !important; */
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
}

.bg_dashboard {
    background: var(--body_dashboard) !important;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
a,
span {
    font-family: Poppins;
    font-style: normal;
    /* font-weight: 500; */
    color: var(--button-secondary);
}

/* Section Background */
.section-bg {
    background-color: var(--section-bg) !important;
}

.sales-offer-bg-two {
    background: linear-gradient(117deg, #F3FEFF 14.35%, #DACFFF 84.4%) !important;
}

.box-shadow {
    box-shadow: var(--box-shadow) !important;
}

.box-shadow-lg {
    box-shadow: var(--box-shadow-lg) !important;
}

.max-h-unset {
    max-height: unset !important;
}

.max-w-unset {
    max-width: unset !important;
}

.w-20 {
    width: 20px;
}

.min-w-maxContent {
    min-width: max-content;
}

.cursor-pointer {
    cursor: pointer;
}

.z-index-1 {
    z-index: 1;
}

.z-index--1 {
    z-index: -1;
}

.bg-white {
    background-color: var(--white) !important;
}

.bg-main {
    background-color: var(--main) !important;
}

.bg-main-btn {
    background: var(--main) !important;
    color: var(--white) !important;
}

.bg-black {
    background-color: var(--black) !important;
}

.bg-static-black {
    background-color: var(--static-black) !important;
}


.border:focus {
    border: 1px solid var(--main) !important;
}

.border-main {
    border-color: var(--main) !important;
}

.border-color {
    border-color: var(--border-color);
}

.border-black {
    border-color: var(--black) !important;
}

.border-gray-five {
    border-color: var(--gray-five) !important;
}

.fw-200 {
    font-weight: 200 !important;
}

.fw-300 {
    font-weight: 300 !important;
}

.fw-400 {
    font-weight: 400 !important;
}

.fw-500 {
    font-weight: 500 !important;
}

.fw-600 {
    font-weight: 600 !important;
}

.fw-700 {
    font-weight: 700 !important;
}

.fw-800 {
    font-weight: 800 !important;
}

.fw-900 {
    font-weight: 900 !important;
}

.left-auto {
    left: auto !important;
}



.text-main {
    color: var(--main) !important;
}


.hover-text-main:hover {
    color: var(--main) !important;
}

.hover-text-decoration-underline:hover {
    text-decoration: underline;
}

.font-heading {
    font-family: var(--heading-font);
}

.font-body {
    font-family: var(--body-font);
}

.pill {
    border-radius: 30px !important;
}

.radius-8 {
    border-radius: 8px !important;
}

.line-height-0 {
    line-height: 0;
}

.line-height-1 {
    line-height: 1;
}

/* Column Extra Small Screen */
@media screen and (min-width: 425px) and (max-width: 575px) {
    .col-xs-6 {
        width: 50%;
    }
}

/* Bg Image Css */
.background-img {
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center center !important;
    width: 100%;
    height: 100%;
}

/* Hide Scroll bar Css For Custom Modal */
.scroll-hide {
    position: absolute;
    overflow-y: hidden;
    padding-right: 17px;
    top: 0;
    left: 0;
    width: 100%;
}

@media screen and (max-width: 991px) {
    .scroll-hide {
        padding-right: 0;
    }
}

.scroll-hide-sm {
    position: absolute;
    overflow-y: hidden;
    top: 0;
    left: 0;
    width: calc(100% - 0px);
}

/* Overlay Start */
.overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    content: "";
    left: 0;
    top: 0;
    background-color: hsla(234, 100%, 7%, 0.8);
    z-index: 99;
    transition: 0.2s linear;
    visibility: hidden;
    opacity: 0;
}

.overlay.show-overlay {
    visibility: visible;
    opacity: 1;
}

@media (max-width: 991px) {
    .side-overlay {
        position: fixed;
        width: 100%;
        height: 100%;
        content: "";
        left: 0;
        top: 0;
        /* background-color: var((--static-black)/0.8); */
        background-color: hsla(234, 100%, 7%, 0.8);
        z-index: 99;
        transition: 0.2s linear;
        visibility: hidden;
        opacity: 0;
    }

    .side-overlay.show {
        visibility: visible;
        opacity: 1;
    }
}

/* Overlay End */
/* ================================= Classes Css End =========================== */
/* ============================ Extend Css Start ======================== */
/* Cover image Css */
.cover-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* Display Flex Css Start */
.flx-wrap {
    display: flex;
    flex-wrap: wrap;
}

.flx-align,
.common-check {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.flx-center {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}

.flx-between {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
}

/* Display Flex Css End */
/* Positioning Css Class Start */
.pa-content {
    position: absolute;
    content: "";
}

.top-center,
.common-accordion .accordion-button[aria-expanded=true]::after,
.common-accordion .accordion-button[aria-expanded=false]::after {
    top: 50%;
    transform: translateY(-50%);
}

.left-center {
    left: 50%;
    transform: translateX(-50%);
}

.top-left-center {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/* Positioning Css Class End */
/* Font Size For responsive devices Start */
.font-10 {
    font-size: 0.625rem !important;
}

.font-11 {
    font-size: 0.6875rem !important;
}

.font-12 {
    font-size: 0.75rem !important;
}

.font-13 {
    font-size: 0.8125rem !important;
}

.font-14 {
    font-size: 0.875rem !important;
}

.font-15 {
    font-size: 0.9375rem !important;
}

.font-16 {
    font-size: 1rem !important;
}

.font-17 {
    font-size: 1.0625rem !important;
}

.font-18 {
    font-size: 1.125rem !important;
}

@media screen and (max-width: 1199px) {
    .font-18 {
        font-size: 1rem !important;
    }
}

@media screen and (max-width: 767px) {
    .font-18 {
        font-size: 0.9375rem !important;
    }
}

.font-19 {
    font-size: 1.1875rem !important;
}

.font-20 {
    font-size: 1.25rem !important;
}

@media screen and (max-width: 1199px) {
    .font-20 {
        font-size: 1.125rem !important;
    }
}

@media screen and (max-width: 767px) {
    .font-20 {
        font-size: 1rem !important;
    }
}

.font-21 {
    font-size: 1.3125rem !important;
}

.font-22 {
    font-size: 1.375rem !important;
}

.font-23 {
    font-size: 1.4375rem !important;
}

.font-24 {
    font-size: 1.5rem !important;
}

.font-25 {
    font-size: 1.5625rem !important;
}

.font-26 {
    font-size: 1.625rem !important;
}

.font-27 {
    font-size: 1.6875rem !important;
}

.font-28 {
    font-size: 1.75rem !important;
}

.font-29 {
    font-size: 1.8125rem !important;
}

.font-30 {
    font-size: 1.875rem !important;
}

.font-31 {
    font-size: 1.9375rem !important;
}

.font-32 {
    font-size: 2rem !important;
}

.font-33 {
    font-size: 2.0625rem !important;
}

.font-34 {
    font-size: 2.125rem !important;
}

.font-35 {
    font-size: 2.1875rem !important;
}

.font-36 {
    font-size: 2.25rem !important;
}

.font-37 {
    font-size: 2.3125rem !important;
}

.font-38 {
    font-size: 2.375rem !important;
}

.font-39 {
    font-size: 2.4375rem !important;
}

.font-40 {
    font-size: 2.5rem !important;
}

/* Font Size For responsive devices End */
/* ============================ Extend Css End ======================== */
/* ======================= WordPress Default Css Start =================== */
.admin-bar .default-header .sticky-wrapper.sticky {
    top: 32px;
}

.wp-block-search__label {
    position: relative;
    font-size: 24px;
    font-weight: 500 !important;
    font-family: var(--title-font);
    line-height: 1em;
    margin: -0.12em 0 25px 0;
}

p.has-drop-cap {
    margin-bottom: 20px;
}

.page--item p:last-child .alignright {
    clear: right;
}

.blog-title,
.pagi-title,
.breadcumb-title {
    word-break: break-word;
}

.blocks-gallery-caption,
.wp-block-embed figcaption,
.wp-block-image figcaption {
    color: var(--body-color);
}

.bypostauthor,
.gallery-caption {
    display: block;
}

.page-links,
.clearfix {
    clear: both;
}

.page--item {
    margin-bottom: 30px;
}

.page--item p {
    line-height: 1.8;
}

.page--item .th-comment-form {
    padding: 0;
}

.page--item .th-comments-wrap {
    margin-left: 0;
    margin-right: 0;
    margin-top: 30px;
}

.content-none-search {
    margin-top: 30px;
}

.wp-block-button.aligncenter {
    text-align: center;
}

.alignleft {
    display: inline;
    float: left;
    margin-bottom: 10px;
    margin-right: 1.5em;
}

.alignright {
    display: inline;
    float: right;
    margin-bottom: 10px;
    margin-left: 1.5em;
    margin-right: 1em;
}

.aligncenter {
    clear: both;
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
}

.gallery {
    margin-bottom: 1.5em;
    width: 100%;
}

.gallery-item {
    display: inline-block;
    text-align: center;
    vertical-align: top;
    width: 100%;
    padding: 0 5px;
}

.wp-block-columns {
    margin-bottom: 1em;
}

figure.gallery-item {
    margin-bottom: 10px;
    display: inline-block;
}

figure.wp-block-gallery {
    margin-bottom: 14px;
}

.gallery-columns-2 .gallery-item {
    max-width: 50%;
}

.gallery-columns-3 .gallery-item {
    max-width: 33.33%;
}

.gallery-columns-4 .gallery-item {
    max-width: 25%;
}

.gallery-columns-5 .gallery-item {
    max-width: 20%;
}

.gallery-columns-6 .gallery-item {
    max-width: 16.66%;
}

.gallery-columns-7 .gallery-item {
    max-width: 14.28%;
}

.gallery-columns-8 .gallery-item {
    max-width: 12.5%;
}

.gallery-columns-9 .gallery-item {
    max-width: 11.11%;
}

.gallery-caption {
    display: block;
    font-size: 12px;
    color: var(--body-color);
    line-height: 1.5;
    padding: 0.5em 0;
}

.wp-block-cover p:not(.has-text-color),
.wp-block-cover-image-text,
.wp-block-cover-text {
    color: var(--white-color);
}

.wp-block-cover {
    margin-bottom: 15px;
}

.wp-caption-text {
    text-align: center;
}

.wp-caption {
    margin-bottom: 1.5em;
    max-width: 100%;
}

.wp-caption .wp-caption-text {
    margin: 0.5em 0;
    font-size: 14px;
}

.wp-block-media-text,
.wp-block-media-text.alignwide,
figure.wp-block-gallery {
    margin-bottom: 30px;
}

.wp-block-media-text.alignwide {
    background-color: var(--smoke-color);
}

.editor-styles-wrapper .has-large-font-size,
.has-large-font-size {
    line-height: 1.4;
}

.wp-block-latest-comments a {
    color: inherit;
}

.wp-block-button {
    margin-bottom: 10px;
}

.wp-block-button:last-child {
    margin-bottom: 0;
}

.wp-block-button .wp-block-button__link {
    color: #fff;
}

.wp-block-button .wp-block-button__link:hover {
    color: #fff;
    background-color: var(--theme-color);
}

.wp-block-button.is-style-outline .wp-block-button__link {
    background-color: transparent;
    border-color: var(--title-color);
    color: var(--title-color);
}

.wp-block-button.is-style-outline .wp-block-button__link:hover {
    color: #fff;
    background-color: var(--theme-color);
    border-color: var(--theme-color);
}

.wp-block-button.is-style-squared .wp-block-button__link {
    border-radius: 0;
}

ol.wp-block-latest-comments li {
    margin: 15px 0;
}

ul.wp-block-latest-posts {
    padding: 0;
    margin: 0;
    margin-bottom: 15px;
}

ul.wp-block-latest-posts a {
    color: inherit;
}

ul.wp-block-latest-posts a:hover {
    color: var(--theme-color);
}

ul.wp-block-latest-posts li {
    margin: 15px 0;
}

.wp-block-search {
    display: flex;
    flex-wrap: wrap;
}

.wp-block-search .wp-block-search__inside-wrapper {
    border: 1px solid #EAEBEE;
    border-radius: 10px 0 0 10px;
    overflow: hidden;
}

.wp-block-search .wp-block-search__input {
    width: 100%;
    max-width: 100%;
    padding-left: 20px;
    border: 0;
}

.wp-block-search .wp-block-search__button {
    margin: 0;
    min-width: 110px;
    border: none;
    color: #fff;
    border-radius: 10px;
    background-color: var(--theme-color);
}

.wp-block-search .wp-block-search__button.has-icon {
    min-width: 55px;
}

.wp-block-search .wp-block-search__button:hover {
    background-color: var(--title-color);
}

.wp-block-search.wp-block-search__button-inside .wp-block-search__inside-wrapper {
    padding: 0;
    border: none;
}

.wp-block-search.wp-block-search__button-inside .wp-block-search__inside-wrapper .wp-block-search__input {
    padding: 0 8px 0 25px;
}

ul.wp-block-rss a {
    color: inherit;
}

.wp-block-group.has-background {
    padding: 15px 15px 1px;
    margin-bottom: 30px;
}

.wp-block-table td,
.wp-block-table th {
    border-color: rgba(0, 0, 0, 0.1);
}

.wp-block-table.is-style-stripes {
    border: 1px solid rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
}

.wp-block-table.is-style-stripes {
    border: 0;
    margin-bottom: 30px;
    border-bottom: 0;
}

.wp-block-table.is-style-stripes th,
.wp-block-table.is-style-stripes td {
    border-color: var(--border-color);
}

.logged-in .will-sticky .sticky-active.active,
.logged-in .preloader .btn {
    top: 32px;
}

@media (max-width: 782px) {

    .logged-in .will-sticky .sticky-active.active,
    .logged-in .preloader .btn {
        top: 46px;
    }
}

@media (max-width: 600px) {

    .logged-in .will-sticky .sticky-active.active,
    .logged-in .preloader .btn {
        top: 0;
    }
}

.post-password-form {
    margin-bottom: 30px;
    margin-top: 20px;
}

.post-password-form p {
    display: flex;
    position: relative;
    gap: 15px;
    /* Extra small devices */
}

@media (max-width: 575px) {
    .post-password-form p {
        flex-wrap: wrap;
    }
}

.post-password-form label {
    display: flex;
    align-items: center;
    flex: auto;
    margin-bottom: 0;
    line-height: 1;
    margin-top: 0;
    gap: 15px;
    /* Extra small devices */
}

@media (max-width: 575px) {
    .post-password-form label {
        flex-wrap: wrap;
    }
}

.post-password-form input {
    width: 100%;
    border: none;
    height: 55px;
    padding-left: 25px;
    color: var(--body-color);
    ;
    border: 1px solid var(--border-color);
}

.post-password-form input[type=submit] {
    padding-left: 0;
    padding-right: 0;
    margin: 0;
    width: 140px;
    border: none;
    color: #fff;
    background-color: var(--theme-color);
    text-align: center;
}

.post-password-form input[type=submit]:hover {
    background-color: var(--title-color);
}

.page-links {
    clear: both;
    margin: 0 0 1.5em;
    padding-top: 1em;
}

.page-links>.page-links-title {
    margin-right: 10px;
}

.page-links>span:not(.page-links-title):not(.screen-reader-text),
.page-links>a {
    display: inline-block;
    padding: 5px 13px;
    background-color: var(--white-color);
    color: var(--title-color);
    border: 1px solid rgba(0, 0, 0, 0.08);
    margin-right: 10px;
}

.page-links>span:not(.page-links-title):not(.screen-reader-text):hover,
.page-links>a:hover {
    opacity: 0.8;
    color: var(--white-color);
    background-color: var(--theme-color);
    border-color: transparent;
}

.page-links>span:not(.page-links-title):not(.screen-reader-text).current,
.page-links>a.current {
    background-color: var(--theme-color);
    color: var(--white-color);
    border-color: transparent;
}

.page-links span.screen-reader-text {
    display: none;
}

.blog-single .wp-block-archives-dropdown {
    margin-bottom: 30px;
}

.blog-single.format-quote,
.blog-single.format-link,
.blog-single.tag-sticky-2,
.blog-single.sticky {
    position: relative;
}

.blog-single.format-quote .blog-content,
.blog-single.format-link .blog-content,
.blog-single.tag-sticky-2 .blog-content,
.blog-single.sticky .blog-content {
    background-color: var(--smoke-color);
    border: none;
    padding: 40px;
    border-radius: 15px;
}

.blog-single.format-quote .blog-content:before,
.blog-single.format-link .blog-content:before,
.blog-single.tag-sticky-2 .blog-content:before,
.blog-single.sticky .blog-content:before {
    display: none;
}

.blog-single.format-quote:before,
.blog-single.format-link:before,
.blog-single.tag-sticky-2:before,
.blog-single.sticky:before {
    content: "\\f0c1";
    position: absolute;
    font-family: "Font Awesome 6 Pro";
    font-size: 5rem;
    opacity: 0.3;
    right: 15px;
    line-height: 1;
    top: 15px;
    color: var(--theme-color);
    z-index: 1;
}

.blog-single.tag-sticky-2::before,
.blog-single.sticky::before {
    content: "\\f08d";
    position: absolute;
    font-family: var(--icon-font);
    font-size: 16px;
    font-weight: 500;
    opacity: 1;
    right: 0;
    top: 0;
    color: var(--white-color);
    background-color: var(--theme-color);
    z-index: 1;
    height: 44px;
    width: 44px;
    line-height: 44px;
    text-align: center;
    border-radius: 0 15px 0 4px;
}

.blog-single.format-quote blockquote,
.blog-single.format-quote .wp-block-quote {
    background: var(--white-color);
    margin-bottom: 0;
}

.blog-single.format-quote:before {
    content: "\\f10e";
    top: 0;
}

.blog-single .blog-content .wp-block-categories-dropdown.wp-block-categories,
.blog-single .blog-content .wp-block-archives-dropdown {
    display: block;
    margin-bottom: 30px;
}

.blog-single.format-chat .entry-content>p:nth-child(2n) {
    background: var(--smoke-color);
    padding: 5px 20px;
}

.blog-details .blog-single:before {
    display: none;
}

.blog-details .blog-single .blog-content {
    background-color: transparent;
    overflow: hidden;
}

.blog-details .blog-single .blog-content p:last-child {
    margin-bottom: 0;
}

.blog-details .blog-single.format-chat .blog-meta {
    margin-bottom: 20px;
}

.blog-details .blog-single.format-chat .blog-content>p:nth-child(2n) {
    background: var(--smoke-color);
    padding: 5px 20px;
}

.blog-details .blog-single.tag-sticky-2,
.blog-details .blog-single.sticky,
.blog-details .blog-single.format-quote,
.blog-details .blog-single.format-link {
    box-shadow: none;
    background-color: transparent;
}

.blog-details .blog-single.tag-sticky-2:before,
.blog-details .blog-single.sticky:before,
.blog-details .blog-single.format-quote:before,
.blog-details .blog-single.format-link:before {
    display: none;
}

.blog-single .wp-block-tag-cloud {
    margin-bottom: 20px;
}

.blog-single .wp-block-tag-cloud a {
    background-color: var(--smoke-color);
    color: var(--title-color);
    box-shadow: none;
}

.th-search {
    background-color: #f3f3f3;
    margin-bottom: 30px;
    border: 1px solid #f3f3f3;
}

.th-search .search-grid-content {
    padding: 30px;
    /* Small devices */
}

@media (max-width: 767px) {
    .th-search .search-grid-content {
        padding: 20px;
    }
}

.th-search .search-grid-title {
    font-size: 20px;
    margin-bottom: 5px;
    margin-top: 0;
}

.th-search .search-grid-title a {
    color: inherit;
}

.th-search .search-grid-title a:hover {
    color: var(--theme-color);
}

.th-search .search-grid-meta>* {
    display: inline-block;
    margin-right: 15px;
    font-size: 14px;
}

.th-search .search-grid-meta>*:last-child {
    margin-right: 0;
}

.th-search .search-grid-meta a,
.th-search .search-grid-meta span {
    color: var(--body-color);
}

/* Large devices */
@media (max-width: 1199px) {

    .blog-single.format-quote:before,
    .blog-single.format-link:before,
    .blog-single.tag-sticky-2:before,
    .blog-single.sticky:before {
        font-size: 14px;
        padding: 8px 16px;
    }

    .blog-single.format-quote:before {
        top: 15px;
    }
}

/* Small devices */
@media (max-width: 767px) {

    .blog-single.format-quote:before,
    .blog-single.format-link:before,
    .blog-single.tag-sticky-2:before,
    .blog-single.sticky:before {
        font-size: 14px;
        padding: 8px 16px;
    }
}

@media (max-width: 768px) {
    .wp-block-latest-comments {
        padding-left: 10px;
    }

    .page--content.clearfix+.th-comment-form {
        margin-top: 24px;
    }
}

.site {
    overflow-x: visible;
}

/* ======================= WordPress Default Css End =================== */
/* ================================= Typography Css Start =========================== */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: var(--body-font);
    color: var(--body-color);
    ;
    word-break: break-word;
    /* background-color: var(--body-bg); */
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

@media screen and (max-width: 767px) {
    body {
        font-size: 0.9375rem;
    }
}

@media screen and (max-width: 575px) {
    body {
        font-size: 0.875rem;
    }
}

p {
    font-size: inherit;
    font-weight: 400;
    margin: 0;
    line-height: 1.6;
    padding-left: 10px;
}

span {
    display: inline-block;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    margin: 0 0 16px 0;
    font-family: var(--heading-font);
    color: var(--heading-color);
    line-height: 1.2;
    font-weight: 700;
}

h1 {
    font-size: var(--heading-one);
}

h2 {
    font-size: var(--heading-two);
}

h3 {
    font-size: var(--heading-three);
}

h4 {
    font-size: var(--heading-four);
}

h5 {
    font-size: var(--heading-five);
}

h6 {
    font-size: var(--heading-six);
    font-weight: 800;
}

h1>a,
h2>a,
h3>a,
h4>a,
h5>a,
h6>a {
    font-weight: inherit;
    font-size: inherit;
    color: inherit;
    transition: 0.2s linear;
    line-height: inherit;
}

h1>a:hover,
h2>a:hover,
h3>a:hover,
h4>a:hover,
h5>a:hover,
h6>a:hover {
    color: var(--main);
}

a {
    display: inline-block;
    transition: 0.2s linear;
    text-decoration: none;
    /* color: #0661e9; */
    color: #000000;
    font-weight: 600;
}

a:hover {
    color: #1d72f2;
}

img {
    max-width: 100%;
    height: auto;
}

select {
    cursor: pointer;
}

ul,
ol {
    padding: 0;
    margin: 0;
    list-style: none;
}

button {
    border: 0;
    background-color: transparent;
}

button:focus {
    outline: none;
    box-shadow: none;
}

.form-select:focus {
    outline: 0;
    box-shadow: none;
}

/* ================================= Typography Css End =========================== */
/* ================================= Margin Css Start =========================== */
.mt--100 {
    margin-top: -100px !important;
}

.mt--24 {
    margin-top: -24px !important;
}

.mb-64 {
    margin-bottom: clamp(2rem, -0.434rem + 5.071vw, 4rem) !important;
}

.mt-64 {
    margin-top: clamp(2rem, -0.434rem + 5.071vw, 4rem) !important;
}

.mt-48 {
    margin-top: clamp(1.5rem, -0.326rem + 3.803vw, 3rem) !important;
}

.mb-48 {
    margin-bottom: clamp(1.5rem, -0.326rem + 3.803vw, 3rem) !important;
}

.mt-40 {
    margin-top: clamp(1.5rem, 0.283rem + 2.536vw, 2.5rem) !important;
}

.mb-40 {
    margin-bottom: clamp(1.5rem, 0.283rem + 2.536vw, 2.5rem) !important;
}

.mt-32 {
    margin-top: 32px !important;
}

@media screen and (max-width: 1199px) {
    .mt-32 {
        margin-top: 20px;
    }
}

.mb-32 {
    margin-bottom: 32px !important;
}

@media screen and (max-width: 1199px) {
    .mb-32 {
        margin-bottom: 20px;
    }
}

.mt-24 {
    margin-top: 24px !important;
}

@media screen and (max-width: 1199px) {
    .mt-24 {
        margin-top: 16px;
    }
}

.mb-24 {
    margin-bottom: 24px !important;
}

@media screen and (max-width: 1199px) {
    .mb-24 {
        margin-bottom: 16px;
    }
}

.margin-y-120 {
    margin-top: 60px;
    margin-bottom: 60px;
}

@media (min-width: 576px) {
    .margin-y-120 {
        margin-top: 80px;
        margin-bottom: 80px;
    }
}

@media (min-width: 992px) {
    .margin-y-120 {
        margin-top: 120px;
        margin-bottom: 120px;
    }
}

.margin-t-120 {
    margin-top: 60px;
}

@media (min-width: 576px) {
    .margin-t-120 {
        margin-top: 80px;
    }
}

@media (min-width: 992px) {
    .margin-t-120 {
        margin-top: 120px;
    }
}

.margin-b-120 {
    margin-bottom: 60px;
}

@media (min-width: 576px) {
    .margin-b-120 {
        margin-bottom: 80px;
    }
}

@media (min-width: 992px) {
    .margin-b-120 {
        margin-bottom: 120px;
    }
}

.margin-y-60 {
    margin-top: 30px;
    margin-bottom: 30px;
}

@media (min-width: 576px) {
    .margin-y-60 {
        margin-top: 40px;
        margin-bottom: 40px;
    }
}

@media (min-width: 992px) {
    .margin-y-60 {
        margin-top: 60px;
        margin-bottom: 60px;
    }
}

.margin-t-60 {
    margin-top: 30px;
}

@media (min-width: 576px) {
    .margin-t-60 {
        margin-top: 40px;
    }
}

@media (min-width: 992px) {
    .margin-t-60 {
        margin-top: 60px;
    }
}

.margin-b-60 {
    margin-bottom: 30px;
}

@media (min-width: 576px) {
    .margin-b-60 {
        margin-bottom: 40px;
    }
}

@media (min-width: 992px) {
    .margin-b-60 {
        margin-bottom: 60px;
    }
}

/* ================================= Margin Css End =========================== */
/* ================================= Padding Css Start =========================== */
.padding-y-120 {
    padding-top: 60px;
    padding-bottom: 60px;
}

@media (min-width: 576px) {
    .padding-y-120 {
        padding-top: 80px;
        padding-bottom: 80px;
    }
}

@media (min-width: 992px) {
    .padding-y-120 {
        padding-top: 120px;
        padding-bottom: 120px;
    }
}

.padding-t-120 {
    padding-top: 60px;
}

@media (min-width: 576px) {
    .padding-t-120 {
        padding-top: 80px;
    }
}

@media (min-width: 992px) {
    .padding-t-120 {
        padding-top: 120px;
    }
}

.padding-b-120 {
    padding-bottom: 60px;
}

@media (min-width: 576px) {
    .padding-b-120 {
        padding-bottom: 80px;
    }
}

@media (min-width: 992px) {
    .padding-b-120 {
        padding-bottom: 120px;
    }
}

.padding-y-60 {
    padding-top: 30px;
    padding-bottom: 30px;
}

@media (min-width: 576px) {
    .padding-y-60 {
        padding-top: 40px;
        padding-bottom: 40px;
    }
}

@media (min-width: 992px) {
    .padding-y-60 {
        padding-top: 60px;
        padding-bottom: 60px;
    }
}

.padding-t-60 {
    padding-top: 30px;
}

@media (min-width: 576px) {
    .padding-t-60 {
        padding-top: 40px;
    }
}

@media (min-width: 992px) {
    .padding-t-60 {
        padding-top: 60px;
    }
}

.padding-b-60 {
    padding-bottom: 30px;
}

@media (min-width: 576px) {
    .padding-b-60 {
        padding-bottom: 40px;
    }
}

@media (min-width: 992px) {
    .padding-b-60 {
        padding-bottom: 60px;
    }
}

/* ================================= Padding Css End =========================== */
/* =========================== Accordion Css start ============================= */
.accordiantion_radius {
    border-radius: 16px;
    background: #FFF;
}

.common-accordion .accordion-item {
    border: 1px solid var(--border-color);
    background-color: var(--white) !important;
    /* border-radius: 8px; */
    overflow: hidden;

}

.common-accordion .accordion-item:not(:last-child) {
    margin-bottom: 20px;
    border-bottom: 3px solid #D9D9D9;
}

.common-accordion .accordion-header {
    line-height: 1;
}

.common-accordion .accordion-body {
    padding: 20px 0px;
    padding-top: 0;
}

@media screen and (max-width: 575px) {
    .common-accordion .accordion-body {
        padding: 12px 0px;
        padding-top: 0;
    }
}

.common-accordion:first-of-type .accordion-button.collapsed {
    /* border-radius: 5px; */
    /* border-bottom: 3px solid #D9D9D9; */
}

.common-accordion:last-of-type .accordion-button.collapsed {
    /* border-radius: 5px; */
    /* border-bottom: 3px solid #D9D9D9; */
}

.common-accordion .accordion-button {
    color: var(--heading-color);
    font-size: 1.125rem;
    padding: 20px 0px;
    padding-right: 46px;
    font-weight: 600;
    font-size: clamp(1rem, 0.696rem + 0.634vw, 1.25rem);
    font-family: var(--heading-font);
}

@media screen and (max-width: 575px) {
    .common-accordion .accordion-button {
        padding: 12px 20px;
        padding-right: 36px;
    }
}

.common-accordion .accordion-button::after {
    background-image: none;
}

.common-accordion .accordion-button:focus {
    box-shadow: none;
}

.common-accordion .accordion-button:not(.collapsed) {
    background-color: transparent !important;
    box-shadow: none;
    color: var(--main);
}

.common-accordion .accordion-button:not(.collapsed)::after {
    background-image: none;
    color: var(--main);
}

.common-accordion .accordion-button[aria-expanded=true]::after,
.common-accordion .accordion-button[aria-expanded=false]::after {
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    content: "\\f106";
    color: var(--main);
    display: inline-block;
    position: absolute;
    right: 30px;
    height: unset;
    font-size: 1rem;
    text-align: center;
}

@media screen and (max-width: 575px) {

    .common-accordion .accordion-button[aria-expanded=true]::after,
    .common-accordion .accordion-button[aria-expanded=false]::after {
        right: 20px;
    }
}

.common-accordion .accordion-button[aria-expanded=false]::after {
    content: "\\f107";
    color: var(--heading-color);
}

/* ================================= Accordion Css End =========================== */
/* ================================= Button Css Start =========================== */
.btn-check:checked+.btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check)+.btn:active {
    color: none;
    background-color: none;
    border-color: none;
}

.btn {
    position: relative;
    border-radius: 8px;
    border: 1px solid transparent;
    font-weight: 400;
    font-family: var(--body-font);
    color: var(--static-white) !important;
    z-index: 1;
    font-size: 0.875rem;
    line-height: 1;
    text-transform: capitalize;
    padding: 14px 16px;
}

.btn:hover,
.btn:focus,
.btn:focus-visible {
    box-shadow: none !important;
}



@media screen and (max-width: 991px) {
    .btn {
        padding: 12px 16px;
    }
}

.btn-sm {
    padding: 11px 16px !important;
    font-size: 0.875rem;
}

@media screen and (max-width: 424px) {
    .btn-sm {
        padding: 10px !important;
        font-size: 12px;
    }
}

.btn-md {
    padding: 17px 16px;
}

@media screen and (max-width: 424px) {
    .btn-md {
        padding: 10px;
        font-size: 12px;
    }
}

.btn-lg {
    /* padding: 22px 40px; */
    font-size: 1rem;
}

@media screen and (max-width: 991px) {
    .btn-lg {
        padding: 17px 32px;
    }
}

.btn-lg-icon {
    /* height: 60px; */
    display: flex;
    justify-content: center;
    align-items: center;
}

@media screen and (max-width: 991px) {
    .btn-lg-icon {
        height: 50px;
    }
}

.btn-xl {
    padding: 20px 64px;
    font-size: 1rem;
}

@media screen and (max-width: 991px) {
    .btn-xl {
        padding: 15px 36px;
    }
}

.btn-icon {
    width: 30px;
    height: 30px;
    background-color: var(--white) !important;
    padding: 0;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.2s linear;
    font-size: 1.25rem;
    margin-right: 20px;
}

.btn-icon img {
    width: 60%;
}

@media screen and (max-width: 767px) {
    .btn-icon {
        width: 44px;
        height: 44px;

    }
}

.btn-icon--sm {
    width: 44px;
    height: 44px;
}

@media screen and (max-width: 767px) {
    .btn-icon--sm {
        width: 40px;
        height: 40px;
    }
}

.btn-icon:hover {
    transform: scale(1.04);
}

.btn .icon-right {
    margin-left: 8px;
    font-size: 1rem;
}

.btn .icon-left {
    margin-right: 8px;
    font-size: 1rem;
}

.btn:active {
    transform: scale(1.01);
}

.btn-main {
    background-color: var(--main-bg) !important;
    border: transparent !important;
    z-index: 1;
    border-radius: 30px !important;
}

.btn-main::before,
.btn-main::after {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    border-radius: inherit;
    background: var(--main-gradient);
    z-index: -1;
    transition: 0.2s linear;
}

.btn-main::after {
    background: var(--main-gradient-rev);
    visibility: hidden;
    opacity: 0;
}

.btn-main:hover::after {
    visibility: visible;
    opacity: 1;
}

.btn-outline-main {
    background-color: transparent !important;
    border-color: var(--main) !important;
    color: var(--main) !important;
}

.btn-outline-main:hover {
    background-color: var((--main)/0.15) !important;
    border-color: var((--main)/0.4) !important;
}

.btn-white {
    background-color: var(--white) !important;
    border-color: var(--white) !important;
    color: var(--black) !important;
}

.btn-white:hover {
    background-color: var(--main) !important;
    border-color: var(--main) !important;
    color: var(--static-white) !important;
}

.btn-light {
    background-color: var(--white-one) !important;
    border-color: var(--white-one) !important;
    color: var(--black) !important;
}

.btn-light:hover {
    background-color: var(--main) !important;
    border-color: var(--main) !important;
    color: var(--white) !important;
}

.btn-outline-light {
    background-color: transparent !important;
    border-color: var(--white-one) !important;
    color: var(--black) !important;
    font-weight: 500;
}

.btn-outline-light:hover {
    background-color: var(--black) !important;
    border-color: var(--black) !important;
    color: var(--white) !important;
}

.btn-black {
    background-color: var(--black) !important;
    border-color: var(--black) !important;
    border-width: 2px;
    color: var(--white) !important;
}

.btn-black:hover {
    background-color: transparent !important;
    border-color: var(--black) !important;
    color: var(--black) !important;
}

.btn-outline-black {
    background-color: transparent !important;
    border-color: var(--black) !important;
    border-width: 2px;
    color: var(--black) !important;
    font-weight: 600;
}

.btn-outline-black:hover {
    background-color: var(--black) !important;
    border-color: var(--black) !important;
    color: var(--white) !important;
}

.btn-static-black {
    background-color: var(--static-black) !important;
    border-color: var(--static-black) !important;
    border-width: 2px;
    color: var(--static-white) !important;
}

.btn-static-black:hover {
    background-color: transparent !important;
    border-color: var(--static-black) !important;
    color: var(--static-black) !important;
    font-weight: 600 !important;
}

.btn-static-outline-black {
    background-color: transparent !important;
    border-color: var(--static-black) !important;
    border-width: 2px;
    color: var(--static-black) !important;
    font-weight: 600;
}

.btn-static-outline-black:hover {
    background-color: var(--static-black) !important;
    border-color: var(--static-black) !important;
    color: var(--static-white) !important;
}

/* ================================= Button Css End =========================== */
/* ================================= Form Css Start =========================== */
/* input Start */
/* .common-input {
    border-radius: 5px;
    font-weight: 400;
    outline: none;
    width: 100%;
    padding: 17px 16px;
    background-color: transparent !important;
    border: 1px solid var(--border-color);
    color: var(--black);
    line-height: 1;
    font-size: 1.0625rem;
} */

.common-input {
    border-radius: 30px !important;
    /* More rounded corners for an almost circular edge */
    font-weight: 400;
    outline: none;
    width: 100%;
    padding: 17px 16px;
    /* Spacious padding */
    background-color: transparent !important;
    /* Transparent background */
    border: 1px solid var(--border-color);
    /* Subtle border */
    color: var(--black);
    /* Text color */
    line-height: 1;
    font-size: 1.0625rem;
    /* Font size as requested */
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    /* Smooth transition on focus */
}

.spl_burron {
    margin-right: 0;
    /* padding: 8px; */
    padding: 6px !important;
}

.spl_burron img {
    width: 100%;
}

.auto-suggestion-input {
    border-radius: 5px !important;
    font-weight: 400;
    outline: none;
    width: 100%;
    padding: 17px 16px;
    background-color: transparent !important;
    border: 1px solid var(--border-color);
    color: var(--black);
    line-height: 1;
    font-size: 1.0625rem;
}

/* When the input field is focused */
.common-input:focus {
    border-color: var(--main);
    /* Purple border on focus */
    box-shadow: 0 0 5px rgba(94, 53, 242, 0.2);
    /* Subtle shadow on focus */
    background-color: #fff;
    /* Optional: Give a light background on focus for better readability */
}


@media screen and (max-width: 991px) {
    .common-input {
        padding: 10px 16px;
    }
}

.common-input::placeholder {
    color: var(--black-three);
    font-size: 0.875rem;
    transition: 0.25s linear;
    font-weight: 400;
}

.common-input--md {
    padding: 13px 16px;
    font-size: 0.9375rem;
}

/* .common-input--lg {
    padding: 25px 24px;
} */

@media screen and (max-width: 767px) {
    .common-input--lg {
        padding: 18px 24px;
    }
}

.common-input:focus {
    border-color: var(--main);
    box-shadow: none;
}

.common-input:focus::placeholder {
    visibility: hidden;
    opacity: 0;
}

.common-input:disabled,
.common-input[readonly] {
    background-color: var((--black)/0.2);
    opacity: 1;
    border: 0;
}

.common-input[type=password] {
    color: var((--black)/0.5);
}

.common-input[type=password]:focus {
    color: var(--black);
}

.common-input--withIcon {
    padding-right: 50px !important;
}

.common-input--withLeftIcon {
    padding-left: 40px !important;
}

.common-input--bg {
    background-color: var(--gray-seven) !important;
    border-color: var(--gray-seven) !important;
}

.common-input--bg::placeholder {
    color: var(--black-three);
}

/* input End */
/* input icon */
.input-icon {
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--heading-color);
    font-size: 0.875rem;
}

.input-icon--left {
    left: 10px;
    right: auto;
}

textarea+.input-icon {
    top: 15px;
    transform: translateY(0);
}

/* input icon */
/* Label */
.form-label {
    margin-bottom: 6px;
    font-size: 0.875rem;
    color: var(--heading-color);
    font-weight: 500;
}

/* Form Select */
select option {
    background-color: var(--white);
}

.select-has-icon {
    position: relative;
}

.select-has-icon::before {
    position: absolute;
    content: "\\f107";
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    font-size: 0.75rem;
    color: var(--main);
    transition: 0.2s linear;
    pointer-events: none;
    color: var(--body-color) !important;
}

.select-has-icon.icon-black::before {
    -webkit-text-fill-color: var(--black);
}

.select-has-icon select {
    background-image: none;
    -webkit-appearance: none;
    padding: 19px 24px;
    font-size: 1rem;
}

@media screen and (max-width: 991px) {
    .select-has-icon select {
        padding: 12px 24px;
    }
}

.select-has-icon .common-input {
    padding-right: 30px !important;
}

.select {
    color: var((--black)/0.6) !important;
    padding: 16px 24px;
    background-color: transparent;
}

@media screen and (max-width: 991px) {
    .select {
        padding: 11px 24px;
    }
}

@media screen and (max-width: 767px) {
    .select {
        padding: 9px 24px;
        font-size: 0.9375rem;
    }
}

.select:focus {
    border-color: var(--main);
    color: var(--black) !important;
    outline: none;
}

.select option {
    background-color: var(--white);
    color: var(--heading-color);
}

/* Form Select End */
textarea.common-input {
    height: 140px;
}

@media screen and (max-width: 767px) {
    textarea.common-input {
        height: 110px;
    }
}

/* Autofill Css */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
textarea:-webkit-autofill:active {
    -webkit-transition: background-color 5000s ease-in-out 0s;
    transition: background-color 5000s ease-in-out 0s;
}

input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill,
textarea:-webkit-autofill,
textarea:-webkit-autofill,
textarea:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px transparent inset;
    -webkit-text-fill-color: var(--heading-color) !important;
    caret-color: var(--heading-color);
}

/* Autofill Css End */
/* Show Hide Password */
input#your-password,
input#confirm-password {
    padding-right: 50px;
}

.password-show-hide {
    position: absolute;
    right: 20px;
    z-index: 5;
    cursor: pointer;
    top: 50%;
    transform: translateY(-50%);
    color: var((--black)/0.4);
}

/* Number Arrow None */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

input[type=number] {
    -moz-appearance: textfield;
}

/* Custom Checkbox & Radio Css Start */
.common-check {
    margin-bottom: 16px;
}

.common-check:last-child {
    margin-bottom: 0;
}

.common-check a {
    display: inline;
}

.common-check.common-radio .form-check-input {
    border-radius: 50%;
}

.common-check.common-radio .form-check-input:checked {
    background-color: transparent !important;
}

.common-check.common-radio .form-check-input:checked::after {
    visibility: visible;
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
}

.common-check .form-check-input {
    transition: 0.2s linear;
    box-shadow: none;
    background-color: transparent;
    box-shadow: none !important;
    border: 0;
    position: relative;
    border-radius: 3px;
    width: 18px;
    height: 18px;
    border: 1px solid var(--black);
    cursor: pointer;
    transition: 0.2s linear;
    margin-top: 0;
}


.common-check .form-check-input::before {
    position: absolute;
    content: "\\f00c";
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    color: var(--static-white);
    font-size: 0.6875rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: 0.2s linear;
    visibility: hidden;
    opacity: 0;
}

.common-check .form-check-input::after {
    position: absolute;
    content: "";
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.2);
    width: 10px;
    height: 10px;
    background-color: var(--main);
    border-radius: 50%;
    transition: 0.2s linear;
    z-index: 1;
    visibility: hidden;
    opacity: 0;
}

.common-check .form-check-input:checked {
    background-color: var(--main) !important;
    border-color: var(--main) !important;
    box-shadow: none;
}


.common-check .form-check-input:checked[type=checkbox] {
    background-image: none;
}

.common-check .form-check-input:checked::before {
    visibility: visible;
    opacity: 1;
}

.common-check .form-check-label {
    font-weight: 500;
    width: calc(100% - 18px);
    padding-left: 12px;
    cursor: pointer;
    font-size: 0.875rem;
    color: var(--heading-color);
    font-family: var(--poppins-font);
}

@media screen and (max-width: 424px) {
    .common-check label {
        font-size: 0.9375rem;
    }
}

@media screen and (max-width: 424px) {
    .common-check a {
        font-size: 0.9375rem;
    }
}

/* Custom Checkbox & Radio Css End */
/* ================================= Form Css End =========================== */
/* ================================= Pagination Css Start =========================== */
.common-pagination {
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 64px;
    gap: 8px;
}

@media screen and (max-width: 1199px) {
    .common-pagination {
        margin-top: 48px;
    }
}

@media screen and (max-width: 991px) {
    .common-pagination {
        margin-top: 40px;
    }
}

@media screen and (max-width: 767px) {
    .common-pagination {
        margin-top: 32px;
    }
}

.common-pagination .page-item.active .page-link {
    color: var(--white);
    background-color: var(--black);
}

.common-pagination .page-item .page-link {
    border-radius: 8px;
    width: 42px;
    height: 43px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    font-weight: 600;
    padding: 0;
    color: var(--heading-color);
    border: 1px solid var((--black)/0.3);
    font-size: 1rem;
}

@media screen and (max-width: 991px) {
    .common-pagination .page-item .page-link {
        width: 48px;
        height: 48px;
    }
}

.common-pagination .page-item .page-link:hover,
.common-pagination .page-item .page-link:focus,
.common-pagination .page-item .page-link:focus-visible {
    color: var(--white);
    background-color: var(--black);
}

.common-pagination .page-item .page-link:focus {
    box-shadow: none;
}

.common-pagination .page-item:last-child .page-link {
    width: unset;
    height: unset;
    background-color: var(--section-bg);
    border-color: var(--section-bg);
    padding: 9px 16px;
}

.common-pagination .page-item:last-child .page-link:hover,
.common-pagination .page-item:last-child .page-link:focus,
.common-pagination .page-item:last-child .page-link:focus-visible {
    color: var(--white);
    background-color: var(--black);
}

/* ================================= Pagination Css End =========================== */
/* ================================= Tab Css Start =========================== */
.common-tab {
    margin-bottom: 20px;
    gap: 16px;
    /* Style Icon */
}

@media screen and (max-width: 991px) {
    .common-tab {
        gap: 8px;
    }
}

.common-tab .nav-item {
    border-bottom: 0;
}

.common-tab .nav-item .nav-link {
    color: var(--heading-color);
    padding: 7px 16px !important;
    background-color: transparent;
    transition: 0.2s linear;
    border-radius: 8px;
    border: 1px solid var(--gray-five);
    text-transform: capitalize;
    font-weight: 500;
    overflow: hidden;
    font-size: 0.875rem;
}

@media screen and (max-width: 991px) {
    .common-tab .nav-item .nav-link {
        padding: 5px 10px !important;
    }
}

.common-tab .nav-item .nav-link.active {
    color: var(--white) !important;
    background-color: var(--heading-color) !important;
    border-color: var(--heading-color) !important;
    font-weight: 300;
}

.common-tab .nav-item .nav-link:hover {
    color: var(--main);
    background-color: var(--white);
}

.common-tab.style-icon .nav-item .nav-link {
    padding: 0 !important;
    border: 0 !important;
    background-color: transparent !important;
    overflow: unset;
}

.common-tab.style-icon .nav-item .nav-link .product-category-list__item {
    box-shadow: 0px 5px 10px 0px rgba(204, 204, 204, 0.25);
}

.common-tab.style-icon .nav-item .nav-link .product-category-list__item .text {
    display: none;
}

.common-tab.style-icon .nav-item .nav-link.active .product-category-list__item {
    padding: 10px;
    height: unset;
    width: unset;
    border-radius: 50px !important;
    border: 1px solid var(--main);
    background-color: var(--white);
    box-shadow: 0px 5px 10px 0px rgba(204, 204, 204, 0.25);
    color: var(--heading-color);
    font-weight: 500;
}

.common-tab.style-icon .nav-item .nav-link.active .product-category-list__item .text {
    display: block;
}

/* Style Gradient */
.tab-gradient {
    display: flex;
    align-items: center;
    gap: 16px;
}

.tab-gradient .nav-item .nav-link {
    background-color: transparent !important;
    position: relative;
    z-index: 1;
    color: var(--heading-color);
    font-size: 1.125rem;
    text-transform: capitalize;
    font-weight: 400;
    padding: 14px 50px;
}

@media screen and (max-width: 1199px) {
    .tab-gradient .nav-item .nav-link {
        padding: 10px 30px;
        font-size: 1rem;
    }
}

.tab-gradient .nav-item .nav-link::before,
.tab-gradient .nav-item .nav-link::after {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    background: var(--white);
    left: 0;
    top: 0;
    border-radius: inherit;
    z-index: -1;
}

.tab-gradient .nav-item .nav-link::after {
    background: var(--main-gradient);
    visibility: hidden;
    opacity: 0;
}

.tab-gradient .nav-item .nav-link.active {
    color: var(--white);
    font-weight: 300;
}

.tab-gradient .nav-item .nav-link.active::before {
    visibility: hidden;
    opacity: 0;
}

.tab-gradient .nav-item .nav-link.active::after {
    visibility: visible;
    opacity: 1;
}

/* Bordered Tab */
.tab-bordered {
    gap: 32px;
    margin-bottom: 0px;
}

@media screen and (max-width: 1199px) {
    .tab-bordered {
        gap: 24px;
    }
}

@media screen and (max-width: 991px) {
    .tab-bordered {
        gap: 16px;
    }
}

@media screen and (max-width: 575px) {
    .tab-bordered {
        gap: 8px;
        margin-bottom: 24px;
    }
}

.tab-bordered .nav-link {
    background-color: transparent;
    border: 1px solid var(--gray-five);
    border-radius: 5px;
    color: var(--body-color);
    padding: 5px 8px;
}

@media (min-width: 575px) {
    .tab-bordered .nav-link {
        background-color: transparent;
        padding: 0;
        color: var(--body-color) !important;
        font-size: 14px;
        padding-bottom: 16px !important;
        border: 0;
        border-bottom: 2px solid transparent;
        border-radius: 0;
    }
}

.tab-bordered .nav-link.active {
    background-color: transparent;
    color: var(--heading-color) !important;
    font-weight: 600;
    border-color: var(--heading-color) !important;
}

.tab-bordered .nav-link.active .star-rating__text {
    color: var(--heading-color) !important;
    font-weight: 600;
}

/* ================================= Tab Css End =========================== */
/* ======================= Common Table Css Start ======================= */
.table {
    color: var(--white);
    margin-bottom: 0;
    min-width: max-content;
    border-collapse: separate;
    border-spacing: 0 24px;
    /* Style Two */
}

.table> :not(caption)>*>* {
    border-bottom: 0;
}

.table tr th {
    padding-left: 0;
    padding: 20px 16px;
    color: var(--heading-color);
    background-color: var(--section-bg);
}

.table tr th:not(:last-child) {
    border-radius: 0;
}

.table tr th:not(:first-child) {
    border-radius: 0;
}

.table tr th:first-child {
    border-radius: 8px 0 0 8px;
}

.table tr th:last-child {
    border-radius: 0 8px 8px 0;
}

.table tr th,
.table tr td {
    text-align: center;
    vertical-align: middle;
}

.table tr th:first-child,
.table tr td:first-child {
    text-align: left;
}

.table tr th:last-child,
.table tr td:last-child {
    text-align: right;
}

.table thead tr {
    border-bottom: 1px solid var((--white)/0.2);
}

.table thead tr th {
    font-size: clamp(1rem, 0.848rem + 0.317vw, 1.125rem);
    font-weight: 500;
}

.table tbody tr {
    border-bottom: 1px solid var((--white)/0.2);
}

.table tbody tr:last-child {
    border-bottom: 0;
}

.table tbody tr td {
    font-size: clamp(0.875rem, 0.723rem + 0.317vw, 1rem);
    font-weight: 400;
    padding: 16px;
    border: 1px solid var(--gray-five);
}

.table tbody tr td:not(:last-child) {
    border-right: 0;
}

.table tbody tr td:not(:first-child) {
    border-left: 0;
}

.table tbody tr td:first-child {
    border-radius: 8px 0 0 8px;
}

.table tbody tr td:last-child {
    border-radius: 0 8px 8px 0;
}

.table.style-two {
    color: var(--body-color);
    ;
    border-spacing: 0px;
    background-color: var(--white);
    border: 1px solid var(--gray-five);
    border-radius: 16px;
    overflow: hidden;
}

.table.style-two thead tr {
    border: 0;
}

.table.style-two thead tr th {
    border-bottom: 1px solid var(--gray-five);
    border-radius: 0;
    padding: 24px;
    font-weight: 700;
    font-family: var(--heading-font);
    background-color: var(--white);
}

.table.style-two tbody tr:last-child td {
    border-bottom: 0;
}

.table.style-two tbody tr td {
    border-radius: 0 !important;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-style: dashed;
}

/* ======================= Common Table Css End ======================= */
/* ================= Common Card Css Start ========================= */
.common-card {
    border: 0;
    box-shadow: var(--box-shadow);
    border-radius: 16px;
    background-color: var(--white);
}

.common-card .card-header,
.common-card .card-footer {
    padding: 12px 24px;
    background-color: transparent;
    border-bottom: 1px solid var(--border-color);
}

@media screen and (max-width: 424px) {

    .common-card .card-header,
    .common-card .card-footer {
        padding: 12px 16px;
    }
}

.common-card .card-header {
    background-color: var(--black);
}

.common-card .card-header .title {
    color: var(--static-white);
    margin-bottom: 0;
}

.common-card .card-body {
    padding: 24px;
}

@media screen and (max-width: 424px) {
    .common-card .card-body {
        padding: 16px;
    }
}

.common-card .card-footer {
    border-top: 1px solid var(--border-color);
    border-bottom: 0;
}

/* ================= Common Card Css End ========================= */
/* ================================= preload Css Start =========================== */
.loader-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--white);
    z-index: 99999;
}

.loader-mask .loader {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 80px;
    height: 80px;
    font-size: 0;
    display: inline-block;
    margin: -40px 0 0 -40px;
    text-indent: -9999em;
    transform: translateZ(0);
}

.loader-mask .loader div {
    background-color: var(--main);
    display: inline-block;
    float: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 80px;
    height: 80px;
    opacity: 0.6;
    border-radius: 50%;
    animation: ballPulseDouble 2s ease-in-out infinite;
}

.loader-mask .loader div:last-child {
    animation-delay: -1s;
}

@keyframes ballPulseDouble {

    0%,
    100% {
        transform: scale(0);
    }

    50% {
        transform: scale(1);
    }
}

/* ================================= preload Css End ===========================  */
/* ====================== Section Heading ==================== */
.section-heading {
    text-align: center;
    margin-bottom: clamp(2rem, 0.783rem + 2.536vw, 3rem);
    max-width: 630px;
    margin-left: auto;
    margin-right: auto;
}

.section-heading__title {
    position: relative;
    margin-bottom: 16px;
    /* text-transform: capitalize; */
    font-size: 250px;
    line-height: 230px;
    font-family: "Unbounded", sans-serif;
    font-style: normal;


}

.section-heading__desc {
    margin-top: clamp(1rem, -0.217rem + 2.536vw, 2rem);
    font-size: clamp(1rem, 0.848rem + 0.317vw, 1.125rem);
    max-width: 634px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 24px;
}

.section-heading__desc:last-child {
    margin-bottom: 0;
}

.section-heading__desc.w-sm {
    max-width: 465px;
}

.section-heading.style-left {
    text-align: left;
    margin-left: 0;
}

.section-heading.style-left .section-heading__desc {
    margin-left: 0;
}

.section-heading.style-white .section-heading__title {
    color: var(--static-white);
}

.section-heading.style-white .section-heading__desc {
    color: #bdbecc;
    font-weight: 300;
}

.section-heading.style-flex {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: unset;
    align-items: center;
}

.section-heading.style-flex .section-heading__inner {
    max-width: 410px;
}

.section-heading.style-flex .section-heading__inner.w-lg {
    max-width: 636px;
}

.section-heading.style-three .section-heading__subtitle {
    text-transform: capitalize;
    padding: 8px 16px;
    background-color: var(--white);
    color: var(--main);
    font-size: clamp(0.9375rem, 0.785rem + 0.317vw, 1.0625rem);
    border-radius: 50px;
    margin-bottom: 16px;
}

/* ====================== Section Heading En d==================== */
/* ============= Header Start Here ======================= */
.header {
   
    transition: 0.2s linear;
    font-family: "Happy Monkey", system-ui;
    font-weight: 400;
    font-style: normal;
}

@media screen and (max-width: 991px) {
    .header {
        padding: 10px 0;
    }
}

.header.fixed-header {
    position: sticky;
    left: 0;
    top: 0;
    right: 0;
    width: 100%;
    z-index: 9;
    /* backdrop-filter: blur(24px); */
    animation: slideDown 0.35s ease-out;
    background-color: var(--body-bg);
    box-shadow: 0 5px 16px rgba(0, 0, 0, 0.1);
}

@media screen and (max-width: 991px) {
    .header.fixed-header {
        top: -1px;
        background-color: var(--main-bg);
    }

}

@keyframes slideDown {
    from {
        transform: translateY(-100%);
    }

    to {
        transform: translateY(0);
    }
}

.logo img {
    max-width: 224px;
}

@media screen and (max-width: 767px) {
    .logo img {
        max-width: 160px;
    }
}

@media (max-width: 1199px) {
    .header-right__inner .btn .icon {
        display: none;
    }

    .language-select img {
        display: none;
    }

    .language-select .select {
        padding-left: 0 !important;
    }
}

.header-right {
    gap: 24px;
}

@media screen and (max-width: 1199px) {
    .header-right {
        gap: 16px;
    }
}

.header-right__button {
    position: relative;
    z-index: 1;
    cursor: pointer;
}

.header-right__button:hover::before {
    visibility: visible;
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
}

.header-right__button::before {
    position: absolute;
    content: "";
    width: 40px;
    height: 40px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(0.8);
    background-color: var(--gray-five);
    z-index: -1;
    border-radius: 50%;
    visibility: hidden;
    opacity: 0;
    transition: 0.2s linear;
}

/* Cart Btn */
.cart-btn {
    padding-right: 8px;
    padding-top: 5px;
}

.qty-badge {
    width: 20px;
    height: 20px;
    background: var(--main-gradient);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--static-white);
    position: absolute;
    top: 0;
    right: 0;
    pointer-events: none;
}

/* Cart Btn */
/* Language Select */
.language-select {
    border: 1px solid var(--border-color);
    border-radius: 50px;
    padding: 8px 16px;
}

.language-select::before {
    right: 16px;
}

.language-select select {
    color: var(--heading-color) !important;
    padding: 8px 16px;
}

/* Language Select */
.toggle-mobileMenu {
    line-height: 1;
    font-size: 36px;
    color: var(--heading-color);
}

.contact-number {
    padding-right: clamp(0.75rem, -0.771rem + 3.17vw, 2rem);
    margin-right: clamp(0.75rem, -0.771rem + 3.17vw, 2rem);
    border-right: 1px solid var(--border-color);
}

@media screen and (max-width: 575px) {
    .contact-number {
        font-size: 0.875rem;
    }
}

@media screen and (max-width: 424px) {
    .contact-number {
        display: none !important;
    }
}

.contact-number:hover .text {
    color: var(--main);
}

@media screen and (max-width: 575px) {
    .contact-number .icon {
        font-size: 15px !important;
    }
}

/* Header Menu and Submenu Css Start */
.nav-menu {
    gap: 2px;
}

@media (min-width: 992px) and (max-width: 1199px) {
    .nav-menu {
        gap: 0px;
    }

    .logo {
        display: none;
    }

    .shape_top {
        width: 80px !important;
    }

    .hero-inner__title {
        /* margin-bottom: 24px; */
        font-size: clamp(4rem, -2.0093rem + 4.85vw, 2.5rem) !important;
        line-height: 4rem !important;
    }

    .most_follwed {
        height: 250px !important;
    }

    .popular {
        padding-top: 20px !important;
    }

    .card-img {
        height: 160px !important;
    }
}

.nav-menu__item.activePage>a {
    color: var(--main);
}

.nav-menu__item.activePage>a::before {
    color: var(--main);
}

.nav-menu__item:hover>a {
    color: var(--heading-color);
}

@media (min-width: 992px) {
    .nav-menu__item:hover>a {
        color: var(--main);
    }
}

.nav-menu__link {
    color: var(--heading-color);
    font-weight: 500;
    font-size: 1rem;
    width: 100%;
    padding: 30px 20px;
    width: 100%;
    font-family: "Happy Monkey", system-ui;
    /* font-weight: 400;
    font-style: normal; */
}

@media screen and (max-width: 1199px) {
    .nav-menu__link {
        font-size: 0.875rem;
    }
}

.has-submenu {
    position: relative;
}

.has-submenu .nav-menu__link {
    padding-right: 16px;
}

.has-submenu.active>a,
.has-submenu.active>a::before {
    color: var(--main);
}

.has-submenu.active>a::before {
    transform: translateY(-50%) rotate(180deg) !important;
}

.has-submenu:hover .nav-submenu {
    visibility: visible;
    opacity: 1;
    margin-top: 0;
}

@media (min-width: 992px) {
    .has-submenu:hover>a::before {
        color: var(--main);
        transform: translateY(-50%) rotate(180deg);
    }
}

.has-submenu>a {
    position: relative;
}

.has-submenu>a::before {
    position: absolute;
    content: "\\f107";
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    font-size: 0.625rem;
    color: var((--heading-color)/0.4);
    transition: 0.2s linear;
}

/* Submenu Start */
.nav-submenu {
    position: absolute;
    left: 0;
    top: 100%;
    width: max-content;
    background-color: var(--white);
    border-radius: 6px;
    min-width: 190px;
    overflow: hidden;
    padding: 8px;
    box-shadow: var(--box-shadow);
    visibility: hidden;
    opacity: 0;
    margin-top: 16px;
    transition: 0.2s linear;
    z-index: 99;
}

@media (min-width: 992px) {
    .nav-submenu {
        max-height: 400px;
        overflow-y: auto;
    }
}

.nav-submenu::-webkit-scrollbar {
    width: 6px;
}

.nav-submenu::-webkit-scrollbar-track {
    background: #e4e4e4;
}

.nav-submenu::-webkit-scrollbar-thumb {
    background: #a2a2a2;
    border-radius: 50px;
}

.nav-submenu::-webkit-scrollbar-thumb:hover {
    background: #6d6d6d;
}

.nav-submenu__item {
    display: block;
    border-radius: 4px;
    transition: 0.2s linear;
    position: relative;
}

.nav-submenu__item.activePage .nav-submenu__link {
    color: var(--main);
}

.nav-submenu__item.activePage::before {
    visibility: visible;
    opacity: 1;
}

.nav-submenu__item.activePage a {
    margin-left: 10px;
}

.nav-submenu__item::before {
    position: absolute;
    content: "\\f101";
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    font-size: 0.625rem;
    color: var(--main);
    visibility: hidden;
    opacity: 0;
    transition: inherit;
}

.nav-submenu__item:hover {
    background-color: var(--gray-200);
}

.nav-submenu__item:hover::before {
    visibility: visible;
    opacity: 1;
}

.nav-submenu__item:hover a {
    margin-left: 10px;
    color: var(--heading-color);
}

.nav-submenu__link {
    color: var(--heading-color);
    font-weight: 500;
    font-size: 1rem;
    width: 100%;
    padding-right: 16px;
    width: 100%;
    display: block;
    padding: 8px 14px;
    border-radius: inherit;
}

.nav-submenu__link::before {
    position: absolute;
}

.nav-submenu__link:hover {
    color: var(--main) !important;
}

/* Submenu End */
/* Header Menu and Submenu Css End */
/* ================================= Header Css End =========================== */
/* ============ Search box ============= */
.search-box {
    position: relative;
    /* Style Two */
    /* style Three */
}

.search-box input {
    background-color: var(--white) !important;
    border: 0;
    padding-right: 70px;
}

@media screen and (max-width: 767px) {
    .search-box input {
        padding-right: 56px;
    }
}

.search-box input::placeholder {
    color: var(--black-three);
}

.search-box .icon {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--body-color);
}

@media screen and (max-width: 767px) {
    .search-box .icon {
        right: 5px;
    }
}

.search-box.style-two {
    max-width: 636px;
    margin: 0 auto;
}

.search-box.style-two input {
    padding-left: 170px;
}

@media screen and (max-width: 575px) {
    .search-box.style-two input {
        padding-left: 128px;
    }
}

.search-box.style-two .search-box__select {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
}

@media screen and (max-width: 575px) {
    .search-box.style-two .search-box__select {
        left: 0;
    }
}

.search-box.style-two .search-box__select.select-has-icon::before {
    right: 0;
}

.search-box.style-two .search-box__select.select-has-icon::after {
    position: absolute;
    content: "";
    width: 1px;
    height: 100%;
    right: -8px;
    top: 50%;
    transform: translateY(-50%);
    background: var(--border-color);
}

.search-box.style-two .search-box__select.select-has-icon select {
    padding-right: 19px;
    padding-left: 12px;
    color: var(--black-three);
}

@media screen and (max-width: 575px) {
    .search-box.style-two .search-box__select.select-has-icon select {
        font-size: 0.75rem;
    }
}

.search-box.style-two .search-box__select.select-has-icon select:focus {
    box-shadow: none;
}

.search-box.style-three {
    max-width: 274px;
}

.search-box.style-three .icon {
    width: 48px;
    height: 48px;
    right: 4px;
}

@media screen and (max-width: 991px) {
    .search-box.style-three .icon {
        width: 36px;
        height: 36px;
    }
}

.search-box.style-three input {
    background-color: var(--section-bg) !important;
    border: 1px solid var(--white-one);
}

.search-box .rounded-icon {
    width: 40px;
    height: 40px;
    border: 1px solid var(--white-one);
    border-radius: 50%;
    transition: 0.2s linear;
}

.search-box .rounded-icon:hover {
    background-color: var(--white-one) !important;
}

/* ================== Search Box =================== */
/* Mobile Menu Sidebar Start */
.mobile-menu {
    position: fixed;
    background-color: white;
    width: 300px;
    height: 100vh;
    overflow-y: auto;
    padding: 24px;
    z-index: 991;
    transform: translateX(-100%);
    transition: 0.2s linear;
    padding-bottom: 68px;
    z-index: 9999;
}

.mobile-menu::-webkit-scrollbar {
    width: 6px;
}

.mobile-menu::-webkit-scrollbar-track {
    background: #e0e0e0;
}

.mobile-menu::-webkit-scrollbar-thumb {
    background: #bab9b9;
    border-radius: 30px;
}

.mobile-menu::-webkit-scrollbar-thumb:hover {
    background: #949494;
}

.mobile-menu.active {
    transform: translateX(0%);
}

.close-button {
    position: absolute;
    right: 8px;
    top: 8px;
    width: 28px;
    height: 28px;
    background-color: var(--gray-200);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.2s;
}

.close-button:hover {
    background-color: var(--black);
    color: var(--white);
}

.nav-menu--mobile {
    display: block;
    margin-top: 32px;
}

.nav-menu--mobile .nav-menu__item>a::before {
    transform: translateY(-50%) rotate(0deg);
}

.nav-menu--mobile .nav-menu__link {
    border-bottom: 1px solid var((--black)/0.08) !important;
    position: relative;
    padding: 12px 0;
    padding-right: 16px;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
}

.nav-menu--mobile .nav-submenu {
    position: static;
    visibility: visible;
    opacity: 1;
    box-shadow: none;
    width: 100%;
    margin-top: 0;
    padding: 0;
    margin-left: 16px;
    display: none;
    transition: 0s;
}

.nav-menu--mobile .nav-submenu__link {
    width: 100%;
    padding: 10px 0;
    border-bottom: 1px solid var((--black)/0.08) !important;
    font-family: Poppins;
}

.nav-menu--mobile .nav-submenu__item:hover {
    background-color: transparent;
    color: var(--main);
}

.nav-menu--mobile .nav-submenu__item::before {
    display: none;
}

/* Mobile Menu Sidebar Start */
/* ============= Footer Start Here ======================= */
/* Text Slider Css Start */
.text-slider-section {
    padding: 40px 0;
    border-bottom: 1px solid var((--white-one)/0.2);
}

.text-slider .js-marquee {
    display: flex;
    align-items: center;
    gap: 20px;
}

.text-slider__item {
    font-size: clamp(1rem, -0.674rem + 3.487vw, 2.375rem);
    color: var(--black-three);
    text-transform: capitalize;
    transition: 0.2s linear;
}

.text-slider__item:hover {
    color: var(--static-white);
}

.footer-three {
    background-color: var(--black-two);
}

.footer-three .footer-inner {
    padding: 80px 0;
    background-color: #0b0e2a !important;
}

.footer-section {
    margin-top: auto;
    position: relative;
    z-index: 1;

    /* background-image: url(../images/shapes/footer-bg.png); */
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top;
    padding: 70px 0;
    /* padding-top: 220px; */
    /* color: white; */
    background-color: var(--main-bg);
}

@media screen and (max-width: 1199px) {
    .footer-section {
        padding: 70px 0;
        /* background-color: var(--black) !important; */
        /* background-image: none; */
    }
}

@media screen and (max-width: 991px) {
    .footer-section {
        padding: 80px 0;
    }
}

.footer-inner {
    padding: 80px 0;
}

.footer-widget__desc {
    color: var(--static-white-one);
    font-size: 1rem;
    font-weight: 300;
    line-height: 170%;
}

.footer-widget__logo {
    margin-bottom: 32px;
}

@media screen and (max-width: 991px) {
    .footer-widget__logo {
        margin-bottom: 24px;
    }
}

.footer-widget__logo a img {
    width: 100%;
    height: 100%;
    max-width: 240px;
    max-height: 64px;
}

.footer-widget__social {
    margin-top: 32px;
}

@media screen and (max-width: 991px) {
    .footer-widget__social {
        margin-top: 24px;
    }
}

.footer-widget__title {
    margin-bottom: 24px;
}

/* Footer List Item */
.footer-lists {
    display: flex;
    flex-direction: column;
}

.footer-lists__item {
    display: block;
    padding-bottom: 10px;
}

.footer-lists__item:last-child {
    padding-bottom: 0;
}

.footer-lists__link {
    position: relative;
    color: var(--static-white-one);
    padding-left: 22px;
}

.footer-lists__link::before {
    position: absolute;
    /* content: "\\f105"; */
    font-family: "Line Awesome Free";
    font-weight: 900;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0.875rem;
    transition: 0.2s linear;
    width: calc(100% + 1px);
    height: calc(100% + 1px);
}

.footer-lists__link:hover {
    color: var(--static-white);
}

.footer-lists__link:hover::before {
    left: 4px;
}

/* ============= Footer End Here ======================= */

/* ===================== Scroll to Top Start ================================= */
.progress-wrap {
    position: fixed;
    right: 36px;
    bottom: 36px;
    height: 46px;
    line-height: 46px;
    width: 46px;
    cursor: pointer;
    display: block;
    border-radius: 50px;
    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.2);
    z-index: 10000;
    opacity: 0;
    visibility: hidden;
    transform: translateY(15px);
    transition: all 200ms linear;
    background-color: var(--white);
}

@media screen and (max-width: 991px) {
    .progress-wrap {
        right: 24px;
        bottom: 24px;
        height: 40px;
        width: 40px;
        line-height: 40px;
    }
}

.progress-wrap.active-progress {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

.progress-wrap:hover {
    transform: scale(1.06);
}

.progress-wrap::after {
    position: absolute;
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    content: "\\f062";
    text-align: center;
    height: 46px;
    width: 46px;
    line-height: 46px;
    font-size: 18px;
    left: 0;
    top: 0;
    cursor: pointer;
    display: block;
    z-index: 1;
    transition: all 200ms linear;
    color: var(--main) !important;
}

@media screen and (max-width: 991px) {
    .progress-wrap::after {
        height: 40px;
        width: 40px;
        line-height: 40px;
    }
}

.progress-circle {
    top: -2px;
    position: relative;
}

.progress-wrap svg path {
    fill: none;
}

.progress-wrap svg.progress-circle path {
    stroke: var(--main);
    stroke-width: 5;
    box-sizing: border-box;
    transition: all 200ms linear;
}

/* ===================== Scroll to Top End ================================= */
/* ================================= Template Selection Css Start =========================== */
/* ================================= Template Selection Css End ===========================  */
/* ============================ Sale Offer Css Start =========================== */
.sale-offer {
    background: linear-gradient(117deg, #FEF0F8 14.35%, #DACFFF 84.4%);
    padding: 8px 0;
}

.sale-offer__content {
    gap: 16px;
}

@media screen and (max-width: 424px) {
    .sale-offer__content {
        gap: 8px;
    }
}

.sale-offer__text {
    font-size: clamp(0.6875rem, 0.459rem + 0.475vw, 0.875rem);
}

.sale-offer__qty {
    font-size: clamp(0.75rem, 0.294rem + 0.951vw, 1.125rem);
}

.sale-offer__button {
    width: 32px;
}

.sale-offer__close {
    position: absolute;
    right: 0;
    top: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    z-index: 1;
    transition: 0.2s linear;
    display: flex;
    justify-content: center;
    align-items: center;
}

@media screen and (max-width: 424px) {
    .sale-offer__close {
        width: 28px;
        height: 28px;
    }
}

.sale-offer__close:hover {
    color: var(--main);
}

.sale-offer__close:hover::before {
    visibility: visible;
    opacity: 1;
    transform: scale(1);
}

.sale-offer__close::before {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: var((--main)/0.2);
    z-index: -1;
    border-radius: inherit;
    transition: 0.2s linear;
    visibility: hidden;
    opacity: 0;
    transform: scale(0.8);
}

.countdown {
    display: flex;
    align-items: center;
    gap: 16px;
}

@media screen and (max-width: 424px) {
    .countdown {
        gap: 10px;
    }
}

.countdown>div {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-direction: row-reverse;
}

.countdown span {
    font-weight: 500;
    color: var(--heading-color);
    font-size: 14px;
}

/* ============================ Sale Offer Css End =========================== */
/* ================================= Social Icon Css Start =========================== */
.social-icon-list {
    display: inline-flex;
    gap: 12px;
    align-items: center;
}

.social-icon-list__link {
    width: 70px;
    height: 70px;
    border: 1px solid var(--static-white-one);
    background: #000;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--main-bg);
    position: relative;
    font-size: 0.875rem;
    z-index: 1;
    font-size: 30px;
}

.social-icon-list__link::after {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    border-radius: inherit;
    background: var(--main-gradient);
    transition: 0.2s linear;
    z-index: -1;
    visibility: hidden;
    opacity: 0;
}

.social-icon-list__link:hover {
    color: var(--static-white) !important;
    border-color: transparent;
}

.social-icon-list__link:hover::after {
    visibility: visible;
    opacity: 1;
}

/* ================================= Social Icon Css End ===========================  */
/* ================= Slick Arrow & Dots css Start ================ */
.slick-initialized.slick-slider .slick-track {
    display: flex;
}

.slick-initialized.slick-slider .slick-slide {
    cursor: grab;
    height: auto;
    margin: 0 10px;
}

.slick-initialized.slick-slider .slick-slide>div {
    height: 100%;
}

/* Arrow Small size */
.arrow-sm .slick-arrow {
    width: 32px;
    height: 32px;
    border: 1px solid var(--white-one);
    box-shadow: 0px 20px 30px rgba(197, 196, 201, 0.25);
    font-size: 1.125rem;
}

.arrow-sm .slick-arrow:hover {
    border-color: var(--main);
}

/* Slick Slider Arrow */
.slick-arrow {
    position: absolute;
    z-index: 1;
    border: none;
    background-color: transparent;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    transition: 0.2s linear;
    bottom: clamp(1.5rem, -1.239rem + 5.705vw, 3.75rem);
    left: clamp(1.5rem, -1.239rem + 5.705vw, 3.75rem);
    top: 50%;
    transform: translateY(-50%);
    margin-top: 0;
    background-color: var(--white);
    color: var(--heading-color);
    box-shadow: 0px 20px 30px 0px rgba(197, 196, 201, 0.25);
    font-size: 1.5rem;
    left: -24px;
}

@media screen and (max-width: 575px) {
    .slick-arrow {
        left: -10px;
    }
}

.slick-arrow:hover {
    background-color: var(--main);
    color: var(--white);
}

.slick-next {
    right: -24px;
    left: auto;
}

@media screen and (max-width: 575px) {
    .slick-next {
        right: -10px;
    }
}

/* Dots Css Start */
.slick-dots {
    text-align: center;
    margin-top: clamp(1.5rem, -1.239rem + 5.705vw, 3.75rem);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
}

@media screen and (max-width: 1199px) {
    .slick-dots {
        gap: 8px;
    }
}

.slick-dots li {
    display: inline-block;
}

.slick-dots li button {
    border: none;
    background-color: transparent;
    color: var(--white);
    width: 16px;
    height: 16px;
    border-radius: 50%;
    text-indent: -9999px;
    transition: 0.3s linear;
    border: 1px solid var(--black);
}

.slick-dots li.slick-active button {
    background-color: var(--black);
}

/* Dots Css End */
/* ================= Slick Arrow & Dots css Start ================ */


.search-box {
    position: relative;
}

.search-box .btn {
    position: absolute;
    right: 8px;
    top: 50%;
    width: 30px;
    height: 30px;
    transform: translateY(-50%);
}

.search-box .common-input {
    background-color: #E3E3E3 !important;
    border-color: #E3E3E3;
    padding-right: 200px;
}

@media screen and (max-width: 575px) {
    .search-box .common-input {
        padding-right: 60px;
    }
}


.shape_top {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 250px;
    z-index: 999;
}

.shape_top_2 {
    position: absolute;
    top: 350px;
    left: 0px;
    width: 150px;
    z-index: -1;
}

.shape_top_3 {
    position: absolute;
    top: 450px;
    /* left: 10px; */
    width: 150px;
    z-index: 999;
    right: -50px;
}

.shape_top_4 {
    position: absolute;
    top: 0px;
    /* left: 10px; */
    width: 150px;
    left: 0px;
    z-index: 999;
}

.shape_top_5 {
    position: absolute;
    top: 0px;
    /* left: 10px; */
    width: 150px;
    right: -50px;
    z-index: 999;
    height: 170px;
}

.shape_top_6 {
    position: absolute;
    top: 80px;
    right: 40px;
    z-index: 999;
    /* height: 170px; */
}

.shape_top_7 {
    position: absolute;
    top: 400%;
    left: 0px;
    height: 170px;
    z-index: 999;
}

.shape_top_8 {
    position: absolute;
    top: 420%;
    right: 0px;
    /* width: 250px; */
    height: 170px;
    z-index: 999;
}

.shape_top_9 {
    position: absolute;
    top: 250%;
    height: 170px;
    left: 0px;
    /* width: 250px; */
    z-index: 999;
}

.shape_top_10 {
    position: absolute;
    top: -200px;
    height: 170px;
    right: 0px;
    /* width: 250px; */
    z-index: 999;
}


.map-box iframe {
    border-radius: 10px;
}

.left_1,
.right_1 {
    top: 86% !important;
    width: 36px;
    height: 36px;

    border: 2px solid black;
}

/* Hover effect for the .left_1 and .right_1 buttons */
.left_1:hover,
.right_1:hover {
    background: var(--main-bg);
    /* Change background to white on hover */
    color: white;
    /* Change text color to match the main background color */
    border: 2px solid var(--main-bg);
    /* Keep the border color the same */
}


.learn-new {
    padding: 80px 0;
    /* background-color: #f9f9f9; */
}

.section-title {
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 20px;
}

.course-card {
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
    padding: 10px;
    display: flex;
    align-items: center;
    border-radius: 15px;
}



.card-img {
    width: 40%;
    height: 120px;
    border-radius: 10px;
    object-fit: cover;
}

.card-content {
    flex-grow: 1;
}

.course-title {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 5px;
}

.author-name,
.course-duration {
    font-size: 0.9rem;
    color: #777;
    margin: 0;
}

.hero-inner__title {
    margin-bottom: 24px;
    font-size: clamp(6rem, -2.0093rem + 7.85vw, 4.5rem);
    line-height: 6rem;
    /* text-transform: capitalize; */

    font-family: "Unbounded", sans-serif;
    font-style: normal;
}



.hero-inner__title_2 {
    font-size: 50px;
    color: #FF7A00;
    /* -webkit-text-fill-color: white;  */
    /* -webkit-text-stroke: 1px white; */
    margin-top: -70px;
    width: 60%;
}

@media screen and (max-width: 991px) {
    .hero-inner__title {
        font-size: clamp(3rem, -2.0093rem + 7.85vw, 4.5rem);
        line-height: 3rem;
        margin-bottom: 16px;
    }

    .hero-inner__title_2 {
        margin-top: -60px;
    }

    .hero-inner__title_2 img {
        width: 300px;
        max-width: 300px;
        height: auto;

    }

    .header {
        background: var(--main-bg);
    }

    .section-heading__title {
        font-size: 60px;
        line-height: 60px;


    }

    .selling-product-slider {
        width: 80%;
    }

}

.product-item {
    position: relative;
    margin-top: 150px;
}

.product-item_main {
    position: absolute;
    z-index: 0;
}

.product-item_main_img {
    position: relative;
    width: 90%;
    height: 90%;
    margin-top: 20px;
    margin-left: 20px;
}

.product-item_main_link {
    position: relative;
    z-index: 2;
    text-align: center;
    display: block;
    font-size: 26px;
    margin-top: 10px;
    color: black;
    margin-top: 30px;
}

.most_follwed {
    background: #FF7A00;
    width: 95%;
    height: 350px;
    margin: 0 auto;
    position: absolute;
    top: 40px;
    z-index: 0;
    border-radius: 10px;
}

.most_follwed_img {
    position: relative;
    top: 20px;
    margin-left: -30px;
}

.most_follwed_name {
    position: relative;
    z-index: 2;
    text-align: center;
    display: block;
    font-size: 18px;
    margin-top: 30px;
    color: black;
}

.section-heading__1 {
    font-size: 60px;
}


/* ========================== Account Page Css Start ============================= */
.dark-light-mode {
    position: absolute;
    right: 24px;
    top: 24px;
}

.account {
    position: relative;
}

.account__img {
    position: absolute;
    right: 0;
    bottom: 0;
}

/* @media screen and (max-width: 991px) {
    .account__img {
        display: none;
    }
} */

/* .account__left {
    width: 43%;
    padding: 32px;
    position: relative;
}

@media screen and (max-width: 991px) {
    .account__left {
        width: 60%;
    }
}

.account__left::before {
    position: absolute;
    content: "";
    width: 675px;
    height: 552px;
    background: linear-gradient(152deg, rgba(246, 246, 246, 0.3) 17.12%, rgba(94, 53, 242, 0.3) 105.91%);
    filter: blur(100px);
    left: -290px;
    top: 50%;
    transform: translateY(-50%);
    z-index: -1;
} */

/* Image section, taking 55% of the screen width */
/* Main styles for larger screens */
.account__left {
    width: 50%;
    padding: 32px;
    position: relative;
    height: 100vh;
    /* Ensures the image section fills the full height */
    overflow: hidden;
}

.account__right {
    width: 50%;
    height: 100vh;
    padding: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
}



.account__left::before {
    position: absolute;
    content: "";
    width: 675px;
    height: 552px;
    background: linear-gradient(152deg, rgba(246, 246, 246, 0.3) 17.12%, rgba(94, 53, 242, 0.3) 105.91%);
    filter: blur(100px);
    left: -290px;
    top: 50%;
    transform: translateY(-50%);
    z-index: -1;
}

.account__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* Make sure the image fills its container */
}

.account__right_box {
    min-height: 500px;
}

/* Right side form section */
.account__right {
    width: 50%;
    /* Form section takes 45% of the screen width */
    display: flex;
    justify-content: center;
    align-items: center;
    background: #F4F4F4;
    height: 100vh;
    /* Ensure the form section fills the screen height */
}

.account-content {
    width: 100%;
    max-width: 400px;
    /* Restrict the form width */
}

/* Heading for login form */
.login-heading {
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    /* color: black; */
}

/* Form field styling */
.common-input {
    width: 100%;
    padding: 12px 16px;
    border-radius: 8px;
    /* Rounded corners */
    border: 1px solid #d1d1d1;
    background-color: #f6f6f6;
    outline: none;
}

.common-input:focus {
    border-color: var(--main);
    /* Purple focus border */
    box-shadow: 0 0 5px rgba(94, 53, 242, 0.2);
}

/* Styling for the submit button */
.btn-main {
    background-color: var(--main);
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 12px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    font-family: "Happy Monkey", system-ui;
}

.btn-main:hover {
    background-color: #4b29b0;
}

.btn-outline-light {
    background-color: #fff;
    color: #5e35f2;
    border: 1px solid #5e35f2;
    border-radius: 8px;
    padding: 12px;
}

.btn-outline-light:hover {
    background-color: #f0f0f0;
}

/* Forgot password link */
.forgot-password {
    font-size: 14px;
    color: var(--main-bg) !important;
}


.account__right {
    flex-grow: 1;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 300px;
    position: relative;
}

@media screen and (max-width: 991px) {
    .account__right {
        padding-bottom: 80px;
    }
}

@media screen and (max-width: 575px) {
    .account__right {
        padding-bottom: 60px;
    }
}

@media screen and (max-width: 575px) {
    .account__right {
        padding-left: 24px;
        padding-right: 24px;
    }
}

.account-thumb {
    max-width: 572px;
    margin-left: auto;
    margin-right: auto;
}

.account-content {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
}

.sign_btn {
    /* border-radius: 43px; */

    background: linear-gradient(94deg, #FFA553 0%, #FF7A00 100%);
    box-shadow: 0px 5px 10px 0px rgba(144, 144, 144, 0.25);
}

.cicrle_btn {
    /* width: 53px;
    height: 53px; */
    background: var(--main-bg);
}

.btN_login {
    background: linear-gradient(90deg, #FFA24C 0%, #FF7D06 100%);

}

.Unbounded {
    font-family: "Unbounded", sans-serif;
}

.intractive {
    width: 659px;
}

.this_flex p {
    margin-top: 10px;
    margin-right: 25px;
}

.spcl_clss {
    margin-top: -250px;
}

.spcl_clss .col-lg-6:nth-child(2) {
    margin-top: -120px;
}

.spcl_clss a {
    color: black;
    border-radius: 54px;
    background: linear-gradient(94deg, #FF7A00 3.89%, #D74000 96.79%);
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
}

.header-menu {
    margin-left: 20%;
}

.nav-menu__item.activePage>a {
    color: var(--main-bg);
    /* color: #FF7A00; */
}




/* ========================== Course============================= */
.spl_cards {
    background-color: #fff;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
    padding: 20px;
    display: flex;
    border-radius: 16px;
    background: #FFF;
    border: none;
}

.feed_card {
    background-color: #fff;
    border-radius: 16px;
    /* box-shadow: 0 0 15px rgba(0, 0, 0, 0.1); */
    padding: 20px 30px;
    background: #FFF;
    border: none;
}


.spl_cards .course-title {
    color: #030408;
    font-family: Poppins;
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    line-height: 37px;
    /* 102.778% */
}

.spl_cards .course-description {
    color: var(--button-secondary);
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 19px;
    /* 135.714% */
}

.spl_cards .Stars {
    color: var(--main-bg);
    /* font-size: 30px; */
}

.spl_cards .course-author {
    color: #000;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;

}

.spl_cards .course-time {
    color: var(--main-bg);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 19px;


}

.btn_cousre {
    color: #040404;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 19px;
    border-radius: 4px;
    background: linear-gradient(278deg, #FF7B01 1.43%, #FFA350 91.63%);
}

.cours_deataisl {
    color: var(--button-secondary);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;

}

.course-titles {
    color: #030408;
    font-family: Poppins;
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
}



.spl_buttonss {
    margin-right: 10px;
    border-radius: 8px !important;
    border: 2px solid var(--button-secondary) !important;
    margin-top: 10px;
}

.card_add {
    border-radius: 16px;
    background: #FFF;
    border: none;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;

}

.other_course-title {
    color: #030408;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
}

.card_add {
    color: var(--button-secondary);
    font-family: Poppins;
}

.card_add .class_span span {
    margin-right: 20px;
}


.btn_cousre {
    border-radius: 30px;
    padding: 15px 20px;
    border-radius: 8px;
    color: #030408 !important;
    font-family: Poppins;
    font-size: 16px;
    /* width: 80%; */
    background: linear-gradient(93deg, #FFA34F 0.91%, #FF7A00 100%);
}

.course-checkout {
    color: #030408;
    font-family: Poppins;
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
}


.card_add .cousrse_p {

    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 19px;
    /* 118.75% */
}

.check_class {
    border-bottom: 3px solid #D9D9D9;
}

.check_class_1 {
    height: 4px;
    width: 100%;
    border-radius: 8px;
    background: #D9D9D9;
    margin-top: 20px;
}

.check_class p {
    margin-bottom: 10px;
}

.feed_img {
    width: 56px;
    height: 56px;
}

.feed_img img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
}



.feed_imgs {
    /* width: 314px; */
    height: 314px;
}

.feed_imgs img {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    object-fit: cover;
}

.feed_details_img {
    width: 740px;
    height: 738px;
    margin: 80px auto;
}

.feed_details_img img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
}

.upload_modal .modal-content {
    border-radius: 16px;
    background: #F9F5F2;
}

.upload_modal .form-control {
    /* border-radius: 16px; */
    background: #F9F5F2;
    border: transparent;
}

.upload_modal .modal-header {
    border-bottom: transparent;
}

.upload_modal .modal-footer {
    border-top: transparent;
}


.upload_popup .modal-body textarea {
    min-height: 250px;
}

.btn_cls {
    background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / 1em auto no-repeat;

}

.uplaod_close {
    background-color: var(--main-bg);
    color: var(--white) !important;
    opacity: 1;
    border-radius: 50%;
    margin-right: 10px !important;

}

.upload_media_titlle {
    color: #000;
    font-size: 33px;

}

.upload_popup_medai .modal-body {
    min-height: 400px;
}

/* Style for the first image */
.upload_popup_medai2 .modal-body .uplad_img:first-of-type {
    width: 462px;
    height: 456px;
    margin: 20px;
}

.upload_popup_medai2 .modal-body .uplad_img:first-of-type img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
}

.upload_popup_medai2 .modal-body .uplad_img:first-of-type span {
    display: none;
}


/* Style for all other images */
.upload_popup_medai2 .modal-body .uplad_img:not(:first-of-type) {
    width: 187px;
    height: 247px;
    border-radius: 8px;
    margin: 20px;

}

.upload_popup_medai2 .modal-body .uplad_img:nth-of-type(2) {
    padding: 5px;
    border: 2px solid #FFA553;
}

/* Style for all other images */
.upload_popup_medai2 .modal-body .uplad_img:not(:first-of-type) img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
}

.upload_popup_medai3 .modal-body .uplad_img {
    width: 286px;
    height: 259px;
    margin: 20px;
}

.upload_popup_medai3 .modal-body .uplad_img img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
}




@media (min-width: 992px) {

    .modal-lg,
    .modal-xl {
        --bs-modal-width: 994px;
    }
}

.learn_withcard {
    background-color: #fff;
    border-radius: 16px;
    /* box-shadow: 0 0 15px rgba(0, 0, 0, 0.1); */
    padding: 20px 30px;
    background: #FFF;
    border: none;
}

.learn_withcard .img {
    width: 186px;
    height: 186px;
}

.learn_withcard .img img {
    border-radius: 50%;
}

.learm-tilte {
    color: #000;
    font-size: 24px;
    font-weight: 600;
}

.learm-tilte2 {
    color: #FF7A00;
    font-size: 16px;
    font-weight: 600;
}

.course_video .imgss {
    width: 267px;
    height: 153px
}

.course_video .imgss img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
}

.course_video_text {
    color: #030408;
    font-size: 20px;
    font-weight: 500;
}

.course_video_time {
    font-size: 16px;
    font-weight: 500;
    color: #030408;
}

.comment_box_input {
    border-radius: 0 !important;
    box-shadow: none !important;
    border-bottom: 1px solid black !important;
}

.comment_box .row {
    margin-bottom: 20px;
}

.comment_box .sp_row {
    width: 50%;
}


.replay {
    margin-top: 30px;
    color: #000;
    font-size: 14px;
    font-weight: 500;
}

.comment_box .feed_img {
    width: 42px;
    height: 42px;
}

.share_button {
    /* height: 44px; */
    border-radius: 28px !important;
    color: white !important;
    padding: 9px 25px !important;
    background: linear-gradient(278deg, #FF7B01 1.43%, #FFA350 91.63%) !important;
}

.upnext {
    color: #FF7A00 !important;
    font-size: 22px !important;
}

/* ======================== All Product Section Css Start ====================== */
/* Filter Tab Css Start */
.filter-tab {
    margin-bottom: 32px;
}

@media screen and (max-width: 1199px) {
    .filter-tab {
        gap: 24px;
    }
}

@media screen and (max-width: 1199px) {
    .filter-tab {
        gap: 16px;
    }
}

.filter-tab__right {
    gap: 24px;
}

@media screen and (max-width: 1199px) {
    .filter-tab__right {
        gap: 16px;
    }
}

@media screen and (max-width: 991px) {
    .filter-tab__button:hover {
        background-color: transparent !important;
        border-color: var(--white-one) !important;
        color: var(--black) !important;
    }
}

.filter-tab__button.active {
    background-color: var(--white-one) !important;
    border-color: var(--white-one) !important;
    color: var(--black) !important;
}

.filter-form {
    display: none;
}

/* Filter Tab Css End */
/* List & Grid Buttons Start */
@media screen and (max-width: 991px) {
    .list-grid {
        order: -1;
    }
}

.list-grid__button {
    width: 36px;
    height: 36px;
    border: 1px solid var(--gray-five);
    border-radius: 8px;
    font-size: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.2s linear;
}

.list-grid__button.active {
    border-color: var(--black) !important;
    background: var(--black) !important;
    color: var(--white) !important;
}

/* List & Grid Buttons End */
/* List & Grid Card Css Start */
.list-view .list-grid-wrapper>div {
    width: 100%;
}

.list-view .list-grid-wrapper .product-item {
    display: flex;
}

.list-view .list-grid-wrapper .product-item__content {
    flex-grow: 1;
}

/* List & Grid Card Css End */
/* Filter Sidebar Css Start */
.filter-sidebar {
    background: var(--white);
    padding: 32px 16px;
    border-radius: 8px;
    position: relative;
}

.common-check .form-check-input:checked::before {
    visibility: hidden;
}

/* @media screen and (max-width: 991px) {
    .filter-sidebar {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        border-radius: 0;
        width: 300px;
        transform: translateX(-100%);
        transition: 0.2s linear;
        height: 100vh;
        overflow-y: auto;
        padding-top: 48px;
    }
} */

.filter-sidebar.show {
    transform: translateX(0);
}

.filter-sidebar__item:last-child .filter-sidebar__content {
    margin-bottom: 0;
}

.filter-sidebar__content {
    margin-bottom: 44px;
}

@media screen and (max-width: 1199px) {
    .filter-sidebar__content {
        margin-bottom: 32px;
    }
}

@media screen and (max-width: 991px) {
    .filter-sidebar__content {
        margin-bottom: 24px;
    }
}

.filter-sidebar__button {
    margin-bottom: 16px;
    padding-bottom: 16px;
    width: 100%;
    text-align: left;
    position: relative;
    color: var(--heading-color);
}

.filter-sidebar__button.active::after {
    transform: rotate(180deg);
}

.filter-sidebar__button::before {
    position: absolute;
    content: "";
    width: calc(100% + 32px);
    height: 1px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background: var(--gray-five);
}

.filter-sidebar__button::after {
    position: absolute;
    content: "\\f107";
    font-weight: 900;
    font-family: "Line Awesome Free";
    right: 0;
    top: 0px;
    transition: 0.2s linear;
}

.filter-sidebar-list__item {
    margin-bottom: 16px;
}

.filter-sidebar-list__item:last-child {
    margin-bottom: 0;
}

.filter-sidebar-list__text {
    font-size: 0.875rem;
    color: var(--black-three);
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: 0.2s linear;
}

.filter-sidebar-list__text:hover {
    color: var(--main);
}

.filter-sidebar-list__text:hover .form-check-label {
    color: var(--main);
}

.filter-sidebar-list__text .common-check {
    margin-bottom: 0;
}

.filter-sidebar-list__text .form-check-label {
    transition: 0.2s linear;
}

.learn_withcard .Stars img {
    width: 20px;
    height: auto;
}


/* Optional custom style to adjust button appearance for pill display */
.filter-sidebar__pills {
    white-space: nowrap;
    /* padding-bottom: 8px; */
}

.filter-sidebar__pills::-webkit-scrollbar {
    display: none;
    /* Hide scrollbar on webkit browsers */
}

.btn-outline-primary_1 {
    padding: 7px 0;
    padding-left: 10px;
    padding-right: 25px;
    border-radius: 8px !important;
    background: #E3E3E3;
    width: auto;
    height: 40px;
}

.btn-outline-primary_1::after {
    top: 8px;
    right: 5px;
}

.spaldrop_down {
    position: absolute;
    width: 90%;
    margin: 0 5%;
    padding: 20px;
    border-radius: 8px;
    background: #D9D9D9;
    z-index: 9;
}

/* Filter Sidebar Css End */
/* ======================== All Product Section Css End ====================== */
/* ======================== Dashboard start ====================== */

.dashboard_right {
    border-right: 3px solid #E3E3E3;
    /* transition: 0.2s linear;
    width: 312px;
    height: 100vh;
    overflow-y: auto;
    position: sticky;
    z-index: 999;
    top: 0; */

}

.sidebar-list {
    padding-right: 20px;
}

.padding_100 {
    padding-top: 70px;
}


.sidebar-list__item {
    margin-bottom: 15px;
}

.sidebar-list__link {
    width: 100%;
    color: var(--body-color);
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 16px;
    transition: 0s;
    background-color: var(--white);
    border: 1px solid transparent;
}

.sidebar-list__icon {
    width: 24px;
    height: auto;
    position: relative;
}

.sidebar-list__item.activePage .sidebar-list__link,
.sidebar-list__item:hover .sidebar-list__link {
    color: var(--heading-color);
    /* background-color: black;
     */
    color: #000;
    border: 1px solid var(--main);
}

.sidebar-list__item.activePage .sidebar-list__icon .icon,
.sidebar-list__item:hover .sidebar-list__icon .icon {
    visibility: hidden;
    opacity: 0;
}

.sidebar-list__item.activePage .sidebar-list__icon .icon-active,
.sidebar-list__item:hover .sidebar-list__icon .icon-active {
    visibility: visible;
    opacity: 1;
}

.sidebar-list__icon {
    width: 24px;
    height: auto;
    position: relative;
}

.sidebar-list__icon .icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.sidebar-list__icon .icon-active {
    visibility: hidden;
    opacity: 0;
}



.dashboard_search_input {
    height: 70px;
    border-radius: 16px !important;
}

.dashboard_search .btn {
    position: absolute;
    right: 15px;
    top: 50%;
    width: 40px;
    height: 40px;
    transform: translateY(-50%);
}

.dashboard_profile {
    width: 70px;
    height: 70px;
}

.dashboard_profile img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.dashboard_card {
    border-radius: 16px;
    background: var(--white);
    /* min-height: 6000px; */
}

.dashboard_card .dasboard_profile {
    width: 130px;
    height: 130px;
}

.dashboard_card .dasboard_profile img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.btn-outline-light {
    border-radius: 8px;
    border: 2px solid #E3E3E3 !important;
    color: #030408;
}

.profiel_text {
    width: 292px
}

hr {
    height: 3px;
    background-color: #dbdcdd;
    border: none;
}

.dashboard_sub_card {
    border-radius: 8px;
    border: 3px solid #F5F6F8;
    padding: 20px;
}

.profile_text_1 {
    color: #040404;
}

.profile_text_2 {
    color: #040404;
    font-size: 18px;
    font-weight: 600;
}

.dash_borad_input {
    border-radius: 4px !important;
    background: #F5F6F8 !important;
    height: 50px !important;
}

.dash_borad_input_1 {
    height: 46px !important;
    border-radius: 8px !important;
    background: rgba(144, 144, 144, 0.25) !important;
    padding-right: 90px;

}

.dash_borad_input_boost {
    height: 85px !important;
    border-radius: 8px !important;
    background: rgba(144, 144, 144, 0.25) !important;
    font-size: 20px;
    padding-left: 40px;

}

.dash_borad_input_boost::placeholder {
    font-size: 20px;
    /* padding-left: 20px; */
}

input::placeholder {
    color: var(--button-secondary);
    font-family: Poppins;
    font-size: 16px;
}

.font-weight {
    font-weight: 500;
}

.dashboard_right::-webkit-scrollbar {
    width: 5px;
}

/* Track */
.dashboard_right::-webkit-scrollbar-track {
    background: #f1f1f1;
    /* box-shadow: inset 0 0 5px grey;  */

}

/* Handle */
.dashboard_right::-webkit-scrollbar-thumb {
    background: #e0dfdf;
    border-radius: 10px;
}

/* Handle on hover */
.dashboard_right::-webkit-scrollbar-thumb:hover {
    background: #afafaf;
}

.img-cover {
    object-fit: cover;

}

.dashboard_subitel {
    color: #FF7C05;
    /* font-size: 16px; */
}

.dashboard_input_cust {
    background-color: #E3E3E3 !important;
}

.text-white {
    color: var(--white) !important;
}

.dashboard_card .chat_icons {
    width: 54px;
    height: 54px;
}

.dashboard_card .chat_icons img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.single-line-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.circle_dot {
    position: absolute;
    width: 18px;
    height: 18px;
    background: #50FA01;
    border-radius: 20px;
    border: 2px solid #FFF;
    right: 0px;
    bottom: 0px;
}

.group_img {
    position: absolute;
    left: 35px;
    top: 25px;
}

/* ===================== Dashboard Sidebar Start ======================= */
.dashboard-sidebar {
    padding: 32px;
    padding-left: 0;
    /* background-color: var(--white); */
    /* border-right: 5px solid var(--black); */
    transition: 0.2s linear;
    width: 312px;
    height: 100vh;
    overflow-y: auto;
    position: sticky;
    top: 0;
}

.dashboard-sidebar::-webkit-scrollbar {
    width: 6px;
}

.dashboard-sidebar::-webkit-scrollbar-track {
    background: transparent;
}

.dashboard-sidebar::-webkit-scrollbar-thumb {
    background: #e8e8e8;
    border-radius: 10px;
}

.dashboard-sidebar::-webkit-scrollbar-thumb:hover {
    background: #d1d1d1;
}

@media screen and (max-width: 991px) {
    .dashboard-sidebar.active {
        transform: translateX(0);
    }

    .dashboard-sidebar {
        /* padding: 32px; */
        padding-left: 20px;
        background-color: var(--white);
        /* border-right: 5px solid var(--black); */
    }

    .sidebar-list {
        padding-left: 20px;
    }
}

@media screen and (max-width: 1399px) {
    .dashboard-sidebar {
        padding: 24px;
        padding-left: 0;
    }
}

@media screen and (max-width: 991px) {
    .dashboard-sidebar {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 99;
        transform: translateX(-100%);
    }
}

.dashboard-sidebar__close {
    position: absolute;
    right: 4px;
    top: 4px;
    font-size: 20px;
}

.dashboard-sidebar .logo img {
    max-width: 166px !important;
}

.dashboard-sidebar .logo.favicon {
    display: none;
}

.dashboard-sidebar .logo.favicon img {
    max-width: 44px;
}

/* User Profile Css Start */
.user-profile {
    position: relative;
    text-align: center;
}

.user-profile__thumb {
    width: 40px;
    height: 40px;
    overflow: hidden;
    border-radius: 50%;
}

.user-profile__button {
    position: relative;
}

.user-profile .user-profile-dropdown {
    border-radius: 8px;
    transition: 0.2s linear;
    background-color: hsl(var(--white));
    box-shadow: var(--box-shadow);
    width: 200px;
    position: absolute;
    right: 0;
    z-index: 9;
    top: 100%;
    margin-top: 15px;
    padding: 15px;
    transform: scale(0.9);
    visibility: hidden;
    opacity: 0;
    border: 1px solid hsl(var(--gray-five));
}

.user-profile .user-profile-dropdown::before {
    position: absolute;
    content: "";
    width: 14px;
    height: 14px;
    top: -7px;
    right: 16px;
    transform: rotate(45deg);
    border: 1px solid hsl(var(--gray-five));
    background-color: hsl(var(--white));
    border-radius: 3px;
    border-bottom: 0;
    border-right: 0;
}

@media screen and (max-width: 991px) {
    .user-profile .user-profile-dropdown {
        transform: unset;
        top: 43px;
    }
}

.user-profile .user-profile-dropdown.show {
    visibility: visible;
    opacity: 1;
    transform: scale(1);
}

.account {
    position: relative;
}

.account__img {
    position: absolute;
    right: 0;
    bottom: 0;
}

@media screen and (max-width: 991px) {
    .account__img {
        display: none;
    }
}

.account__left {
    width: 43%;
    padding: 32px;
    position: relative;
}

@media screen and (max-width: 991px) {
    .account__left {
        width: 60%;
    }
}

.account__left::before {
    position: absolute;
    content: "";
    width: 675px;
    height: 552px;
    background: linear-gradient(152deg, rgba(246, 246, 246, 0.3) 17.12%, rgba(94, 53, 242, 0.3) 105.91%);
    filter: blur(100px);
    left: -290px;
    top: 50%;
    transform: translateY(-50%);
    z-index: -1;
}

.account__right {
    flex-grow: 1;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 300px;
    position: relative;
}

@media screen and (max-width: 991px) {
    .account__right {
        padding-bottom: 80px;
    }
}

@media screen and (max-width: 575px) {
    .account__right {
        padding-bottom: 60px;
    }
}

@media screen and (max-width: 575px) {
    .account__right {
        padding-left: 24px;
        padding-right: 24px;
    }
}

.account-thumb {
    max-width: 572px;
    margin-left: auto;
    margin-right: auto;
}

.account-content {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
}

/* ========================== Account Page Css End ============================= */
/* ===================== Dashboard Start ======================= */
.dashboard-nav,
.dashboard-body__content,
.dashboard-footer {
    padding-left: 32px;
    padding-right: 32px;
}

@media screen and (max-width: 1399px) {

    .dashboard-nav,
    .dashboard-body__content,
    .dashboard-footer {
        padding-left: 24px;
        padding-right: 24px;
    }
}

.dashboard-footer {
    margin-top: auto !important;
}

.dashboard {
    background-color: hsl(var(--gray-seven));
}

.dashboard-body {
    width: calc(100% - 312px);
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

@media screen and (max-width: 991px) {
    .dashboard-body {
        width: 100%;
    }
}

.dashboard-body__content {
    margin: 32px 0;
}

.dashboard-body__item {
    margin-bottom: 32px;
}

.dashboard-body__item:last-child {
    margin-bottom: 0;
}

/* Sidebar Collapse */
@media (min-width: 992px) {
    .dashboard.active .dashboard-sidebar {
        width: auto;
    }

    .dashboard.active .dashboard-sidebar .logo {
        display: none;
    }

    .dashboard.active .dashboard-sidebar .logo.favicon {
        display: block;
    }

    .dashboard.active .dashboard-sidebar .sidebar-list__link {
        width: 44px;
        height: 44px;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .dashboard.active .dashboard-sidebar .sidebar-list__link .text {
        display: none;
    }

    .dashboard.active .bar-icon {
        display: none;
    }

    .dashboard.active .arrow-icon {
        display: block;
    }
}

/* Sidebar Collapse End */
/* Dashboard Widget Css Start */
.dashboard-widget {
    padding: 16px 24px;
    border-radius: 8px;
    background-color: transparent;
    position: relative;
    z-index: 1;
    transition: 0.2s linear;
}

@media screen and (max-width: 1399px) {
    .dashboard-widget {
        padding: 16px;
    }
}

.dashboard-widget:hover {
    box-shadow: 0px 20px 30px 0px rgba(197, 196, 201, 0.25);
    background: var(--main-gradient);
}

.dashboard-widget:hover .dashboard-widget__shape.one {
    visibility: hidden;
    opacity: 0;
}

.dashboard-widget:hover .dashboard-widget__shape.two {
    visibility: visible;
    opacity: 1;
}

.dashboard-widget::before {
    position: absolute;
    content: "";
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    background: hsl(var(--white));
    left: 1px;
    top: 1px;
    border-radius: inherit;
    z-index: -1;
    transition: 0.2s linear;
}

.dashboard-widget__shape {
    position: absolute;
    right: 0;
    top: 16px;
    transition: 0.2s linear;
}

.dashboard-widget__shape.two {
    visibility: hidden;
    opacity: 0;
}

.dashboard-widget__icon {
    width: 72px;
    height: 72px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: hsl(var(--gray-seven));
}

@media (min-width: 992px) and (max-width: 1399px) {
    .dashboard-widget__icon {
        width: 60px;
        height: 60px;
    }
}

@media (min-width: 992px) and (max-width: 1399px) {
    .dashboard-widget__number {
        font-size: 22px;
    }
}

/* Dashboard Widget Css End */

/* ======================== Dashboard End ====================== */



/* Chat row styling */
.chat_row {
    padding: 20px;
    background: var(--main-bg);
}

.chat_row .course_video_time {
    color: var(--white);
    /* border-radius: 20px; */
}

.dashboard_card .btn-main {
    background-color: var(--white) !important;
    /* border-radius: 20px; */
}


.chat_bubble {
    padding: 10px;
    margin-bottom: 8px;
    max-width: 60%;
    border-radius: 22px;
    /* Default for all bubbles */
}

/* Left-aligned chat bubbles */
.chat_bubble_left {
    background: #D9D9D9;
    color: #040404;
    align-self: flex-start;
    border-radius: 22px 22px 22px 22px;
    /* Full radius for left bubbles by default */
}

/* Right-aligned chat bubbles */
.chat_bubble_right {
    align-self: flex-end;
    color: white;
    background: linear-gradient(120deg, #FFA553 0.98%, #FF7A00 97.64%);
    border-radius: 22px 22px 22px 22px;
    /* Full radius for right bubbles by default */
}

/* Last left-aligned chat bubble */
.p-4 .chat_bubble_left:last-child {
    border-radius: 22px 22px 22px 0px;
    /* Square bottom-left corner */
}

/* Last right-aligned chat bubble */
.p-4 .chat_bubble_right:last-child {
    border-radius: 22px 0px 22px 22px;
    /* Square bottom-right corner */
}

.bg-white {
    background: var(--white) !important;
}

.dashboard_chatbox {
    border-radius: 8px !important;
}

.dashboard_card .chat_icons_group {
    width: 84px;
    height: 84px;
    position: relative;
    margin-bottom: 35px;
}

.dashboard_card .chat_icons_group img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.custm_navpills .nav-link {
    color: #040404;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;

}

.custm_navpills .nav-link.active,
.custm_navpills .show>.nav-link {
    color: var(--black);
    border-radius: 28px;
    padding: 10px 40px;
    background: linear-gradient(98deg, #FFA553 9.49%, #FF7A00 93.9%);
}

.text-black {
    color: black;
}

.dasboard_profile_qr {
    background: #F5F6F8;
    width: 100px;
    height: 100px;
    border-radius: 50%;
}

.dasboard_profile_qr img {
    width: 57px;
    height: 57px;
    object-fit: cover;

}

.teacher_experince {
    width: 32px;
    height: 32px;
    /* border-radius: 4px; */
    border-radius: 4px;
    border: 0.5px solid #787877;
    background: #FFF;
}

.teacher_experince img {
    border-radius: 4px;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.height_150 {
    height: 150px;
}

.height_370 {
    height: 370px;
    border-radius: 8px;
    background: rgba(144, 144, 144, 0.25);
    margin-top: 20px;
}

#courseDescription {
    height: 150px !important;
}

.btn-secondary {
    background: var(--button-secondary) !important;
}

.boost_profile {
    width: 157px;
    height: 157px;
}

.boost_profile img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
}

.cust_radio {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 30px;
    height: 30px;
    border: 3px solid gray;
    /* Orange border */
    border-radius: 50%;
    /* Make it circular */
    outline: none;
    cursor: pointer;
    position: relative;
}

.cust_radio:checked {
    border: 3px solid #FF7A00;
}

.cust_radio:checked::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 14px;
    height: 14px;
    background-color: #FF7A00;
    /* Inner orange dot */
    border-radius: 50%;
    transform: translate(-50%, -50%);
}


.bg_dashboard_boost {
    background-color: #F9F5F2;
}


input[type="range"] {
    -webkit-appearance: none;
    width: 100%;
    background-color: #ddd;
    height: 6px;
    border-radius: 3px;
    outline: none;
}

/* Style for the slider thumb */
input[type="range"]::-webkit-slider-thumb {
    appearance: none;
    width: 20px;
    /* Increase size of the thumb */
    height: 20px;
    background-color: var(--main-bg);
    /* Set color of the thumb */
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
    /* Optional: add a subtle shadow */
}

input[type="range"]::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background-color: var(--main-bg);
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
}

.call {
    border-radius: 7px !important;
    background: #D9D9D9 !important;
    color: var(--button-secondary) !important;
}

.whatsapp {
    border-radius: 7px !important;
    color: var(--white) !important;
    background: linear-gradient(95deg, #00FF1A 1.97%, #00750C 99.72%) !important;
}

.btn {
    border: transparent;
}

.boost_cards {
    border-radius: 16px;
    background: #FFF;
    height: 309px;
}

.boost_imgs {
    border-radius: 16px 16px 0 0;
    height: 80%;
    width: 100%;
    object-fit: cover;
}
.course_video  {

    border-radius: 16px;
    padding: 10px;
    height: 50%;
    width: 100%;
    object-fit: cover;

}

.btn_boost {
    /* height: 32px !important; */
    /* padding: 30px; */
    border-radius: 4px !important;
    background: #FF7A00 !important;
    color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/main.css"],"names":[],"mappings":"AAAA,gEAAgE;AAChE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAiCC;AACD,gEAAgE;AAChE,uEAAuE;AACvE,uEAAuE;AACvE,eAAe;;AAGf,0EAA0E;AAC1E;IACI,yBAAyB;IACzB,kCAAkC;IAClC,gCAAgC;IAChC,6BAA6B;IAC7B,8BAA8B;IAC9B,8DAA8D;IAC9D,+DAA+D;IAC/D,+DAA+D;IAC/D,8DAA8D;IAC9D,6DAA6D;IAC7D,yDAAyD;IACzD,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;IACb,wBAAwB;IACxB,yBAAyB;IACzB,gCAAgC;IAChC,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,qEAAqE;IACrE,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,6EAA6E;IAC7E,yBAAyB;IACzB,wBAAwB;AAC5B;;;;AAIA,wEAAwE;AACxE,+EAA+E;AAC/E,2CAA2C;AAC3C,yCAAyC;AACzC,2CAA2C;AAC3C,yCAAyC;AACzC,6EAA6E;AAC7E,oFAAoF;AACpF;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,2CAA2C;IAC3C,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;;;;;;;;;IASI,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA,uBAAuB;AACvB;IACI,8CAA8C;AAClD;;AAEA;IACI,6EAA6E;AACjF;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,gDAAgD;AACpD;;;AAGA;IACI,wCAAwC;AAC5C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;;;AAIA;IACI,6BAA6B;AACjC;;;AAGA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,8BAA8B;AAC9B;IACI;QACI,UAAU;IACd;AACJ;;AAEA,iBAAiB;AACjB;IACI,iCAAiC;IACjC,uCAAuC;IACvC,6CAA6C;IAC7C,WAAW;IACX,YAAY;AAChB;;AAEA,yCAAyC;AACzC;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,MAAM;IACN,OAAO;IACP,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,uBAAuB;AAC3B;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,WAAW;IACX,OAAO;IACP,MAAM;IACN,0CAA0C;IAC1C,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,YAAY;QACZ,WAAW;QACX,OAAO;QACP,MAAM;QACN,iDAAiD;QACjD,0CAA0C;QAC1C,WAAW;QACX,uBAAuB;QACvB,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA,gBAAgB;AAChB,kFAAkF;AAClF,2EAA2E;AAC3E,oBAAoB;AACpB;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB,gCAAgC;AAChC;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;;;IAGI,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA,8BAA8B;AAC9B,2CAA2C;AAC3C;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,+BAA+B;IACnC;AACJ;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,4BAA4B;AAChC;;AAEA,yCAAyC;AACzC,yEAAyE;AACzE,4EAA4E;AAC5E;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,8BAA8B;IAC9B,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;;IAGI,wBAAwB;AAC5B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,SAAS;AACb;;AAEA;;IAEI;;QAEI,SAAS;IACb;AACJ;;AAEA;;IAEI;;QAEI,MAAM;IACV;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;;IAExB,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,qBAAqB;IACrB,iBAAiB;IACjB,oCAAoC;IACpC,yBAAyB;IACzB,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;IACZ,yBAAyB;IACzB,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;IACpC,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;IAII,kBAAkB;AACtB;;AAEA;;;;IAII,oCAAoC;IACpC,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;;;;IAII,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,YAAY;IACZ,WAAW;IACX,cAAc;IACd,SAAS;IACT,yBAAyB;IACzB,UAAU;AACd;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,MAAM;IACN,yBAAyB;IACzB,oCAAoC;IACpC,UAAU;IACV,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;;IAEI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,MAAM;AACV;;AAEA;;IAEI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;;;;IAII,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA,kBAAkB;AAClB;;IAEI;;;;QAII,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA,kBAAkB;AAClB;;IAEI;;;;QAII,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA,0EAA0E;AAC1E,uFAAuF;AACvF;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,wBAAwB;;IAExB,sBAAsB;IACtB,sCAAsC;IACtC,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;;;;IAMI,kBAAkB;IAClB,gCAAgC;IAChC,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;;;;;;IAMI,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;;;;;;IAMI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA,qFAAqF;AACrF,mFAAmF;AACnF;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,+DAA+D;AACnE;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,mEAAmE;AACvE;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA,iFAAiF;AACjF,oFAAoF;AACpF;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,qBAAqB;IACzB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA,kFAAkF;AAClF,kFAAkF;AAClF;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,yCAAyC;IACzC,wBAAwB;IACxB,gBAAgB;;AAEpB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI,wBAAwB;IACxB,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;IACxB,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,mDAAmD;IACnD,gCAAgC;AACpC;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;IAEI,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;;AAEA;;IAEI;;QAEI,WAAW;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA,oFAAoF;AACpF,mFAAmF;AACnF;;;;;IAKI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,6BAA6B;IAC7B,qCAAqC;IACrC,UAAU;IACV,mBAAmB;IACnB,cAAc;IACd,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;;;IAGI,2BAA2B;AAC/B;;;;AAIA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI;QACI,wBAAwB;QACxB,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,WAAW;QACX,YAAY;;IAEhB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2CAA2C;IAC3C,8BAA8B;IAC9B,UAAU;IACV,8BAA8B;AAClC;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;IACN,sBAAsB;IACtB,gCAAgC;IAChC,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,6BAA6B;AACjC;;AAEA;IACI,+CAA+C;IAC/C,0CAA0C;AAC9C;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;IACzC,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;IACxC,yCAAyC;IACzC,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;IACxC,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;IACxC,qCAAqC;IACrC,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA;IACI,gDAAgD;IAChD,4CAA4C;IAC5C,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA;IACI,wCAAwC;IACxC,4CAA4C;IAC5C,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;IACxC,4CAA4C;IAC5C,iBAAiB;IACjB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;IAChD,4CAA4C;IAC5C,qCAAqC;AACzC;;AAEA,iFAAiF;AACjF,iFAAiF;AACjF,gBAAgB;AAChB;;;;;;;;;;;GAWG;;AAEH;IACI,8BAA8B;IAC9B,qDAAqD;IACrD,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,wCAAwC;IACxC,2BAA2B;IAC3B,qCAAqC;IACrC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,2BAA2B;IAC3B,wDAAwD;IACxD,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,wCAAwC;IACxC,qCAAqC;IACrC,mBAAmB;IACnB,cAAc;IACd,oBAAoB;AACxB;;AAEA,oCAAoC;AACpC;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,0CAA0C;IAC1C,2BAA2B;IAC3B,sBAAsB;IACtB,sEAAsE;AAC1E;;;AAGA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;;GAEG;;AAEH;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI,oCAAoC;IACpC,UAAU;IACV,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,8CAA8C;IAC9C,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,cAAc;AACd,eAAe;AACf;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,SAAS;IACT,wBAAwB;AAC5B;;AAEA,eAAe;AACf,UAAU;AACV;IACI,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;IACpB,mCAAmC;AACvC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA,iBAAiB;AACjB;;;;;;;;IASI,yDAAiD;IAAjD,iDAAiD;AACrD;;AAEA;;;;;;IAMI,oDAAoD;IACpD,wDAAwD;IACxD,iCAAiC;AACrC;;AAEA,qBAAqB;AACrB,uBAAuB;AACvB;;IAEI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,sCAAsC;AACtC;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,UAAU;IAEV,yCAAyC;AAC7C;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,6BAA6B;IAC7B,2BAA2B;IAC3B,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,uBAAuB;IACvB,aAAa;AACjB;;;AAGA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;IACpB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;IAET,2CAA2C;IAC3C,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,gBAAgB;AACpB;;;AAGA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA,oCAAoC;AACpC,+EAA+E;AAC/E,uFAAuF;AACvF;IACI,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,UAAU;IACV,2BAA2B;IAC3B,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;;;IAGI,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mCAAmC;IACnC,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;;;IAGI,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA,qFAAqF;AACrF,gFAAgF;AAChF;IACI,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;IAClB,kCAAkC;IAClC,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,8BAA8B;IAC9B,iDAAiD;IACjD,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,6BAA6B;IAC7B,8BAA8B;IAC9B,sDAAsD;IACtD,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,OAAO;IACP,MAAM;IACN,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA,iBAAiB;AACjB;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,mBAAmB;IACvB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI;QACI,6BAA6B;QAC7B,UAAU;QACV,mCAAmC;QACnC,eAAe;QACf,+BAA+B;QAC/B,SAAS;QACT,oCAAoC;QACpC,gBAAgB;IACpB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,sCAAsC;IACtC,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA,8EAA8E;AAC9E,2EAA2E;AAC3E;IACI,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,oDAAoD;IACpD,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oDAAoD;IACpD,gBAAgB;IAChB,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;;IAExB,mBAAmB;IACnB,8BAA8B;IAC9B,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA,yEAAyE;AACzE,sEAAsE;AACtE;IACI,SAAS;IACT,6BAA6B;IAC7B,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;;IAEI,kBAAkB;IAClB,6BAA6B;IAC7B,4CAA4C;AAChD;;AAEA;;IAEI;;QAEI,kBAAkB;IACtB;AACJ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA,oEAAoE;AACpE,oFAAoF;AACpF;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;IAGpB,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAElB,kDAAkD;AACtD;;AAEA;IAEI,oBAAoB;AACxB;;AAgBA;;IAEI;;QAGI,mBAAmB;IACvB;;IAEA;QAEI,mBAAmB;IACvB;AACJ;;AAEA,mFAAmF;AACnF,gEAAgE;AAChE;IACI,kBAAkB;IAClB,oDAAoD;IACpD,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;;;AAGtB;;AAEA;IACI,kDAAkD;IAClD,oDAAoD;IACpD,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;IAClB,0DAA0D;IAC1D,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,oEAAoE;AACpE,4DAA4D;AAC5D;;IAEI,uBAAuB;IACvB,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,MAAM;IACN,QAAQ;IACR,WAAW;IACX,UAAU;IACV,iCAAiC;IACjC,mCAAmC;IACnC,gCAAgC;IAChC,yCAAyC;AAC7C;;AAEA;IACI;QACI,SAAS;QACT,gCAAgC;IACpC;;AAEJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,2CAA2C;IAC3C,kCAAkC;IAClC,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,uBAAuB;AAC3B;;AAEA,aAAa;AACb;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,oBAAoB;AACxB;;AAEA,aAAa;AACb,oBAAoB;AACpB;IACI,qCAAqC;IACrC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;AACrB;;AAEA,oBAAoB;AACpB;IACI,cAAc;IACd,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,uDAAuD;IACvD,sDAAsD;IACtD,2CAA2C;AAC/C;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,sCAAsC;AACtC;IACI,QAAQ;AACZ;;AAEA;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;QACzB,8DAA8D;QAC9D,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,sCAAsC;IACtC;yBACqB;AACzB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI;QACI,kBAAkB;QAClB,0CAA0C;IAC9C;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,kCAAkC;IAClC,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI;QACI,iBAAiB;QACjB,gBAAgB;IACpB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,kCAAkC;IAClC,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA,gBAAgB;AAChB,oCAAoC;AACpC,iFAAiF;AACjF,0CAA0C;AAC1C;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;IACzC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI;QACI,OAAO;IACX;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,8CAA8C;IAC9C,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,6CAA6C;AACjD;;AAEA,sDAAsD;AACtD,8BAA8B;AAC9B;IACI,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,4BAA4B;IAC5B,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,uDAAuD;IACvD,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,uDAAuD;IACvD,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA,8BAA8B;AAC9B,4DAA4D;AAC5D,0BAA0B;AAC1B;IACI,eAAe;IACf,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,qDAAqD;IACrD,yBAAyB;IACzB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;;IAEV,2DAA2D;IAC3D,sBAAsB;IACtB,4BAA4B;IAC5B,wBAAwB;IACxB,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI;QACI,eAAe;QACf,+CAA+C;QAC/C,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,gBAAgB;IAChB,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,SAAS;AACb;;AAEA,0DAA0D;;AAE1D,gFAAgF;AAChF;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,8CAA8C;IAC9C,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,2BAA2B;IAE3B,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,WAAW;QACX,iBAAiB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,OAAO;IACP,MAAM;IACN,eAAe;IACf,cAAc;IACd,UAAU;IAEV,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,iBAAiB;IACrB;AACJ;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IAEtB,4BAA4B;AAChC;;AAEA,8EAA8E;AAC9E,+FAA+F;AAC/F,8FAA8F;AAC9F,kFAAkF;AAClF;IACI,kEAAkE;IAClE,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;IACN,mCAAmC;IACnC,WAAW;IACX,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA,gFAAgF;AAChF,wFAAwF;AACxF;IACI,oBAAoB;IACpB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;IACN,sBAAsB;IACtB,gCAAgC;IAChC,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA,uFAAuF;AACvF,oEAAoE;AACpE;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,mDAAmD;IACnD,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,mDAAmD;IACnD,iDAAiD;IACjD,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,uDAAuD;IACvD,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,uDAAuD;IACvD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA,iBAAiB;AACjB,oEAAoE;;;AAGpE;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;;AAGA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,YAAY;AAChB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,WAAW;IACX,YAAY;;IAEZ,uBAAuB;AAC3B;;AAEA,sDAAsD;AACtD;;IAEI,0BAA0B;IAC1B,wCAAwC;IACxC,YAAY;IACZ,yDAAyD;IACzD,gCAAgC;IAChC,mCAAmC;AACvC;;;AAGA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;;;AAIA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;IACjB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,mDAAmD;IACnD,iBAAiB;IACjB,gCAAgC;;IAEhC,oCAAoC;IACpC,kBAAkB;AACtB;;;;AAIA;IACI,eAAe;IACf,cAAc;IACd,qCAAqC;IACrC,oCAAoC;IACpC,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI;QACI,mDAAmD;QACnD,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,YAAY;;IAEhB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;QACf,iBAAiB;;;IAGrB;;IAEA;QACI,UAAU;IACd;;AAEJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;;AAGA,oFAAoF;AACpF;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;;;;GAIG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;GAuBG;;AAEH,kDAAkD;AAClD,mCAAmC;AACnC;IACI,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,oDAAoD;IACpD,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;;AAIA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oGAAoG;IACpG,mBAAmB;IACnB,YAAY;IACZ,QAAQ;IACR,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;AACrB;;AAEA,4BAA4B;AAC5B;IACI,UAAU;IACV,+CAA+C;IAC/C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,oDAAoD;AACxD;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA,2BAA2B;AAC3B;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,0CAA0C;AAC9C;;AAEA,kCAAkC;AAClC;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,yBAAyB;AACzB;IACI,eAAe;IACf,gCAAgC;AACpC;;;AAGA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;;IAEzB,4DAA4D;IAC5D,sDAAsD;AAC1D;;AAEA;IACI;mBACe;IACf,0BAA0B;AAC9B;;AAEA;IACI,4DAA4D;;AAEhE;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,iEAAiE;IACjE,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;;;;AAKA,mEAAmE;AACnE;IACI,sBAAsB;IACtB,uCAAuC;IACvC,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,6CAA6C;IAC7C,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;;AAGA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;;;AAGrB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kEAAkE;AACtE;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;;;AAIA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,oDAAoD;IACpD,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,+DAA+D;AACnE;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;;IAEI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;;;AAIA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;IACI,2FAAqX;;AAEzX;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;IAC9B,UAAU;IACV,kBAAkB;IAClB,6BAA6B;;AAEjC;;AAEA;IACI,WAAW;IACX,eAAe;;AAEnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,8BAA8B;AAC9B;IACI,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;;AAGA,+BAA+B;AAC/B;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,YAAY;;AAEhB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA,+BAA+B;AAC/B;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;;;;AAKA;;IAEI;;QAEI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,6CAA6C;IAC7C,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,uBAAuB;IACvB,4BAA4B;IAC5B,6EAA6E;AACjF;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA,kFAAkF;AAClF,yBAAyB;AACzB;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,wCAAwC;QACxC,yCAAyC;QACzC,8BAA8B;IAClC;AACJ;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;IACzC,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA,uBAAuB;AACvB,8BAA8B;AAC9B;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,mCAAmC;IACnC,8BAA8B;AAClC;;AAEA,4BAA4B;AAC5B,+BAA+B;AAC/B;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA,6BAA6B;AAC7B,6BAA6B;AAC7B;IACI,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;;;;;;;;;;;;GAcG;;AAEH;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,wBAAwB;IACxB,WAAW;IACX,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,QAAQ;IACR,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA,uEAAuE;AACvE;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;AACd;;AAEA,2BAA2B;AAC3B,gFAAgF;AAChF,oEAAoE;;AAEpE;IACI,+BAA+B;IAC/B;;;;;;aAMS;;AAEb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,2BAA2B;IAC3B;MACE;IACF,WAAW;IACX,6BAA6B;AACjC;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;;;AAIA;IACI,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,gDAAgD;IAChD,mBAAmB;;AAEvB;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,gDAAgD;IAChD,eAAe;IACf,kBAAkB;;AAEtB;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA,UAAU;AACV;IACI,mBAAmB;IACnB,qCAAqC;;AAEzC;;AAEA,WAAW;AACX;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA,0EAA0E;AAC1E;IACI,aAAa;IACb,eAAe;IACf,oCAAoC;IACpC,0CAA0C;IAC1C,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;AACV;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,8BAA8B;QAC9B,0CAA0C;IAC9C;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,OAAO;QACP,MAAM;QACN,WAAW;QACX,4BAA4B;IAChC;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,mCAAmC;IACnC,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;IACX,wBAAwB;IACxB,uCAAuC;IACvC,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI;QACI,gBAAgB;QAChB,SAAS;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oGAAoG;IACpG,mBAAmB;IACnB,YAAY;IACZ,QAAQ;IACR,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,kFAAkF;AAClF,kEAAkE;AAClE;;;IAGI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI;;;QAGI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;QACV,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA,yBAAyB;AACzB,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;IAClB,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,uDAAuD;IACvD,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,wBAAwB;IACxB,6BAA6B;IAC7B,SAAS;IACT,QAAQ;IACR,sBAAsB;IACtB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA,6BAA6B;;AAE7B,kEAAkE;;;;AAIlE,qBAAqB;AACrB;IACI,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;IACzC,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA,8BAA8B;AAC9B;IACI,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,kCAAkC;IAClC,4CAA4C;AAChD;;AAEA,+BAA+B;AAC/B;IACI,oBAAoB;IACpB,YAAY;IACZ,kEAAkE;IAClE,kCAAkC;IAClC,6CAA6C;AACjD;;AAEA,kCAAkC;AAClC;IACI,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA,mCAAmC;AACnC;IACI,iCAAiC;IACjC,+BAA+B;AACnC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,gEAAgE;AACpE;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;;AAErB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,gCAAgC;AACpC;;;AAGA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,wBAAwB;IACxB,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA,+BAA+B;AAC/B;IAEI,gBAAgB;IAChB,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,gCAAgC;IAChC,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,4EAA4E;AAChF;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,WAAW;IACX,WAAW;IACX,iBAAiB;AACrB;AACA;;IAEI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,WAAW;IACX,iBAAiB;;AAErB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,6BAA6B;IAC7B,8BAA8B;IAC9B,uBAAuB;AAC3B","sourcesContent":["/*====================== CSS Index Here =======================*/\n/*\n01. Abstracts\n    1.1. Classes\n    1.2. Extend\n    1.3. Functions\n    1.4. Mixins\n    1.5. Variable\n    1.6. Wordpress Default\n\n02. Base\n    2.1. Margin\n    2.2. Padding\n    2.3. Typography\n\n03. Components\n    3.1. Accordion\n    3.2. Button\n    3.3. Form\n    3.4. Pagination\n    3.6. Tab\n\n04. Layout\n    4.1. Blog Sidebar\n    4.2. Breadcrumb\n    4.3. Comment\n    4.4. Footer\n    4.5. Header Top\n    4.6. Header\n    4.7. Preloader\n    4.8. Scroll Top\n    4.9. Section Heading\n    4.10. Slick\n    4.11. Social Icon\n*/\n/*======================== CSS Index End ======================*/\n/* ======================== Functions Css End ======================= */\n/* ======================== Functions Css End ======================= */\n/* Font Family*/\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Jost:ital,wght@0,100..900;1,100..900&display=swap\");\n\n/* ========================= Variable Css Start ======================== */\n:root {\n    /* Font Family Variable */\n    --heading-font: \"Jost\", sans-serif;\n    --body-font: \"Inter\", sans-serif;\n    /* Font Size Variable Start */\n    /* --heading-color: #1e1d1d; */\n    --heading-one: clamp(1.875rem, -2.0093rem + 8.3527vw, 4.25rem);\n    --heading-two: clamp(1.75rem, -0.8115rem + 5.3364vw, 3.1875rem);\n    --heading-three: clamp(1.5rem, -0.0592rem + 3.2483vw, 2.375rem);\n    --heading-four: clamp(1.375rem, 0.7068rem + 1.3921vw, 1.75rem);\n    --heading-five: clamp(1.125rem, 0.4568rem + 1.3921vw, 1.5rem);\n    --heading-six: clamp(1rem, 0.7773rem + 0.464vw, 1.125rem);\n    /* Font Size End */\n    /* Gray Color */\n    --main: #FF7A00;\n    --main-bg: #FF7A00;\n    --body-bg: #F9F5F2;\n    --gray-seven: #FFFFFF;\n    --white: #fff;\n    --black-three: #1e1d1d;\n    --white-one: #fff;\n    --black: #000;\n    --gray-five: 252 10% 90%;\n    --gray-seven: 210 25% 97%;\n    --body-color: var(--black-three);\n    --static-black: var(--black);\n    --black-two-h: 234;\n    --black-two-s: 69%;\n    --black-two-l: 9%;\n    --black-two: var(--black-two-h) var(--black-two-s) var(--black-two-l);\n    --black-three-h: 235;\n    --black-three-s: 5%;\n    --black-three-l: 43%;\n    --black-three: var(--black-three-h) var(--black-three-s) var(--black-three-l);\n    --body_dashboard: #F5F6F8;\n    --button-secondary: #666;\n}\n\n\n\n/* ========================= Variable Css End ======================== */\n/* ============================ Mixins Css Start ============================ */\n/* Media Breakpoint for Each Device Start */\n/* Media Breakpoint for Each Device End */\n/* Font Size For responsive devices Start */\n/* Font Size For responsive devices End */\n/* ============================ Mixins Css End ============================ */\n/* ================================= Classes Css Start =========================== */\n@media (min-width: 1199px) {\n    .container-full {\n        max-width: 1792px;\n    }\n}\n\n@media (min-width: 1199px) {\n    .container-two {\n        max-width: 1296px;\n    }\n}\n\n@media (min-width: 1199px) {\n    .container-three {\n        max-width: 1590px;\n    }\n}\n\nbody {\n    /* background: var(--body-bg) !important; */\n    font-family: Poppins;\n    font-style: normal;\n    font-weight: 500;\n}\n\n.bg_dashboard {\n    background: var(--body_dashboard) !important;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\na,\nspan {\n    font-family: Poppins;\n    font-style: normal;\n    /* font-weight: 500; */\n    color: var(--button-secondary);\n}\n\n/* Section Background */\n.section-bg {\n    background-color: var(--section-bg) !important;\n}\n\n.sales-offer-bg-two {\n    background: linear-gradient(117deg, #F3FEFF 14.35%, #DACFFF 84.4%) !important;\n}\n\n.box-shadow {\n    box-shadow: var(--box-shadow) !important;\n}\n\n.box-shadow-lg {\n    box-shadow: var(--box-shadow-lg) !important;\n}\n\n.max-h-unset {\n    max-height: unset !important;\n}\n\n.max-w-unset {\n    max-width: unset !important;\n}\n\n.w-20 {\n    width: 20px;\n}\n\n.min-w-maxContent {\n    min-width: max-content;\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n.z-index-1 {\n    z-index: 1;\n}\n\n.z-index--1 {\n    z-index: -1;\n}\n\n.bg-white {\n    background-color: var(--white) !important;\n}\n\n.bg-main {\n    background-color: var(--main) !important;\n}\n\n.bg-main-btn {\n    background: var(--main) !important;\n    color: var(--white) !important;\n}\n\n.bg-black {\n    background-color: var(--black) !important;\n}\n\n.bg-static-black {\n    background-color: var(--static-black) !important;\n}\n\n\n.border:focus {\n    border: 1px solid var(--main) !important;\n}\n\n.border-main {\n    border-color: var(--main) !important;\n}\n\n.border-color {\n    border-color: var(--border-color);\n}\n\n.border-black {\n    border-color: var(--black) !important;\n}\n\n.border-gray-five {\n    border-color: var(--gray-five) !important;\n}\n\n.fw-200 {\n    font-weight: 200 !important;\n}\n\n.fw-300 {\n    font-weight: 300 !important;\n}\n\n.fw-400 {\n    font-weight: 400 !important;\n}\n\n.fw-500 {\n    font-weight: 500 !important;\n}\n\n.fw-600 {\n    font-weight: 600 !important;\n}\n\n.fw-700 {\n    font-weight: 700 !important;\n}\n\n.fw-800 {\n    font-weight: 800 !important;\n}\n\n.fw-900 {\n    font-weight: 900 !important;\n}\n\n.left-auto {\n    left: auto !important;\n}\n\n\n\n.text-main {\n    color: var(--main) !important;\n}\n\n\n.hover-text-main:hover {\n    color: var(--main) !important;\n}\n\n.hover-text-decoration-underline:hover {\n    text-decoration: underline;\n}\n\n.font-heading {\n    font-family: var(--heading-font);\n}\n\n.font-body {\n    font-family: var(--body-font);\n}\n\n.pill {\n    border-radius: 30px !important;\n}\n\n.radius-8 {\n    border-radius: 8px !important;\n}\n\n.line-height-0 {\n    line-height: 0;\n}\n\n.line-height-1 {\n    line-height: 1;\n}\n\n/* Column Extra Small Screen */\n@media screen and (min-width: 425px) and (max-width: 575px) {\n    .col-xs-6 {\n        width: 50%;\n    }\n}\n\n/* Bg Image Css */\n.background-img {\n    background-size: cover !important;\n    background-repeat: no-repeat !important;\n    background-position: center center !important;\n    width: 100%;\n    height: 100%;\n}\n\n/* Hide Scroll bar Css For Custom Modal */\n.scroll-hide {\n    position: absolute;\n    overflow-y: hidden;\n    padding-right: 17px;\n    top: 0;\n    left: 0;\n    width: 100%;\n}\n\n@media screen and (max-width: 991px) {\n    .scroll-hide {\n        padding-right: 0;\n    }\n}\n\n.scroll-hide-sm {\n    position: absolute;\n    overflow-y: hidden;\n    top: 0;\n    left: 0;\n    width: calc(100% - 0px);\n}\n\n/* Overlay Start */\n.overlay {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    content: \"\";\n    left: 0;\n    top: 0;\n    background-color: hsla(234, 100%, 7%, 0.8);\n    z-index: 99;\n    transition: 0.2s linear;\n    visibility: hidden;\n    opacity: 0;\n}\n\n.overlay.show-overlay {\n    visibility: visible;\n    opacity: 1;\n}\n\n@media (max-width: 991px) {\n    .side-overlay {\n        position: fixed;\n        width: 100%;\n        height: 100%;\n        content: \"\";\n        left: 0;\n        top: 0;\n        /* background-color: var((--static-black)/0.8); */\n        background-color: hsla(234, 100%, 7%, 0.8);\n        z-index: 99;\n        transition: 0.2s linear;\n        visibility: hidden;\n        opacity: 0;\n    }\n\n    .side-overlay.show {\n        visibility: visible;\n        opacity: 1;\n    }\n}\n\n/* Overlay End */\n/* ================================= Classes Css End =========================== */\n/* ============================ Extend Css Start ======================== */\n/* Cover image Css */\n.cover-img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n/* Display Flex Css Start */\n.flx-wrap {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.flx-align,\n.common-check {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n}\n\n.flx-center {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n}\n\n.flx-between {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n}\n\n/* Display Flex Css End */\n/* Positioning Css Class Start */\n.pa-content {\n    position: absolute;\n    content: \"\";\n}\n\n.top-center,\n.common-accordion .accordion-button[aria-expanded=true]::after,\n.common-accordion .accordion-button[aria-expanded=false]::after {\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.left-center {\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.top-left-center {\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n/* Positioning Css Class End */\n/* Font Size For responsive devices Start */\n.font-10 {\n    font-size: 0.625rem !important;\n}\n\n.font-11 {\n    font-size: 0.6875rem !important;\n}\n\n.font-12 {\n    font-size: 0.75rem !important;\n}\n\n.font-13 {\n    font-size: 0.8125rem !important;\n}\n\n.font-14 {\n    font-size: 0.875rem !important;\n}\n\n.font-15 {\n    font-size: 0.9375rem !important;\n}\n\n.font-16 {\n    font-size: 1rem !important;\n}\n\n.font-17 {\n    font-size: 1.0625rem !important;\n}\n\n.font-18 {\n    font-size: 1.125rem !important;\n}\n\n@media screen and (max-width: 1199px) {\n    .font-18 {\n        font-size: 1rem !important;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .font-18 {\n        font-size: 0.9375rem !important;\n    }\n}\n\n.font-19 {\n    font-size: 1.1875rem !important;\n}\n\n.font-20 {\n    font-size: 1.25rem !important;\n}\n\n@media screen and (max-width: 1199px) {\n    .font-20 {\n        font-size: 1.125rem !important;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .font-20 {\n        font-size: 1rem !important;\n    }\n}\n\n.font-21 {\n    font-size: 1.3125rem !important;\n}\n\n.font-22 {\n    font-size: 1.375rem !important;\n}\n\n.font-23 {\n    font-size: 1.4375rem !important;\n}\n\n.font-24 {\n    font-size: 1.5rem !important;\n}\n\n.font-25 {\n    font-size: 1.5625rem !important;\n}\n\n.font-26 {\n    font-size: 1.625rem !important;\n}\n\n.font-27 {\n    font-size: 1.6875rem !important;\n}\n\n.font-28 {\n    font-size: 1.75rem !important;\n}\n\n.font-29 {\n    font-size: 1.8125rem !important;\n}\n\n.font-30 {\n    font-size: 1.875rem !important;\n}\n\n.font-31 {\n    font-size: 1.9375rem !important;\n}\n\n.font-32 {\n    font-size: 2rem !important;\n}\n\n.font-33 {\n    font-size: 2.0625rem !important;\n}\n\n.font-34 {\n    font-size: 2.125rem !important;\n}\n\n.font-35 {\n    font-size: 2.1875rem !important;\n}\n\n.font-36 {\n    font-size: 2.25rem !important;\n}\n\n.font-37 {\n    font-size: 2.3125rem !important;\n}\n\n.font-38 {\n    font-size: 2.375rem !important;\n}\n\n.font-39 {\n    font-size: 2.4375rem !important;\n}\n\n.font-40 {\n    font-size: 2.5rem !important;\n}\n\n/* Font Size For responsive devices End */\n/* ============================ Extend Css End ======================== */\n/* ======================= WordPress Default Css Start =================== */\n.admin-bar .default-header .sticky-wrapper.sticky {\n    top: 32px;\n}\n\n.wp-block-search__label {\n    position: relative;\n    font-size: 24px;\n    font-weight: 500 !important;\n    font-family: var(--title-font);\n    line-height: 1em;\n    margin: -0.12em 0 25px 0;\n}\n\np.has-drop-cap {\n    margin-bottom: 20px;\n}\n\n.page--item p:last-child .alignright {\n    clear: right;\n}\n\n.blog-title,\n.pagi-title,\n.breadcumb-title {\n    word-break: break-word;\n}\n\n.blocks-gallery-caption,\n.wp-block-embed figcaption,\n.wp-block-image figcaption {\n    color: var(--body-color);\n}\n\n.bypostauthor,\n.gallery-caption {\n    display: block;\n}\n\n.page-links,\n.clearfix {\n    clear: both;\n}\n\n.page--item {\n    margin-bottom: 30px;\n}\n\n.page--item p {\n    line-height: 1.8;\n}\n\n.page--item .th-comment-form {\n    padding: 0;\n}\n\n.page--item .th-comments-wrap {\n    margin-left: 0;\n    margin-right: 0;\n    margin-top: 30px;\n}\n\n.content-none-search {\n    margin-top: 30px;\n}\n\n.wp-block-button.aligncenter {\n    text-align: center;\n}\n\n.alignleft {\n    display: inline;\n    float: left;\n    margin-bottom: 10px;\n    margin-right: 1.5em;\n}\n\n.alignright {\n    display: inline;\n    float: right;\n    margin-bottom: 10px;\n    margin-left: 1.5em;\n    margin-right: 1em;\n}\n\n.aligncenter {\n    clear: both;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 100%;\n}\n\n.gallery {\n    margin-bottom: 1.5em;\n    width: 100%;\n}\n\n.gallery-item {\n    display: inline-block;\n    text-align: center;\n    vertical-align: top;\n    width: 100%;\n    padding: 0 5px;\n}\n\n.wp-block-columns {\n    margin-bottom: 1em;\n}\n\nfigure.gallery-item {\n    margin-bottom: 10px;\n    display: inline-block;\n}\n\nfigure.wp-block-gallery {\n    margin-bottom: 14px;\n}\n\n.gallery-columns-2 .gallery-item {\n    max-width: 50%;\n}\n\n.gallery-columns-3 .gallery-item {\n    max-width: 33.33%;\n}\n\n.gallery-columns-4 .gallery-item {\n    max-width: 25%;\n}\n\n.gallery-columns-5 .gallery-item {\n    max-width: 20%;\n}\n\n.gallery-columns-6 .gallery-item {\n    max-width: 16.66%;\n}\n\n.gallery-columns-7 .gallery-item {\n    max-width: 14.28%;\n}\n\n.gallery-columns-8 .gallery-item {\n    max-width: 12.5%;\n}\n\n.gallery-columns-9 .gallery-item {\n    max-width: 11.11%;\n}\n\n.gallery-caption {\n    display: block;\n    font-size: 12px;\n    color: var(--body-color);\n    line-height: 1.5;\n    padding: 0.5em 0;\n}\n\n.wp-block-cover p:not(.has-text-color),\n.wp-block-cover-image-text,\n.wp-block-cover-text {\n    color: var(--white-color);\n}\n\n.wp-block-cover {\n    margin-bottom: 15px;\n}\n\n.wp-caption-text {\n    text-align: center;\n}\n\n.wp-caption {\n    margin-bottom: 1.5em;\n    max-width: 100%;\n}\n\n.wp-caption .wp-caption-text {\n    margin: 0.5em 0;\n    font-size: 14px;\n}\n\n.wp-block-media-text,\n.wp-block-media-text.alignwide,\nfigure.wp-block-gallery {\n    margin-bottom: 30px;\n}\n\n.wp-block-media-text.alignwide {\n    background-color: var(--smoke-color);\n}\n\n.editor-styles-wrapper .has-large-font-size,\n.has-large-font-size {\n    line-height: 1.4;\n}\n\n.wp-block-latest-comments a {\n    color: inherit;\n}\n\n.wp-block-button {\n    margin-bottom: 10px;\n}\n\n.wp-block-button:last-child {\n    margin-bottom: 0;\n}\n\n.wp-block-button .wp-block-button__link {\n    color: #fff;\n}\n\n.wp-block-button .wp-block-button__link:hover {\n    color: #fff;\n    background-color: var(--theme-color);\n}\n\n.wp-block-button.is-style-outline .wp-block-button__link {\n    background-color: transparent;\n    border-color: var(--title-color);\n    color: var(--title-color);\n}\n\n.wp-block-button.is-style-outline .wp-block-button__link:hover {\n    color: #fff;\n    background-color: var(--theme-color);\n    border-color: var(--theme-color);\n}\n\n.wp-block-button.is-style-squared .wp-block-button__link {\n    border-radius: 0;\n}\n\nol.wp-block-latest-comments li {\n    margin: 15px 0;\n}\n\nul.wp-block-latest-posts {\n    padding: 0;\n    margin: 0;\n    margin-bottom: 15px;\n}\n\nul.wp-block-latest-posts a {\n    color: inherit;\n}\n\nul.wp-block-latest-posts a:hover {\n    color: var(--theme-color);\n}\n\nul.wp-block-latest-posts li {\n    margin: 15px 0;\n}\n\n.wp-block-search {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.wp-block-search .wp-block-search__inside-wrapper {\n    border: 1px solid #EAEBEE;\n    border-radius: 10px 0 0 10px;\n    overflow: hidden;\n}\n\n.wp-block-search .wp-block-search__input {\n    width: 100%;\n    max-width: 100%;\n    padding-left: 20px;\n    border: 0;\n}\n\n.wp-block-search .wp-block-search__button {\n    margin: 0;\n    min-width: 110px;\n    border: none;\n    color: #fff;\n    border-radius: 10px;\n    background-color: var(--theme-color);\n}\n\n.wp-block-search .wp-block-search__button.has-icon {\n    min-width: 55px;\n}\n\n.wp-block-search .wp-block-search__button:hover {\n    background-color: var(--title-color);\n}\n\n.wp-block-search.wp-block-search__button-inside .wp-block-search__inside-wrapper {\n    padding: 0;\n    border: none;\n}\n\n.wp-block-search.wp-block-search__button-inside .wp-block-search__inside-wrapper .wp-block-search__input {\n    padding: 0 8px 0 25px;\n}\n\nul.wp-block-rss a {\n    color: inherit;\n}\n\n.wp-block-group.has-background {\n    padding: 15px 15px 1px;\n    margin-bottom: 30px;\n}\n\n.wp-block-table td,\n.wp-block-table th {\n    border-color: rgba(0, 0, 0, 0.1);\n}\n\n.wp-block-table.is-style-stripes {\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    margin-bottom: 30px;\n}\n\n.wp-block-table.is-style-stripes {\n    border: 0;\n    margin-bottom: 30px;\n    border-bottom: 0;\n}\n\n.wp-block-table.is-style-stripes th,\n.wp-block-table.is-style-stripes td {\n    border-color: var(--border-color);\n}\n\n.logged-in .will-sticky .sticky-active.active,\n.logged-in .preloader .btn {\n    top: 32px;\n}\n\n@media (max-width: 782px) {\n\n    .logged-in .will-sticky .sticky-active.active,\n    .logged-in .preloader .btn {\n        top: 46px;\n    }\n}\n\n@media (max-width: 600px) {\n\n    .logged-in .will-sticky .sticky-active.active,\n    .logged-in .preloader .btn {\n        top: 0;\n    }\n}\n\n.post-password-form {\n    margin-bottom: 30px;\n    margin-top: 20px;\n}\n\n.post-password-form p {\n    display: flex;\n    position: relative;\n    gap: 15px;\n    /* Extra small devices */\n}\n\n@media (max-width: 575px) {\n    .post-password-form p {\n        flex-wrap: wrap;\n    }\n}\n\n.post-password-form label {\n    display: flex;\n    align-items: center;\n    flex: auto;\n    margin-bottom: 0;\n    line-height: 1;\n    margin-top: 0;\n    gap: 15px;\n    /* Extra small devices */\n}\n\n@media (max-width: 575px) {\n    .post-password-form label {\n        flex-wrap: wrap;\n    }\n}\n\n.post-password-form input {\n    width: 100%;\n    border: none;\n    height: 55px;\n    padding-left: 25px;\n    color: var(--body-color);\n    ;\n    border: 1px solid var(--border-color);\n}\n\n.post-password-form input[type=submit] {\n    padding-left: 0;\n    padding-right: 0;\n    margin: 0;\n    width: 140px;\n    border: none;\n    color: #fff;\n    background-color: var(--theme-color);\n    text-align: center;\n}\n\n.post-password-form input[type=submit]:hover {\n    background-color: var(--title-color);\n}\n\n.page-links {\n    clear: both;\n    margin: 0 0 1.5em;\n    padding-top: 1em;\n}\n\n.page-links>.page-links-title {\n    margin-right: 10px;\n}\n\n.page-links>span:not(.page-links-title):not(.screen-reader-text),\n.page-links>a {\n    display: inline-block;\n    padding: 5px 13px;\n    background-color: var(--white-color);\n    color: var(--title-color);\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    margin-right: 10px;\n}\n\n.page-links>span:not(.page-links-title):not(.screen-reader-text):hover,\n.page-links>a:hover {\n    opacity: 0.8;\n    color: var(--white-color);\n    background-color: var(--theme-color);\n    border-color: transparent;\n}\n\n.page-links>span:not(.page-links-title):not(.screen-reader-text).current,\n.page-links>a.current {\n    background-color: var(--theme-color);\n    color: var(--white-color);\n    border-color: transparent;\n}\n\n.page-links span.screen-reader-text {\n    display: none;\n}\n\n.blog-single .wp-block-archives-dropdown {\n    margin-bottom: 30px;\n}\n\n.blog-single.format-quote,\n.blog-single.format-link,\n.blog-single.tag-sticky-2,\n.blog-single.sticky {\n    position: relative;\n}\n\n.blog-single.format-quote .blog-content,\n.blog-single.format-link .blog-content,\n.blog-single.tag-sticky-2 .blog-content,\n.blog-single.sticky .blog-content {\n    background-color: var(--smoke-color);\n    border: none;\n    padding: 40px;\n    border-radius: 15px;\n}\n\n.blog-single.format-quote .blog-content:before,\n.blog-single.format-link .blog-content:before,\n.blog-single.tag-sticky-2 .blog-content:before,\n.blog-single.sticky .blog-content:before {\n    display: none;\n}\n\n.blog-single.format-quote:before,\n.blog-single.format-link:before,\n.blog-single.tag-sticky-2:before,\n.blog-single.sticky:before {\n    content: \"\\f0c1\";\n    position: absolute;\n    font-family: \"Font Awesome 6 Pro\";\n    font-size: 5rem;\n    opacity: 0.3;\n    right: 15px;\n    line-height: 1;\n    top: 15px;\n    color: var(--theme-color);\n    z-index: 1;\n}\n\n.blog-single.tag-sticky-2::before,\n.blog-single.sticky::before {\n    content: \"\\f08d\";\n    position: absolute;\n    font-family: var(--icon-font);\n    font-size: 16px;\n    font-weight: 500;\n    opacity: 1;\n    right: 0;\n    top: 0;\n    color: var(--white-color);\n    background-color: var(--theme-color);\n    z-index: 1;\n    height: 44px;\n    width: 44px;\n    line-height: 44px;\n    text-align: center;\n    border-radius: 0 15px 0 4px;\n}\n\n.blog-single.format-quote blockquote,\n.blog-single.format-quote .wp-block-quote {\n    background: var(--white-color);\n    margin-bottom: 0;\n}\n\n.blog-single.format-quote:before {\n    content: \"\\f10e\";\n    top: 0;\n}\n\n.blog-single .blog-content .wp-block-categories-dropdown.wp-block-categories,\n.blog-single .blog-content .wp-block-archives-dropdown {\n    display: block;\n    margin-bottom: 30px;\n}\n\n.blog-single.format-chat .entry-content>p:nth-child(2n) {\n    background: var(--smoke-color);\n    padding: 5px 20px;\n}\n\n.blog-details .blog-single:before {\n    display: none;\n}\n\n.blog-details .blog-single .blog-content {\n    background-color: transparent;\n    overflow: hidden;\n}\n\n.blog-details .blog-single .blog-content p:last-child {\n    margin-bottom: 0;\n}\n\n.blog-details .blog-single.format-chat .blog-meta {\n    margin-bottom: 20px;\n}\n\n.blog-details .blog-single.format-chat .blog-content>p:nth-child(2n) {\n    background: var(--smoke-color);\n    padding: 5px 20px;\n}\n\n.blog-details .blog-single.tag-sticky-2,\n.blog-details .blog-single.sticky,\n.blog-details .blog-single.format-quote,\n.blog-details .blog-single.format-link {\n    box-shadow: none;\n    background-color: transparent;\n}\n\n.blog-details .blog-single.tag-sticky-2:before,\n.blog-details .blog-single.sticky:before,\n.blog-details .blog-single.format-quote:before,\n.blog-details .blog-single.format-link:before {\n    display: none;\n}\n\n.blog-single .wp-block-tag-cloud {\n    margin-bottom: 20px;\n}\n\n.blog-single .wp-block-tag-cloud a {\n    background-color: var(--smoke-color);\n    color: var(--title-color);\n    box-shadow: none;\n}\n\n.th-search {\n    background-color: #f3f3f3;\n    margin-bottom: 30px;\n    border: 1px solid #f3f3f3;\n}\n\n.th-search .search-grid-content {\n    padding: 30px;\n    /* Small devices */\n}\n\n@media (max-width: 767px) {\n    .th-search .search-grid-content {\n        padding: 20px;\n    }\n}\n\n.th-search .search-grid-title {\n    font-size: 20px;\n    margin-bottom: 5px;\n    margin-top: 0;\n}\n\n.th-search .search-grid-title a {\n    color: inherit;\n}\n\n.th-search .search-grid-title a:hover {\n    color: var(--theme-color);\n}\n\n.th-search .search-grid-meta>* {\n    display: inline-block;\n    margin-right: 15px;\n    font-size: 14px;\n}\n\n.th-search .search-grid-meta>*:last-child {\n    margin-right: 0;\n}\n\n.th-search .search-grid-meta a,\n.th-search .search-grid-meta span {\n    color: var(--body-color);\n}\n\n/* Large devices */\n@media (max-width: 1199px) {\n\n    .blog-single.format-quote:before,\n    .blog-single.format-link:before,\n    .blog-single.tag-sticky-2:before,\n    .blog-single.sticky:before {\n        font-size: 14px;\n        padding: 8px 16px;\n    }\n\n    .blog-single.format-quote:before {\n        top: 15px;\n    }\n}\n\n/* Small devices */\n@media (max-width: 767px) {\n\n    .blog-single.format-quote:before,\n    .blog-single.format-link:before,\n    .blog-single.tag-sticky-2:before,\n    .blog-single.sticky:before {\n        font-size: 14px;\n        padding: 8px 16px;\n    }\n}\n\n@media (max-width: 768px) {\n    .wp-block-latest-comments {\n        padding-left: 10px;\n    }\n\n    .page--content.clearfix+.th-comment-form {\n        margin-top: 24px;\n    }\n}\n\n.site {\n    overflow-x: visible;\n}\n\n/* ======================= WordPress Default Css End =================== */\n/* ================================= Typography Css Start =========================== */\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    font-family: var(--body-font);\n    color: var(--body-color);\n    ;\n    word-break: break-word;\n    /* background-color: var(--body-bg); */\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n@media screen and (max-width: 767px) {\n    body {\n        font-size: 0.9375rem;\n    }\n}\n\n@media screen and (max-width: 575px) {\n    body {\n        font-size: 0.875rem;\n    }\n}\n\np {\n    font-size: inherit;\n    font-weight: 400;\n    margin: 0;\n    line-height: 1.6;\n    padding-left: 10px;\n}\n\nspan {\n    display: inline-block;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin: 0 0 16px 0;\n    font-family: var(--heading-font);\n    color: var(--heading-color);\n    line-height: 1.2;\n    font-weight: 700;\n}\n\nh1 {\n    font-size: var(--heading-one);\n}\n\nh2 {\n    font-size: var(--heading-two);\n}\n\nh3 {\n    font-size: var(--heading-three);\n}\n\nh4 {\n    font-size: var(--heading-four);\n}\n\nh5 {\n    font-size: var(--heading-five);\n}\n\nh6 {\n    font-size: var(--heading-six);\n    font-weight: 800;\n}\n\nh1>a,\nh2>a,\nh3>a,\nh4>a,\nh5>a,\nh6>a {\n    font-weight: inherit;\n    font-size: inherit;\n    color: inherit;\n    transition: 0.2s linear;\n    line-height: inherit;\n}\n\nh1>a:hover,\nh2>a:hover,\nh3>a:hover,\nh4>a:hover,\nh5>a:hover,\nh6>a:hover {\n    color: var(--main);\n}\n\na {\n    display: inline-block;\n    transition: 0.2s linear;\n    text-decoration: none;\n    /* color: #0661e9; */\n    color: #000000;\n    font-weight: 600;\n}\n\na:hover {\n    color: #1d72f2;\n}\n\nimg {\n    max-width: 100%;\n    height: auto;\n}\n\nselect {\n    cursor: pointer;\n}\n\nul,\nol {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\nbutton {\n    border: 0;\n    background-color: transparent;\n}\n\nbutton:focus {\n    outline: none;\n    box-shadow: none;\n}\n\n.form-select:focus {\n    outline: 0;\n    box-shadow: none;\n}\n\n/* ================================= Typography Css End =========================== */\n/* ================================= Margin Css Start =========================== */\n.mt--100 {\n    margin-top: -100px !important;\n}\n\n.mt--24 {\n    margin-top: -24px !important;\n}\n\n.mb-64 {\n    margin-bottom: clamp(2rem, -0.434rem + 5.071vw, 4rem) !important;\n}\n\n.mt-64 {\n    margin-top: clamp(2rem, -0.434rem + 5.071vw, 4rem) !important;\n}\n\n.mt-48 {\n    margin-top: clamp(1.5rem, -0.326rem + 3.803vw, 3rem) !important;\n}\n\n.mb-48 {\n    margin-bottom: clamp(1.5rem, -0.326rem + 3.803vw, 3rem) !important;\n}\n\n.mt-40 {\n    margin-top: clamp(1.5rem, 0.283rem + 2.536vw, 2.5rem) !important;\n}\n\n.mb-40 {\n    margin-bottom: clamp(1.5rem, 0.283rem + 2.536vw, 2.5rem) !important;\n}\n\n.mt-32 {\n    margin-top: 32px !important;\n}\n\n@media screen and (max-width: 1199px) {\n    .mt-32 {\n        margin-top: 20px;\n    }\n}\n\n.mb-32 {\n    margin-bottom: 32px !important;\n}\n\n@media screen and (max-width: 1199px) {\n    .mb-32 {\n        margin-bottom: 20px;\n    }\n}\n\n.mt-24 {\n    margin-top: 24px !important;\n}\n\n@media screen and (max-width: 1199px) {\n    .mt-24 {\n        margin-top: 16px;\n    }\n}\n\n.mb-24 {\n    margin-bottom: 24px !important;\n}\n\n@media screen and (max-width: 1199px) {\n    .mb-24 {\n        margin-bottom: 16px;\n    }\n}\n\n.margin-y-120 {\n    margin-top: 60px;\n    margin-bottom: 60px;\n}\n\n@media (min-width: 576px) {\n    .margin-y-120 {\n        margin-top: 80px;\n        margin-bottom: 80px;\n    }\n}\n\n@media (min-width: 992px) {\n    .margin-y-120 {\n        margin-top: 120px;\n        margin-bottom: 120px;\n    }\n}\n\n.margin-t-120 {\n    margin-top: 60px;\n}\n\n@media (min-width: 576px) {\n    .margin-t-120 {\n        margin-top: 80px;\n    }\n}\n\n@media (min-width: 992px) {\n    .margin-t-120 {\n        margin-top: 120px;\n    }\n}\n\n.margin-b-120 {\n    margin-bottom: 60px;\n}\n\n@media (min-width: 576px) {\n    .margin-b-120 {\n        margin-bottom: 80px;\n    }\n}\n\n@media (min-width: 992px) {\n    .margin-b-120 {\n        margin-bottom: 120px;\n    }\n}\n\n.margin-y-60 {\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n\n@media (min-width: 576px) {\n    .margin-y-60 {\n        margin-top: 40px;\n        margin-bottom: 40px;\n    }\n}\n\n@media (min-width: 992px) {\n    .margin-y-60 {\n        margin-top: 60px;\n        margin-bottom: 60px;\n    }\n}\n\n.margin-t-60 {\n    margin-top: 30px;\n}\n\n@media (min-width: 576px) {\n    .margin-t-60 {\n        margin-top: 40px;\n    }\n}\n\n@media (min-width: 992px) {\n    .margin-t-60 {\n        margin-top: 60px;\n    }\n}\n\n.margin-b-60 {\n    margin-bottom: 30px;\n}\n\n@media (min-width: 576px) {\n    .margin-b-60 {\n        margin-bottom: 40px;\n    }\n}\n\n@media (min-width: 992px) {\n    .margin-b-60 {\n        margin-bottom: 60px;\n    }\n}\n\n/* ================================= Margin Css End =========================== */\n/* ================================= Padding Css Start =========================== */\n.padding-y-120 {\n    padding-top: 60px;\n    padding-bottom: 60px;\n}\n\n@media (min-width: 576px) {\n    .padding-y-120 {\n        padding-top: 80px;\n        padding-bottom: 80px;\n    }\n}\n\n@media (min-width: 992px) {\n    .padding-y-120 {\n        padding-top: 120px;\n        padding-bottom: 120px;\n    }\n}\n\n.padding-t-120 {\n    padding-top: 60px;\n}\n\n@media (min-width: 576px) {\n    .padding-t-120 {\n        padding-top: 80px;\n    }\n}\n\n@media (min-width: 992px) {\n    .padding-t-120 {\n        padding-top: 120px;\n    }\n}\n\n.padding-b-120 {\n    padding-bottom: 60px;\n}\n\n@media (min-width: 576px) {\n    .padding-b-120 {\n        padding-bottom: 80px;\n    }\n}\n\n@media (min-width: 992px) {\n    .padding-b-120 {\n        padding-bottom: 120px;\n    }\n}\n\n.padding-y-60 {\n    padding-top: 30px;\n    padding-bottom: 30px;\n}\n\n@media (min-width: 576px) {\n    .padding-y-60 {\n        padding-top: 40px;\n        padding-bottom: 40px;\n    }\n}\n\n@media (min-width: 992px) {\n    .padding-y-60 {\n        padding-top: 60px;\n        padding-bottom: 60px;\n    }\n}\n\n.padding-t-60 {\n    padding-top: 30px;\n}\n\n@media (min-width: 576px) {\n    .padding-t-60 {\n        padding-top: 40px;\n    }\n}\n\n@media (min-width: 992px) {\n    .padding-t-60 {\n        padding-top: 60px;\n    }\n}\n\n.padding-b-60 {\n    padding-bottom: 30px;\n}\n\n@media (min-width: 576px) {\n    .padding-b-60 {\n        padding-bottom: 40px;\n    }\n}\n\n@media (min-width: 992px) {\n    .padding-b-60 {\n        padding-bottom: 60px;\n    }\n}\n\n/* ================================= Padding Css End =========================== */\n/* =========================== Accordion Css start ============================= */\n.accordiantion_radius {\n    border-radius: 16px;\n    background: #FFF;\n}\n\n.common-accordion .accordion-item {\n    border: 1px solid var(--border-color);\n    background-color: var(--white) !important;\n    /* border-radius: 8px; */\n    overflow: hidden;\n\n}\n\n.common-accordion .accordion-item:not(:last-child) {\n    margin-bottom: 20px;\n    border-bottom: 3px solid #D9D9D9;\n}\n\n.common-accordion .accordion-header {\n    line-height: 1;\n}\n\n.common-accordion .accordion-body {\n    padding: 20px 0px;\n    padding-top: 0;\n}\n\n@media screen and (max-width: 575px) {\n    .common-accordion .accordion-body {\n        padding: 12px 0px;\n        padding-top: 0;\n    }\n}\n\n.common-accordion:first-of-type .accordion-button.collapsed {\n    /* border-radius: 5px; */\n    /* border-bottom: 3px solid #D9D9D9; */\n}\n\n.common-accordion:last-of-type .accordion-button.collapsed {\n    /* border-radius: 5px; */\n    /* border-bottom: 3px solid #D9D9D9; */\n}\n\n.common-accordion .accordion-button {\n    color: var(--heading-color);\n    font-size: 1.125rem;\n    padding: 20px 0px;\n    padding-right: 46px;\n    font-weight: 600;\n    font-size: clamp(1rem, 0.696rem + 0.634vw, 1.25rem);\n    font-family: var(--heading-font);\n}\n\n@media screen and (max-width: 575px) {\n    .common-accordion .accordion-button {\n        padding: 12px 20px;\n        padding-right: 36px;\n    }\n}\n\n.common-accordion .accordion-button::after {\n    background-image: none;\n}\n\n.common-accordion .accordion-button:focus {\n    box-shadow: none;\n}\n\n.common-accordion .accordion-button:not(.collapsed) {\n    background-color: transparent !important;\n    box-shadow: none;\n    color: var(--main);\n}\n\n.common-accordion .accordion-button:not(.collapsed)::after {\n    background-image: none;\n    color: var(--main);\n}\n\n.common-accordion .accordion-button[aria-expanded=true]::after,\n.common-accordion .accordion-button[aria-expanded=false]::after {\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900;\n    content: \"\\f106\";\n    color: var(--main);\n    display: inline-block;\n    position: absolute;\n    right: 30px;\n    height: unset;\n    font-size: 1rem;\n    text-align: center;\n}\n\n@media screen and (max-width: 575px) {\n\n    .common-accordion .accordion-button[aria-expanded=true]::after,\n    .common-accordion .accordion-button[aria-expanded=false]::after {\n        right: 20px;\n    }\n}\n\n.common-accordion .accordion-button[aria-expanded=false]::after {\n    content: \"\\f107\";\n    color: var(--heading-color);\n}\n\n/* ================================= Accordion Css End =========================== */\n/* ================================= Button Css Start =========================== */\n.btn-check:checked+.btn,\n.btn.active,\n.btn.show,\n.btn:first-child:active,\n:not(.btn-check)+.btn:active {\n    color: none;\n    background-color: none;\n    border-color: none;\n}\n\n.btn {\n    position: relative;\n    border-radius: 8px;\n    border: 1px solid transparent;\n    font-weight: 400;\n    font-family: var(--body-font);\n    color: var(--static-white) !important;\n    z-index: 1;\n    font-size: 0.875rem;\n    line-height: 1;\n    text-transform: capitalize;\n    padding: 14px 16px;\n}\n\n.btn:hover,\n.btn:focus,\n.btn:focus-visible {\n    box-shadow: none !important;\n}\n\n\n\n@media screen and (max-width: 991px) {\n    .btn {\n        padding: 12px 16px;\n    }\n}\n\n.btn-sm {\n    padding: 11px 16px !important;\n    font-size: 0.875rem;\n}\n\n@media screen and (max-width: 424px) {\n    .btn-sm {\n        padding: 10px !important;\n        font-size: 12px;\n    }\n}\n\n.btn-md {\n    padding: 17px 16px;\n}\n\n@media screen and (max-width: 424px) {\n    .btn-md {\n        padding: 10px;\n        font-size: 12px;\n    }\n}\n\n.btn-lg {\n    /* padding: 22px 40px; */\n    font-size: 1rem;\n}\n\n@media screen and (max-width: 991px) {\n    .btn-lg {\n        padding: 17px 32px;\n    }\n}\n\n.btn-lg-icon {\n    /* height: 60px; */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n@media screen and (max-width: 991px) {\n    .btn-lg-icon {\n        height: 50px;\n    }\n}\n\n.btn-xl {\n    padding: 20px 64px;\n    font-size: 1rem;\n}\n\n@media screen and (max-width: 991px) {\n    .btn-xl {\n        padding: 15px 36px;\n    }\n}\n\n.btn-icon {\n    width: 30px;\n    height: 30px;\n    background-color: var(--white) !important;\n    padding: 0;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: 0.2s linear;\n    font-size: 1.25rem;\n    margin-right: 20px;\n}\n\n.btn-icon img {\n    width: 60%;\n}\n\n@media screen and (max-width: 767px) {\n    .btn-icon {\n        width: 44px;\n        height: 44px;\n\n    }\n}\n\n.btn-icon--sm {\n    width: 44px;\n    height: 44px;\n}\n\n@media screen and (max-width: 767px) {\n    .btn-icon--sm {\n        width: 40px;\n        height: 40px;\n    }\n}\n\n.btn-icon:hover {\n    transform: scale(1.04);\n}\n\n.btn .icon-right {\n    margin-left: 8px;\n    font-size: 1rem;\n}\n\n.btn .icon-left {\n    margin-right: 8px;\n    font-size: 1rem;\n}\n\n.btn:active {\n    transform: scale(1.01);\n}\n\n.btn-main {\n    background-color: var(--main-bg) !important;\n    border: transparent !important;\n    z-index: 1;\n    border-radius: 30px !important;\n}\n\n.btn-main::before,\n.btn-main::after {\n    position: absolute;\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    border-radius: inherit;\n    background: var(--main-gradient);\n    z-index: -1;\n    transition: 0.2s linear;\n}\n\n.btn-main::after {\n    background: var(--main-gradient-rev);\n    visibility: hidden;\n    opacity: 0;\n}\n\n.btn-main:hover::after {\n    visibility: visible;\n    opacity: 1;\n}\n\n.btn-outline-main {\n    background-color: transparent !important;\n    border-color: var(--main) !important;\n    color: var(--main) !important;\n}\n\n.btn-outline-main:hover {\n    background-color: var((--main)/0.15) !important;\n    border-color: var((--main)/0.4) !important;\n}\n\n.btn-white {\n    background-color: var(--white) !important;\n    border-color: var(--white) !important;\n    color: var(--black) !important;\n}\n\n.btn-white:hover {\n    background-color: var(--main) !important;\n    border-color: var(--main) !important;\n    color: var(--static-white) !important;\n}\n\n.btn-light {\n    background-color: var(--white-one) !important;\n    border-color: var(--white-one) !important;\n    color: var(--black) !important;\n}\n\n.btn-light:hover {\n    background-color: var(--main) !important;\n    border-color: var(--main) !important;\n    color: var(--white) !important;\n}\n\n.btn-outline-light {\n    background-color: transparent !important;\n    border-color: var(--white-one) !important;\n    color: var(--black) !important;\n    font-weight: 500;\n}\n\n.btn-outline-light:hover {\n    background-color: var(--black) !important;\n    border-color: var(--black) !important;\n    color: var(--white) !important;\n}\n\n.btn-black {\n    background-color: var(--black) !important;\n    border-color: var(--black) !important;\n    border-width: 2px;\n    color: var(--white) !important;\n}\n\n.btn-black:hover {\n    background-color: transparent !important;\n    border-color: var(--black) !important;\n    color: var(--black) !important;\n}\n\n.btn-outline-black {\n    background-color: transparent !important;\n    border-color: var(--black) !important;\n    border-width: 2px;\n    color: var(--black) !important;\n    font-weight: 600;\n}\n\n.btn-outline-black:hover {\n    background-color: var(--black) !important;\n    border-color: var(--black) !important;\n    color: var(--white) !important;\n}\n\n.btn-static-black {\n    background-color: var(--static-black) !important;\n    border-color: var(--static-black) !important;\n    border-width: 2px;\n    color: var(--static-white) !important;\n}\n\n.btn-static-black:hover {\n    background-color: transparent !important;\n    border-color: var(--static-black) !important;\n    color: var(--static-black) !important;\n    font-weight: 600 !important;\n}\n\n.btn-static-outline-black {\n    background-color: transparent !important;\n    border-color: var(--static-black) !important;\n    border-width: 2px;\n    color: var(--static-black) !important;\n    font-weight: 600;\n}\n\n.btn-static-outline-black:hover {\n    background-color: var(--static-black) !important;\n    border-color: var(--static-black) !important;\n    color: var(--static-white) !important;\n}\n\n/* ================================= Button Css End =========================== */\n/* ================================= Form Css Start =========================== */\n/* input Start */\n/* .common-input {\n    border-radius: 5px;\n    font-weight: 400;\n    outline: none;\n    width: 100%;\n    padding: 17px 16px;\n    background-color: transparent !important;\n    border: 1px solid var(--border-color);\n    color: var(--black);\n    line-height: 1;\n    font-size: 1.0625rem;\n} */\n\n.common-input {\n    border-radius: 30px !important;\n    /* More rounded corners for an almost circular edge */\n    font-weight: 400;\n    outline: none;\n    width: 100%;\n    padding: 17px 16px;\n    /* Spacious padding */\n    background-color: transparent !important;\n    /* Transparent background */\n    border: 1px solid var(--border-color);\n    /* Subtle border */\n    color: var(--black);\n    /* Text color */\n    line-height: 1;\n    font-size: 1.0625rem;\n    /* Font size as requested */\n    transition: border-color 0.3s ease, box-shadow 0.3s ease;\n    /* Smooth transition on focus */\n}\n\n.spl_burron {\n    margin-right: 0;\n    /* padding: 8px; */\n    padding: 6px !important;\n}\n\n.spl_burron img {\n    width: 100%;\n}\n\n.auto-suggestion-input {\n    border-radius: 5px !important;\n    font-weight: 400;\n    outline: none;\n    width: 100%;\n    padding: 17px 16px;\n    background-color: transparent !important;\n    border: 1px solid var(--border-color);\n    color: var(--black);\n    line-height: 1;\n    font-size: 1.0625rem;\n}\n\n/* When the input field is focused */\n.common-input:focus {\n    border-color: var(--main);\n    /* Purple border on focus */\n    box-shadow: 0 0 5px rgba(94, 53, 242, 0.2);\n    /* Subtle shadow on focus */\n    background-color: #fff;\n    /* Optional: Give a light background on focus for better readability */\n}\n\n\n@media screen and (max-width: 991px) {\n    .common-input {\n        padding: 10px 16px;\n    }\n}\n\n.common-input::placeholder {\n    color: var(--black-three);\n    font-size: 0.875rem;\n    transition: 0.25s linear;\n    font-weight: 400;\n}\n\n.common-input--md {\n    padding: 13px 16px;\n    font-size: 0.9375rem;\n}\n\n/* .common-input--lg {\n    padding: 25px 24px;\n} */\n\n@media screen and (max-width: 767px) {\n    .common-input--lg {\n        padding: 18px 24px;\n    }\n}\n\n.common-input:focus {\n    border-color: var(--main);\n    box-shadow: none;\n}\n\n.common-input:focus::placeholder {\n    visibility: hidden;\n    opacity: 0;\n}\n\n.common-input:disabled,\n.common-input[readonly] {\n    background-color: var((--black)/0.2);\n    opacity: 1;\n    border: 0;\n}\n\n.common-input[type=password] {\n    color: var((--black)/0.5);\n}\n\n.common-input[type=password]:focus {\n    color: var(--black);\n}\n\n.common-input--withIcon {\n    padding-right: 50px !important;\n}\n\n.common-input--withLeftIcon {\n    padding-left: 40px !important;\n}\n\n.common-input--bg {\n    background-color: var(--gray-seven) !important;\n    border-color: var(--gray-seven) !important;\n}\n\n.common-input--bg::placeholder {\n    color: var(--black-three);\n}\n\n/* input End */\n/* input icon */\n.input-icon {\n    position: absolute;\n    right: 24px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--heading-color);\n    font-size: 0.875rem;\n}\n\n.input-icon--left {\n    left: 10px;\n    right: auto;\n}\n\ntextarea+.input-icon {\n    top: 15px;\n    transform: translateY(0);\n}\n\n/* input icon */\n/* Label */\n.form-label {\n    margin-bottom: 6px;\n    font-size: 0.875rem;\n    color: var(--heading-color);\n    font-weight: 500;\n}\n\n/* Form Select */\nselect option {\n    background-color: var(--white);\n}\n\n.select-has-icon {\n    position: relative;\n}\n\n.select-has-icon::before {\n    position: absolute;\n    content: \"\\f107\";\n    right: 20px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900;\n    font-size: 0.75rem;\n    color: var(--main);\n    transition: 0.2s linear;\n    pointer-events: none;\n    color: var(--body-color) !important;\n}\n\n.select-has-icon.icon-black::before {\n    -webkit-text-fill-color: var(--black);\n}\n\n.select-has-icon select {\n    background-image: none;\n    -webkit-appearance: none;\n    padding: 19px 24px;\n    font-size: 1rem;\n}\n\n@media screen and (max-width: 991px) {\n    .select-has-icon select {\n        padding: 12px 24px;\n    }\n}\n\n.select-has-icon .common-input {\n    padding-right: 30px !important;\n}\n\n.select {\n    color: var((--black)/0.6) !important;\n    padding: 16px 24px;\n    background-color: transparent;\n}\n\n@media screen and (max-width: 991px) {\n    .select {\n        padding: 11px 24px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .select {\n        padding: 9px 24px;\n        font-size: 0.9375rem;\n    }\n}\n\n.select:focus {\n    border-color: var(--main);\n    color: var(--black) !important;\n    outline: none;\n}\n\n.select option {\n    background-color: var(--white);\n    color: var(--heading-color);\n}\n\n/* Form Select End */\ntextarea.common-input {\n    height: 140px;\n}\n\n@media screen and (max-width: 767px) {\n    textarea.common-input {\n        height: 110px;\n    }\n}\n\n/* Autofill Css */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\ntextarea:-webkit-autofill:active {\n    -webkit-transition: background-color 5000s ease-in-out 0s;\n    transition: background-color 5000s ease-in-out 0s;\n}\n\ninput:-webkit-autofill,\ntextarea:-webkit-autofill,\nselect:-webkit-autofill,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 1000px transparent inset;\n    -webkit-text-fill-color: var(--heading-color) !important;\n    caret-color: var(--heading-color);\n}\n\n/* Autofill Css End */\n/* Show Hide Password */\ninput#your-password,\ninput#confirm-password {\n    padding-right: 50px;\n}\n\n.password-show-hide {\n    position: absolute;\n    right: 20px;\n    z-index: 5;\n    cursor: pointer;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var((--black)/0.4);\n}\n\n/* Number Arrow None */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n}\n\ninput[type=number] {\n    -moz-appearance: textfield;\n}\n\n/* Custom Checkbox & Radio Css Start */\n.common-check {\n    margin-bottom: 16px;\n}\n\n.common-check:last-child {\n    margin-bottom: 0;\n}\n\n.common-check a {\n    display: inline;\n}\n\n.common-check.common-radio .form-check-input {\n    border-radius: 50%;\n}\n\n.common-check.common-radio .form-check-input:checked {\n    background-color: transparent !important;\n}\n\n.common-check.common-radio .form-check-input:checked::after {\n    visibility: visible;\n    opacity: 1;\n    -webkit-transform: translate(-50%, -50%) scale(1);\n    transform: translate(-50%, -50%) scale(1);\n}\n\n.common-check .form-check-input {\n    transition: 0.2s linear;\n    box-shadow: none;\n    background-color: transparent;\n    box-shadow: none !important;\n    border: 0;\n    position: relative;\n    border-radius: 3px;\n    width: 18px;\n    height: 18px;\n    border: 1px solid var(--black);\n    cursor: pointer;\n    transition: 0.2s linear;\n    margin-top: 0;\n}\n\n\n.common-check .form-check-input::before {\n    position: absolute;\n    content: \"\\f00c\";\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900;\n    color: var(--static-white);\n    font-size: 0.6875rem;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    transition: 0.2s linear;\n    visibility: hidden;\n    opacity: 0;\n}\n\n.common-check .form-check-input::after {\n    position: absolute;\n    content: \"\";\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%) scale(0.2);\n    transform: translate(-50%, -50%) scale(0.2);\n    width: 10px;\n    height: 10px;\n    background-color: var(--main);\n    border-radius: 50%;\n    transition: 0.2s linear;\n    z-index: 1;\n    visibility: hidden;\n    opacity: 0;\n}\n\n.common-check .form-check-input:checked {\n    background-color: var(--main) !important;\n    border-color: var(--main) !important;\n    box-shadow: none;\n}\n\n\n.common-check .form-check-input:checked[type=checkbox] {\n    background-image: none;\n}\n\n.common-check .form-check-input:checked::before {\n    visibility: visible;\n    opacity: 1;\n}\n\n.common-check .form-check-label {\n    font-weight: 500;\n    width: calc(100% - 18px);\n    padding-left: 12px;\n    cursor: pointer;\n    font-size: 0.875rem;\n    color: var(--heading-color);\n    font-family: var(--poppins-font);\n}\n\n@media screen and (max-width: 424px) {\n    .common-check label {\n        font-size: 0.9375rem;\n    }\n}\n\n@media screen and (max-width: 424px) {\n    .common-check a {\n        font-size: 0.9375rem;\n    }\n}\n\n/* Custom Checkbox & Radio Css End */\n/* ================================= Form Css End =========================== */\n/* ================================= Pagination Css Start =========================== */\n.common-pagination {\n    flex-wrap: wrap;\n    justify-content: center;\n    margin-top: 64px;\n    gap: 8px;\n}\n\n@media screen and (max-width: 1199px) {\n    .common-pagination {\n        margin-top: 48px;\n    }\n}\n\n@media screen and (max-width: 991px) {\n    .common-pagination {\n        margin-top: 40px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .common-pagination {\n        margin-top: 32px;\n    }\n}\n\n.common-pagination .page-item.active .page-link {\n    color: var(--white);\n    background-color: var(--black);\n}\n\n.common-pagination .page-item .page-link {\n    border-radius: 8px;\n    width: 42px;\n    height: 43px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: transparent;\n    font-weight: 600;\n    padding: 0;\n    color: var(--heading-color);\n    border: 1px solid var((--black)/0.3);\n    font-size: 1rem;\n}\n\n@media screen and (max-width: 991px) {\n    .common-pagination .page-item .page-link {\n        width: 48px;\n        height: 48px;\n    }\n}\n\n.common-pagination .page-item .page-link:hover,\n.common-pagination .page-item .page-link:focus,\n.common-pagination .page-item .page-link:focus-visible {\n    color: var(--white);\n    background-color: var(--black);\n}\n\n.common-pagination .page-item .page-link:focus {\n    box-shadow: none;\n}\n\n.common-pagination .page-item:last-child .page-link {\n    width: unset;\n    height: unset;\n    background-color: var(--section-bg);\n    border-color: var(--section-bg);\n    padding: 9px 16px;\n}\n\n.common-pagination .page-item:last-child .page-link:hover,\n.common-pagination .page-item:last-child .page-link:focus,\n.common-pagination .page-item:last-child .page-link:focus-visible {\n    color: var(--white);\n    background-color: var(--black);\n}\n\n/* ================================= Pagination Css End =========================== */\n/* ================================= Tab Css Start =========================== */\n.common-tab {\n    margin-bottom: 20px;\n    gap: 16px;\n    /* Style Icon */\n}\n\n@media screen and (max-width: 991px) {\n    .common-tab {\n        gap: 8px;\n    }\n}\n\n.common-tab .nav-item {\n    border-bottom: 0;\n}\n\n.common-tab .nav-item .nav-link {\n    color: var(--heading-color);\n    padding: 7px 16px !important;\n    background-color: transparent;\n    transition: 0.2s linear;\n    border-radius: 8px;\n    border: 1px solid var(--gray-five);\n    text-transform: capitalize;\n    font-weight: 500;\n    overflow: hidden;\n    font-size: 0.875rem;\n}\n\n@media screen and (max-width: 991px) {\n    .common-tab .nav-item .nav-link {\n        padding: 5px 10px !important;\n    }\n}\n\n.common-tab .nav-item .nav-link.active {\n    color: var(--white) !important;\n    background-color: var(--heading-color) !important;\n    border-color: var(--heading-color) !important;\n    font-weight: 300;\n}\n\n.common-tab .nav-item .nav-link:hover {\n    color: var(--main);\n    background-color: var(--white);\n}\n\n.common-tab.style-icon .nav-item .nav-link {\n    padding: 0 !important;\n    border: 0 !important;\n    background-color: transparent !important;\n    overflow: unset;\n}\n\n.common-tab.style-icon .nav-item .nav-link .product-category-list__item {\n    box-shadow: 0px 5px 10px 0px rgba(204, 204, 204, 0.25);\n}\n\n.common-tab.style-icon .nav-item .nav-link .product-category-list__item .text {\n    display: none;\n}\n\n.common-tab.style-icon .nav-item .nav-link.active .product-category-list__item {\n    padding: 10px;\n    height: unset;\n    width: unset;\n    border-radius: 50px !important;\n    border: 1px solid var(--main);\n    background-color: var(--white);\n    box-shadow: 0px 5px 10px 0px rgba(204, 204, 204, 0.25);\n    color: var(--heading-color);\n    font-weight: 500;\n}\n\n.common-tab.style-icon .nav-item .nav-link.active .product-category-list__item .text {\n    display: block;\n}\n\n/* Style Gradient */\n.tab-gradient {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.tab-gradient .nav-item .nav-link {\n    background-color: transparent !important;\n    position: relative;\n    z-index: 1;\n    color: var(--heading-color);\n    font-size: 1.125rem;\n    text-transform: capitalize;\n    font-weight: 400;\n    padding: 14px 50px;\n}\n\n@media screen and (max-width: 1199px) {\n    .tab-gradient .nav-item .nav-link {\n        padding: 10px 30px;\n        font-size: 1rem;\n    }\n}\n\n.tab-gradient .nav-item .nav-link::before,\n.tab-gradient .nav-item .nav-link::after {\n    position: absolute;\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    background: var(--white);\n    left: 0;\n    top: 0;\n    border-radius: inherit;\n    z-index: -1;\n}\n\n.tab-gradient .nav-item .nav-link::after {\n    background: var(--main-gradient);\n    visibility: hidden;\n    opacity: 0;\n}\n\n.tab-gradient .nav-item .nav-link.active {\n    color: var(--white);\n    font-weight: 300;\n}\n\n.tab-gradient .nav-item .nav-link.active::before {\n    visibility: hidden;\n    opacity: 0;\n}\n\n.tab-gradient .nav-item .nav-link.active::after {\n    visibility: visible;\n    opacity: 1;\n}\n\n/* Bordered Tab */\n.tab-bordered {\n    gap: 32px;\n    margin-bottom: 0px;\n}\n\n@media screen and (max-width: 1199px) {\n    .tab-bordered {\n        gap: 24px;\n    }\n}\n\n@media screen and (max-width: 991px) {\n    .tab-bordered {\n        gap: 16px;\n    }\n}\n\n@media screen and (max-width: 575px) {\n    .tab-bordered {\n        gap: 8px;\n        margin-bottom: 24px;\n    }\n}\n\n.tab-bordered .nav-link {\n    background-color: transparent;\n    border: 1px solid var(--gray-five);\n    border-radius: 5px;\n    color: var(--body-color);\n    padding: 5px 8px;\n}\n\n@media (min-width: 575px) {\n    .tab-bordered .nav-link {\n        background-color: transparent;\n        padding: 0;\n        color: var(--body-color) !important;\n        font-size: 14px;\n        padding-bottom: 16px !important;\n        border: 0;\n        border-bottom: 2px solid transparent;\n        border-radius: 0;\n    }\n}\n\n.tab-bordered .nav-link.active {\n    background-color: transparent;\n    color: var(--heading-color) !important;\n    font-weight: 600;\n    border-color: var(--heading-color) !important;\n}\n\n.tab-bordered .nav-link.active .star-rating__text {\n    color: var(--heading-color) !important;\n    font-weight: 600;\n}\n\n/* ================================= Tab Css End =========================== */\n/* ======================= Common Table Css Start ======================= */\n.table {\n    color: var(--white);\n    margin-bottom: 0;\n    min-width: max-content;\n    border-collapse: separate;\n    border-spacing: 0 24px;\n    /* Style Two */\n}\n\n.table> :not(caption)>*>* {\n    border-bottom: 0;\n}\n\n.table tr th {\n    padding-left: 0;\n    padding: 20px 16px;\n    color: var(--heading-color);\n    background-color: var(--section-bg);\n}\n\n.table tr th:not(:last-child) {\n    border-radius: 0;\n}\n\n.table tr th:not(:first-child) {\n    border-radius: 0;\n}\n\n.table tr th:first-child {\n    border-radius: 8px 0 0 8px;\n}\n\n.table tr th:last-child {\n    border-radius: 0 8px 8px 0;\n}\n\n.table tr th,\n.table tr td {\n    text-align: center;\n    vertical-align: middle;\n}\n\n.table tr th:first-child,\n.table tr td:first-child {\n    text-align: left;\n}\n\n.table tr th:last-child,\n.table tr td:last-child {\n    text-align: right;\n}\n\n.table thead tr {\n    border-bottom: 1px solid var((--white)/0.2);\n}\n\n.table thead tr th {\n    font-size: clamp(1rem, 0.848rem + 0.317vw, 1.125rem);\n    font-weight: 500;\n}\n\n.table tbody tr {\n    border-bottom: 1px solid var((--white)/0.2);\n}\n\n.table tbody tr:last-child {\n    border-bottom: 0;\n}\n\n.table tbody tr td {\n    font-size: clamp(0.875rem, 0.723rem + 0.317vw, 1rem);\n    font-weight: 400;\n    padding: 16px;\n    border: 1px solid var(--gray-five);\n}\n\n.table tbody tr td:not(:last-child) {\n    border-right: 0;\n}\n\n.table tbody tr td:not(:first-child) {\n    border-left: 0;\n}\n\n.table tbody tr td:first-child {\n    border-radius: 8px 0 0 8px;\n}\n\n.table tbody tr td:last-child {\n    border-radius: 0 8px 8px 0;\n}\n\n.table.style-two {\n    color: var(--body-color);\n    ;\n    border-spacing: 0px;\n    background-color: var(--white);\n    border: 1px solid var(--gray-five);\n    border-radius: 16px;\n    overflow: hidden;\n}\n\n.table.style-two thead tr {\n    border: 0;\n}\n\n.table.style-two thead tr th {\n    border-bottom: 1px solid var(--gray-five);\n    border-radius: 0;\n    padding: 24px;\n    font-weight: 700;\n    font-family: var(--heading-font);\n    background-color: var(--white);\n}\n\n.table.style-two tbody tr:last-child td {\n    border-bottom: 0;\n}\n\n.table.style-two tbody tr td {\n    border-radius: 0 !important;\n    border-top: 0;\n    border-left: 0;\n    border-right: 0;\n    border-style: dashed;\n}\n\n/* ======================= Common Table Css End ======================= */\n/* ================= Common Card Css Start ========================= */\n.common-card {\n    border: 0;\n    box-shadow: var(--box-shadow);\n    border-radius: 16px;\n    background-color: var(--white);\n}\n\n.common-card .card-header,\n.common-card .card-footer {\n    padding: 12px 24px;\n    background-color: transparent;\n    border-bottom: 1px solid var(--border-color);\n}\n\n@media screen and (max-width: 424px) {\n\n    .common-card .card-header,\n    .common-card .card-footer {\n        padding: 12px 16px;\n    }\n}\n\n.common-card .card-header {\n    background-color: var(--black);\n}\n\n.common-card .card-header .title {\n    color: var(--static-white);\n    margin-bottom: 0;\n}\n\n.common-card .card-body {\n    padding: 24px;\n}\n\n@media screen and (max-width: 424px) {\n    .common-card .card-body {\n        padding: 16px;\n    }\n}\n\n.common-card .card-footer {\n    border-top: 1px solid var(--border-color);\n    border-bottom: 0;\n}\n\n/* ================= Common Card Css End ========================= */\n/* ================================= preload Css Start =========================== */\n.loader-mask {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: var(--white);\n    z-index: 99999;\n}\n\n.loader-mask .loader {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 80px;\n    height: 80px;\n    font-size: 0;\n    display: inline-block;\n    margin: -40px 0 0 -40px;\n    text-indent: -9999em;\n    -webkit-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    transform: translateZ(0);\n}\n\n.loader-mask .loader div {\n    background-color: var(--main);\n    display: inline-block;\n    float: none;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 80px;\n    height: 80px;\n    opacity: 0.6;\n    border-radius: 50%;\n    -webkit-animation: ballPulseDouble 2s ease-in-out infinite;\n    animation: ballPulseDouble 2s ease-in-out infinite;\n}\n\n.loader-mask .loader div:last-child {\n    -webkit-animation-delay: -1s;\n    animation-delay: -1s;\n}\n\n@-webkit-keyframes ballPulseDouble {\n\n    0%,\n    100% {\n        -webkit-transform: scale(0);\n        transform: scale(0);\n    }\n\n    50% {\n        -webkit-transform: scale(1);\n        transform: scale(1);\n    }\n}\n\n@keyframes ballPulseDouble {\n\n    0%,\n    100% {\n        -webkit-transform: scale(0);\n        transform: scale(0);\n    }\n\n    50% {\n        -webkit-transform: scale(1);\n        transform: scale(1);\n    }\n}\n\n/* ================================= preload Css End ===========================  */\n/* ====================== Section Heading ==================== */\n.section-heading {\n    text-align: center;\n    margin-bottom: clamp(2rem, 0.783rem + 2.536vw, 3rem);\n    max-width: 630px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.section-heading__title {\n    position: relative;\n    margin-bottom: 16px;\n    /* text-transform: capitalize; */\n    font-size: 250px;\n    line-height: 230px;\n    font-family: \"Unbounded\", sans-serif;\n    font-style: normal;\n\n\n}\n\n.section-heading__desc {\n    margin-top: clamp(1rem, -0.217rem + 2.536vw, 2rem);\n    font-size: clamp(1rem, 0.848rem + 0.317vw, 1.125rem);\n    max-width: 634px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 24px;\n}\n\n.section-heading__desc:last-child {\n    margin-bottom: 0;\n}\n\n.section-heading__desc.w-sm {\n    max-width: 465px;\n}\n\n.section-heading.style-left {\n    text-align: left;\n    margin-left: 0;\n}\n\n.section-heading.style-left .section-heading__desc {\n    margin-left: 0;\n}\n\n.section-heading.style-white .section-heading__title {\n    color: var(--static-white);\n}\n\n.section-heading.style-white .section-heading__desc {\n    color: #bdbecc;\n    font-weight: 300;\n}\n\n.section-heading.style-flex {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    max-width: unset;\n    align-items: center;\n}\n\n.section-heading.style-flex .section-heading__inner {\n    max-width: 410px;\n}\n\n.section-heading.style-flex .section-heading__inner.w-lg {\n    max-width: 636px;\n}\n\n.section-heading.style-three .section-heading__subtitle {\n    text-transform: capitalize;\n    padding: 8px 16px;\n    background-color: var(--white);\n    color: var(--main);\n    font-size: clamp(0.9375rem, 0.785rem + 0.317vw, 1.0625rem);\n    border-radius: 50px;\n    margin-bottom: 16px;\n}\n\n/* ====================== Section Heading En d==================== */\n/* ============= Header Start Here ======================= */\n.header {\n   \n    transition: 0.2s linear;\n    font-family: \"Happy Monkey\", system-ui;\n    font-weight: 400;\n    font-style: normal;\n}\n\n@media screen and (max-width: 991px) {\n    .header {\n        padding: 10px 0;\n    }\n}\n\n.header.fixed-header {\n    position: sticky;\n    left: 0;\n    top: 0;\n    right: 0;\n    width: 100%;\n    z-index: 9;\n    /* backdrop-filter: blur(24px); */\n    animation: slideDown 0.35s ease-out;\n    background-color: var(--body-bg);\n    box-shadow: 0 5px 16px rgba(0, 0, 0, 0.1);\n}\n\n@media screen and (max-width: 991px) {\n    .header.fixed-header {\n        top: -1px;\n        background-color: var(--main-bg);\n    }\n\n}\n\n@keyframes slideDown {\n    from {\n        transform: translateY(-100%);\n    }\n\n    to {\n        transform: translateY(0);\n    }\n}\n\n.logo img {\n    max-width: 224px;\n}\n\n@media screen and (max-width: 767px) {\n    .logo img {\n        max-width: 160px;\n    }\n}\n\n@media (max-width: 1199px) {\n    .header-right__inner .btn .icon {\n        display: none;\n    }\n\n    .language-select img {\n        display: none;\n    }\n\n    .language-select .select {\n        padding-left: 0 !important;\n    }\n}\n\n.header-right {\n    gap: 24px;\n}\n\n@media screen and (max-width: 1199px) {\n    .header-right {\n        gap: 16px;\n    }\n}\n\n.header-right__button {\n    position: relative;\n    z-index: 1;\n    cursor: pointer;\n}\n\n.header-right__button:hover::before {\n    visibility: visible;\n    opacity: 1;\n    transform: translate(-50%, -50%) scale(1);\n}\n\n.header-right__button::before {\n    position: absolute;\n    content: \"\";\n    width: 40px;\n    height: 40px;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%) scale(0.8);\n    background-color: var(--gray-five);\n    z-index: -1;\n    border-radius: 50%;\n    visibility: hidden;\n    opacity: 0;\n    transition: 0.2s linear;\n}\n\n/* Cart Btn */\n.cart-btn {\n    padding-right: 8px;\n    padding-top: 5px;\n}\n\n.qty-badge {\n    width: 20px;\n    height: 20px;\n    background: var(--main-gradient);\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: var(--static-white);\n    position: absolute;\n    top: 0;\n    right: 0;\n    pointer-events: none;\n}\n\n/* Cart Btn */\n/* Language Select */\n.language-select {\n    border: 1px solid var(--border-color);\n    border-radius: 50px;\n    padding: 8px 16px;\n}\n\n.language-select::before {\n    right: 16px;\n}\n\n.language-select select {\n    color: var(--heading-color) !important;\n    padding: 8px 16px;\n}\n\n/* Language Select */\n.toggle-mobileMenu {\n    line-height: 1;\n    font-size: 36px;\n    color: var(--heading-color);\n}\n\n.contact-number {\n    padding-right: clamp(0.75rem, -0.771rem + 3.17vw, 2rem);\n    margin-right: clamp(0.75rem, -0.771rem + 3.17vw, 2rem);\n    border-right: 1px solid var(--border-color);\n}\n\n@media screen and (max-width: 575px) {\n    .contact-number {\n        font-size: 0.875rem;\n    }\n}\n\n@media screen and (max-width: 424px) {\n    .contact-number {\n        display: none !important;\n    }\n}\n\n.contact-number:hover .text {\n    color: var(--main);\n}\n\n@media screen and (max-width: 575px) {\n    .contact-number .icon {\n        font-size: 15px !important;\n    }\n}\n\n/* Header Menu and Submenu Css Start */\n.nav-menu {\n    gap: 2px;\n}\n\n@media (min-width: 992px) and (max-width: 1199px) {\n    .nav-menu {\n        gap: 0px;\n    }\n\n    .logo {\n        display: none;\n    }\n\n    .shape_top {\n        width: 80px !important;\n    }\n\n    .hero-inner__title {\n        /* margin-bottom: 24px; */\n        font-size: clamp(4rem, -2.0093rem + 4.85vw, 2.5rem) !important;\n        line-height: 4rem !important;\n    }\n\n    .most_follwed {\n        height: 250px !important;\n    }\n\n    .popular {\n        padding-top: 20px !important;\n    }\n\n    .card-img {\n        height: 160px !important;\n    }\n}\n\n.nav-menu__item.activePage>a {\n    color: var(--main);\n}\n\n.nav-menu__item.activePage>a::before {\n    color: var(--main);\n}\n\n.nav-menu__item:hover>a {\n    color: var(--heading-color);\n}\n\n@media (min-width: 992px) {\n    .nav-menu__item:hover>a {\n        color: var(--main);\n    }\n}\n\n.nav-menu__link {\n    color: var(--heading-color);\n    font-weight: 500;\n    font-size: 1rem;\n    width: 100%;\n    padding: 30px 20px;\n    width: 100%;\n    font-family: \"Happy Monkey\", system-ui;\n    /* font-weight: 400;\n    font-style: normal; */\n}\n\n@media screen and (max-width: 1199px) {\n    .nav-menu__link {\n        font-size: 0.875rem;\n    }\n}\n\n.has-submenu {\n    position: relative;\n}\n\n.has-submenu .nav-menu__link {\n    padding-right: 16px;\n}\n\n.has-submenu.active>a,\n.has-submenu.active>a::before {\n    color: var(--main);\n}\n\n.has-submenu.active>a::before {\n    transform: translateY(-50%) rotate(180deg) !important;\n}\n\n.has-submenu:hover .nav-submenu {\n    visibility: visible;\n    opacity: 1;\n    margin-top: 0;\n}\n\n@media (min-width: 992px) {\n    .has-submenu:hover>a::before {\n        color: var(--main);\n        transform: translateY(-50%) rotate(180deg);\n    }\n}\n\n.has-submenu>a {\n    position: relative;\n}\n\n.has-submenu>a::before {\n    position: absolute;\n    content: \"\\f107\";\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900;\n    font-size: 0.625rem;\n    color: var((--heading-color)/0.4);\n    transition: 0.2s linear;\n}\n\n/* Submenu Start */\n.nav-submenu {\n    position: absolute;\n    left: 0;\n    top: 100%;\n    width: max-content;\n    background-color: var(--white);\n    border-radius: 6px;\n    min-width: 190px;\n    overflow: hidden;\n    padding: 8px;\n    box-shadow: var(--box-shadow);\n    visibility: hidden;\n    opacity: 0;\n    margin-top: 16px;\n    transition: 0.2s linear;\n    z-index: 99;\n}\n\n@media (min-width: 992px) {\n    .nav-submenu {\n        max-height: 400px;\n        overflow-y: auto;\n    }\n}\n\n.nav-submenu::-webkit-scrollbar {\n    width: 6px;\n}\n\n.nav-submenu::-webkit-scrollbar-track {\n    background: #e4e4e4;\n}\n\n.nav-submenu::-webkit-scrollbar-thumb {\n    background: #a2a2a2;\n    border-radius: 50px;\n}\n\n.nav-submenu::-webkit-scrollbar-thumb:hover {\n    background: #6d6d6d;\n}\n\n.nav-submenu__item {\n    display: block;\n    border-radius: 4px;\n    transition: 0.2s linear;\n    position: relative;\n}\n\n.nav-submenu__item.activePage .nav-submenu__link {\n    color: var(--main);\n}\n\n.nav-submenu__item.activePage::before {\n    visibility: visible;\n    opacity: 1;\n}\n\n.nav-submenu__item.activePage a {\n    margin-left: 10px;\n}\n\n.nav-submenu__item::before {\n    position: absolute;\n    content: \"\\f101\";\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900;\n    font-size: 0.625rem;\n    color: var(--main);\n    visibility: hidden;\n    opacity: 0;\n    transition: inherit;\n}\n\n.nav-submenu__item:hover {\n    background-color: var(--gray-200);\n}\n\n.nav-submenu__item:hover::before {\n    visibility: visible;\n    opacity: 1;\n}\n\n.nav-submenu__item:hover a {\n    margin-left: 10px;\n    color: var(--heading-color);\n}\n\n.nav-submenu__link {\n    color: var(--heading-color);\n    font-weight: 500;\n    font-size: 1rem;\n    width: 100%;\n    padding-right: 16px;\n    width: 100%;\n    display: block;\n    padding: 8px 14px;\n    border-radius: inherit;\n}\n\n.nav-submenu__link::before {\n    position: absolute;\n}\n\n.nav-submenu__link:hover {\n    color: var(--main) !important;\n}\n\n/* Submenu End */\n/* Header Menu and Submenu Css End */\n/* ================================= Header Css End =========================== */\n/* ============ Search box ============= */\n.search-box {\n    position: relative;\n    /* Style Two */\n    /* style Three */\n}\n\n.search-box input {\n    background-color: var(--white) !important;\n    border: 0;\n    padding-right: 70px;\n}\n\n@media screen and (max-width: 767px) {\n    .search-box input {\n        padding-right: 56px;\n    }\n}\n\n.search-box input::placeholder {\n    color: var(--black-three);\n}\n\n.search-box .icon {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--body-color);\n}\n\n@media screen and (max-width: 767px) {\n    .search-box .icon {\n        right: 5px;\n    }\n}\n\n.search-box.style-two {\n    max-width: 636px;\n    margin: 0 auto;\n}\n\n.search-box.style-two input {\n    padding-left: 170px;\n}\n\n@media screen and (max-width: 575px) {\n    .search-box.style-two input {\n        padding-left: 128px;\n    }\n}\n\n.search-box.style-two .search-box__select {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n@media screen and (max-width: 575px) {\n    .search-box.style-two .search-box__select {\n        left: 0;\n    }\n}\n\n.search-box.style-two .search-box__select.select-has-icon::before {\n    right: 0;\n}\n\n.search-box.style-two .search-box__select.select-has-icon::after {\n    position: absolute;\n    content: \"\";\n    width: 1px;\n    height: 100%;\n    right: -8px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: var(--border-color);\n}\n\n.search-box.style-two .search-box__select.select-has-icon select {\n    padding-right: 19px;\n    padding-left: 12px;\n    color: var(--black-three);\n}\n\n@media screen and (max-width: 575px) {\n    .search-box.style-two .search-box__select.select-has-icon select {\n        font-size: 0.75rem;\n    }\n}\n\n.search-box.style-two .search-box__select.select-has-icon select:focus {\n    box-shadow: none;\n}\n\n.search-box.style-three {\n    max-width: 274px;\n}\n\n.search-box.style-three .icon {\n    width: 48px;\n    height: 48px;\n    right: 4px;\n}\n\n@media screen and (max-width: 991px) {\n    .search-box.style-three .icon {\n        width: 36px;\n        height: 36px;\n    }\n}\n\n.search-box.style-three input {\n    background-color: var(--section-bg) !important;\n    border: 1px solid var(--white-one);\n}\n\n.search-box .rounded-icon {\n    width: 40px;\n    height: 40px;\n    border: 1px solid var(--white-one);\n    border-radius: 50%;\n    transition: 0.2s linear;\n}\n\n.search-box .rounded-icon:hover {\n    background-color: var(--white-one) !important;\n}\n\n/* ================== Search Box =================== */\n/* Mobile Menu Sidebar Start */\n.mobile-menu {\n    position: fixed;\n    background-color: white;\n    width: 300px;\n    height: 100vh;\n    overflow-y: auto;\n    padding: 24px;\n    z-index: 991;\n    transform: translateX(-100%);\n    transition: 0.2s linear;\n    padding-bottom: 68px;\n    z-index: 9999;\n}\n\n.mobile-menu::-webkit-scrollbar {\n    width: 6px;\n}\n\n.mobile-menu::-webkit-scrollbar-track {\n    background: #e0e0e0;\n}\n\n.mobile-menu::-webkit-scrollbar-thumb {\n    background: #bab9b9;\n    border-radius: 30px;\n}\n\n.mobile-menu::-webkit-scrollbar-thumb:hover {\n    background: #949494;\n}\n\n.mobile-menu.active {\n    transform: translateX(0%);\n}\n\n.close-button {\n    position: absolute;\n    right: 8px;\n    top: 8px;\n    width: 28px;\n    height: 28px;\n    background-color: var(--gray-200);\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: 0.2s;\n}\n\n.close-button:hover {\n    background-color: var(--black);\n    color: var(--white);\n}\n\n.nav-menu--mobile {\n    display: block;\n    margin-top: 32px;\n}\n\n.nav-menu--mobile .nav-menu__item>a::before {\n    transform: translateY(-50%) rotate(0deg);\n}\n\n.nav-menu--mobile .nav-menu__link {\n    border-bottom: 1px solid var((--black)/0.08) !important;\n    position: relative;\n    padding: 12px 0;\n    padding-right: 16px;\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n}\n\n.nav-menu--mobile .nav-submenu {\n    position: static;\n    visibility: visible;\n    opacity: 1;\n    box-shadow: none;\n    width: 100%;\n    margin-top: 0;\n    padding: 0;\n    margin-left: 16px;\n    display: none;\n    transition: 0s;\n}\n\n.nav-menu--mobile .nav-submenu__link {\n    width: 100%;\n    padding: 10px 0;\n    border-bottom: 1px solid var((--black)/0.08) !important;\n    font-family: Poppins;\n}\n\n.nav-menu--mobile .nav-submenu__item:hover {\n    background-color: transparent;\n    color: var(--main);\n}\n\n.nav-menu--mobile .nav-submenu__item::before {\n    display: none;\n}\n\n/* Mobile Menu Sidebar Start */\n/* ============= Footer Start Here ======================= */\n/* Text Slider Css Start */\n.text-slider-section {\n    padding: 40px 0;\n    border-bottom: 1px solid var((--white-one)/0.2);\n}\n\n.text-slider .js-marquee {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.text-slider__item {\n    font-size: clamp(1rem, -0.674rem + 3.487vw, 2.375rem);\n    color: var(--black-three);\n    text-transform: capitalize;\n    transition: 0.2s linear;\n}\n\n.text-slider__item:hover {\n    color: var(--static-white);\n}\n\n.footer-three {\n    background-color: var(--black-two);\n}\n\n.footer-three .footer-inner {\n    padding: 80px 0;\n    background-color: #0b0e2a !important;\n}\n\n.footer-section {\n    margin-top: auto;\n    position: relative;\n    z-index: 1;\n\n    /* background-image: url(../images/shapes/footer-bg.png); */\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: top;\n    padding: 70px 0;\n    /* padding-top: 220px; */\n    /* color: white; */\n    background-color: var(--main-bg);\n}\n\n@media screen and (max-width: 1199px) {\n    .footer-section {\n        padding: 70px 0;\n        /* background-color: var(--black) !important; */\n        /* background-image: none; */\n    }\n}\n\n@media screen and (max-width: 991px) {\n    .footer-section {\n        padding: 80px 0;\n    }\n}\n\n.footer-inner {\n    padding: 80px 0;\n}\n\n.footer-widget__desc {\n    color: var(--static-white-one);\n    font-size: 1rem;\n    font-weight: 300;\n    line-height: 170%;\n}\n\n.footer-widget__logo {\n    margin-bottom: 32px;\n}\n\n@media screen and (max-width: 991px) {\n    .footer-widget__logo {\n        margin-bottom: 24px;\n    }\n}\n\n.footer-widget__logo a img {\n    width: 100%;\n    height: 100%;\n    max-width: 240px;\n    max-height: 64px;\n}\n\n.footer-widget__social {\n    margin-top: 32px;\n}\n\n@media screen and (max-width: 991px) {\n    .footer-widget__social {\n        margin-top: 24px;\n    }\n}\n\n.footer-widget__title {\n    margin-bottom: 24px;\n}\n\n/* Footer List Item */\n.footer-lists {\n    display: flex;\n    flex-direction: column;\n}\n\n.footer-lists__item {\n    display: block;\n    padding-bottom: 10px;\n}\n\n.footer-lists__item:last-child {\n    padding-bottom: 0;\n}\n\n.footer-lists__link {\n    position: relative;\n    color: var(--static-white-one);\n    padding-left: 22px;\n}\n\n.footer-lists__link::before {\n    position: absolute;\n    /* content: \"\\f105\"; */\n    font-family: \"Line Awesome Free\";\n    font-weight: 900;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 0.875rem;\n    transition: 0.2s linear;\n    width: calc(100% + 1px);\n    height: calc(100% + 1px);\n}\n\n.footer-lists__link:hover {\n    color: var(--static-white);\n}\n\n.footer-lists__link:hover::before {\n    left: 4px;\n}\n\n/* ============= Footer End Here ======================= */\n\n/* ===================== Scroll to Top Start ================================= */\n.progress-wrap {\n    position: fixed;\n    right: 36px;\n    bottom: 36px;\n    height: 46px;\n    line-height: 46px;\n    width: 46px;\n    cursor: pointer;\n    display: block;\n    border-radius: 50px;\n    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.2);\n    z-index: 10000;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(15px);\n    -webkit-transition: all 200ms linear;\n    transition: all 200ms linear;\n    background-color: var(--white);\n}\n\n@media screen and (max-width: 991px) {\n    .progress-wrap {\n        right: 24px;\n        bottom: 24px;\n        height: 40px;\n        width: 40px;\n        line-height: 40px;\n    }\n}\n\n.progress-wrap.active-progress {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n}\n\n.progress-wrap:hover {\n    transform: scale(1.06);\n}\n\n.progress-wrap::after {\n    position: absolute;\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900;\n    content: \"\\f062\";\n    text-align: center;\n    height: 46px;\n    width: 46px;\n    line-height: 46px;\n    font-size: 18px;\n    left: 0;\n    top: 0;\n    cursor: pointer;\n    display: block;\n    z-index: 1;\n    -webkit-transition: all 200ms linear;\n    transition: all 200ms linear;\n    color: var(--main) !important;\n}\n\n@media screen and (max-width: 991px) {\n    .progress-wrap::after {\n        height: 40px;\n        width: 40px;\n        line-height: 40px;\n    }\n}\n\n.progress-circle {\n    top: -2px;\n    position: relative;\n}\n\n.progress-wrap svg path {\n    fill: none;\n}\n\n.progress-wrap svg.progress-circle path {\n    stroke: var(--main);\n    stroke-width: 5;\n    box-sizing: border-box;\n    -webkit-transition: all 200ms linear;\n    transition: all 200ms linear;\n}\n\n/* ===================== Scroll to Top End ================================= */\n/* ================================= Template Selection Css Start =========================== */\n/* ================================= Template Selection Css End ===========================  */\n/* ============================ Sale Offer Css Start =========================== */\n.sale-offer {\n    background: linear-gradient(117deg, #FEF0F8 14.35%, #DACFFF 84.4%);\n    padding: 8px 0;\n}\n\n.sale-offer__content {\n    gap: 16px;\n}\n\n@media screen and (max-width: 424px) {\n    .sale-offer__content {\n        gap: 8px;\n    }\n}\n\n.sale-offer__text {\n    font-size: clamp(0.6875rem, 0.459rem + 0.475vw, 0.875rem);\n}\n\n.sale-offer__qty {\n    font-size: clamp(0.75rem, 0.294rem + 0.951vw, 1.125rem);\n}\n\n.sale-offer__button {\n    width: 32px;\n}\n\n.sale-offer__close {\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    z-index: 1;\n    transition: 0.2s linear;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n@media screen and (max-width: 424px) {\n    .sale-offer__close {\n        width: 28px;\n        height: 28px;\n    }\n}\n\n.sale-offer__close:hover {\n    color: var(--main);\n}\n\n.sale-offer__close:hover::before {\n    visibility: visible;\n    opacity: 1;\n    transform: scale(1);\n}\n\n.sale-offer__close::before {\n    position: absolute;\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    background-color: var((--main)/0.2);\n    z-index: -1;\n    border-radius: inherit;\n    transition: 0.2s linear;\n    visibility: hidden;\n    opacity: 0;\n    transform: scale(0.8);\n}\n\n.countdown {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n@media screen and (max-width: 424px) {\n    .countdown {\n        gap: 10px;\n    }\n}\n\n.countdown>div {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    flex-direction: row-reverse;\n}\n\n.countdown span {\n    font-weight: 500;\n    color: var(--heading-color);\n    font-size: 14px;\n}\n\n/* ============================ Sale Offer Css End =========================== */\n/* ================================= Social Icon Css Start =========================== */\n.social-icon-list {\n    display: inline-flex;\n    gap: 12px;\n    align-items: center;\n}\n\n.social-icon-list__link {\n    width: 70px;\n    height: 70px;\n    border: 1px solid var(--static-white-one);\n    background: #000;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: var(--main-bg);\n    position: relative;\n    font-size: 0.875rem;\n    z-index: 1;\n    font-size: 30px;\n}\n\n.social-icon-list__link::after {\n    position: absolute;\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    border-radius: inherit;\n    background: var(--main-gradient);\n    transition: 0.2s linear;\n    z-index: -1;\n    visibility: hidden;\n    opacity: 0;\n}\n\n.social-icon-list__link:hover {\n    color: var(--static-white) !important;\n    border-color: transparent;\n}\n\n.social-icon-list__link:hover::after {\n    visibility: visible;\n    opacity: 1;\n}\n\n/* ================================= Social Icon Css End ===========================  */\n/* ================= Slick Arrow & Dots css Start ================ */\n.slick-initialized.slick-slider .slick-track {\n    display: flex;\n}\n\n.slick-initialized.slick-slider .slick-slide {\n    cursor: grab;\n    height: auto;\n    margin: 0 10px;\n}\n\n.slick-initialized.slick-slider .slick-slide>div {\n    height: 100%;\n}\n\n/* Arrow Small size */\n.arrow-sm .slick-arrow {\n    width: 32px;\n    height: 32px;\n    border: 1px solid var(--white-one);\n    box-shadow: 0px 20px 30px rgba(197, 196, 201, 0.25);\n    font-size: 1.125rem;\n}\n\n.arrow-sm .slick-arrow:hover {\n    border-color: var(--main);\n}\n\n/* Slick Slider Arrow */\n.slick-arrow {\n    position: absolute;\n    z-index: 1;\n    border: none;\n    background-color: transparent;\n    width: 48px;\n    height: 48px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    transition: 0.2s linear;\n    bottom: clamp(1.5rem, -1.239rem + 5.705vw, 3.75rem);\n    left: clamp(1.5rem, -1.239rem + 5.705vw, 3.75rem);\n    top: 50%;\n    transform: translateY(-50%);\n    margin-top: 0;\n    background-color: var(--white);\n    color: var(--heading-color);\n    box-shadow: 0px 20px 30px 0px rgba(197, 196, 201, 0.25);\n    font-size: 1.5rem;\n    left: -24px;\n}\n\n@media screen and (max-width: 575px) {\n    .slick-arrow {\n        left: -10px;\n    }\n}\n\n.slick-arrow:hover {\n    background-color: var(--main);\n    color: var(--white);\n}\n\n.slick-next {\n    right: -24px;\n    left: auto;\n}\n\n@media screen and (max-width: 575px) {\n    .slick-next {\n        right: -10px;\n    }\n}\n\n/* Dots Css Start */\n.slick-dots {\n    text-align: center;\n    margin-top: clamp(1.5rem, -1.239rem + 5.705vw, 3.75rem);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 16px;\n}\n\n@media screen and (max-width: 1199px) {\n    .slick-dots {\n        gap: 8px;\n    }\n}\n\n.slick-dots li {\n    display: inline-block;\n}\n\n.slick-dots li button {\n    border: none;\n    background-color: transparent;\n    color: var(--white);\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    text-indent: -9999px;\n    transition: 0.3s linear;\n    border: 1px solid var(--black);\n}\n\n.slick-dots li.slick-active button {\n    background-color: var(--black);\n}\n\n/* Dots Css End */\n/* ================= Slick Arrow & Dots css Start ================ */\n\n\n.search-box {\n    position: relative;\n}\n\n.search-box .btn {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    width: 30px;\n    height: 30px;\n    transform: translateY(-50%);\n}\n\n.search-box .common-input {\n    background-color: #E3E3E3 !important;\n    border-color: #E3E3E3;\n    padding-right: 200px;\n}\n\n@media screen and (max-width: 575px) {\n    .search-box .common-input {\n        padding-right: 60px;\n    }\n}\n\n\n.shape_top {\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 250px;\n    z-index: 999;\n}\n\n.shape_top_2 {\n    position: absolute;\n    top: 350px;\n    left: 0px;\n    width: 150px;\n    z-index: -1;\n}\n\n.shape_top_3 {\n    position: absolute;\n    top: 450px;\n    /* left: 10px; */\n    width: 150px;\n    z-index: 999;\n    right: -50px;\n}\n\n.shape_top_4 {\n    position: absolute;\n    top: 0px;\n    /* left: 10px; */\n    width: 150px;\n    left: 0px;\n    z-index: 999;\n}\n\n.shape_top_5 {\n    position: absolute;\n    top: 0px;\n    /* left: 10px; */\n    width: 150px;\n    right: -50px;\n    z-index: 999;\n    height: 170px;\n}\n\n.shape_top_6 {\n    position: absolute;\n    top: 80px;\n    right: 40px;\n    z-index: 999;\n    /* height: 170px; */\n}\n\n.shape_top_7 {\n    position: absolute;\n    top: 400%;\n    left: 0px;\n    height: 170px;\n    z-index: 999;\n}\n\n.shape_top_8 {\n    position: absolute;\n    top: 420%;\n    right: 0px;\n    /* width: 250px; */\n    height: 170px;\n    z-index: 999;\n}\n\n.shape_top_9 {\n    position: absolute;\n    top: 250%;\n    height: 170px;\n    left: 0px;\n    /* width: 250px; */\n    z-index: 999;\n}\n\n.shape_top_10 {\n    position: absolute;\n    top: -200px;\n    height: 170px;\n    right: 0px;\n    /* width: 250px; */\n    z-index: 999;\n}\n\n\n.map-box iframe {\n    border-radius: 10px;\n}\n\n.left_1,\n.right_1 {\n    top: 86% !important;\n    width: 36px;\n    height: 36px;\n\n    border: 2px solid black;\n}\n\n/* Hover effect for the .left_1 and .right_1 buttons */\n.left_1:hover,\n.right_1:hover {\n    background: var(--main-bg);\n    /* Change background to white on hover */\n    color: white;\n    /* Change text color to match the main background color */\n    border: 2px solid var(--main-bg);\n    /* Keep the border color the same */\n}\n\n\n.learn-new {\n    padding: 80px 0;\n    /* background-color: #f9f9f9; */\n}\n\n.section-title {\n    font-size: 2.5rem;\n    font-weight: bold;\n    margin-bottom: 20px;\n}\n\n.course-card {\n    background-color: #fff;\n    border-radius: 15px;\n    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    border-radius: 15px;\n}\n\n\n\n.card-img {\n    width: 40%;\n    height: 120px;\n    border-radius: 10px;\n    object-fit: cover;\n}\n\n.card-content {\n    flex-grow: 1;\n}\n\n.course-title {\n    font-size: 1.2rem;\n    font-weight: bold;\n    margin-bottom: 5px;\n}\n\n.author-name,\n.course-duration {\n    font-size: 0.9rem;\n    color: #777;\n    margin: 0;\n}\n\n.hero-inner__title {\n    margin-bottom: 24px;\n    font-size: clamp(6rem, -2.0093rem + 7.85vw, 4.5rem);\n    line-height: 6rem;\n    /* text-transform: capitalize; */\n\n    font-family: \"Unbounded\", sans-serif;\n    font-style: normal;\n}\n\n\n\n.hero-inner__title_2 {\n    font-size: 50px;\n    color: #FF7A00;\n    /* -webkit-text-fill-color: white;  */\n    /* -webkit-text-stroke: 1px white; */\n    margin-top: -70px;\n    width: 60%;\n}\n\n@media screen and (max-width: 991px) {\n    .hero-inner__title {\n        font-size: clamp(3rem, -2.0093rem + 7.85vw, 4.5rem);\n        line-height: 3rem;\n        margin-bottom: 16px;\n    }\n\n    .hero-inner__title_2 {\n        margin-top: -60px;\n    }\n\n    .hero-inner__title_2 img {\n        width: 300px;\n        max-width: 300px;\n        height: auto;\n\n    }\n\n    .header {\n        background: var(--main-bg);\n    }\n\n    .section-heading__title {\n        font-size: 60px;\n        line-height: 60px;\n\n\n    }\n\n    .selling-product-slider {\n        width: 80%;\n    }\n\n}\n\n.product-item {\n    position: relative;\n    margin-top: 150px;\n}\n\n.product-item_main {\n    position: absolute;\n    z-index: 0;\n}\n\n.product-item_main_img {\n    position: relative;\n    width: 90%;\n    height: 90%;\n    margin-top: 20px;\n    margin-left: 20px;\n}\n\n.product-item_main_link {\n    position: relative;\n    z-index: 2;\n    text-align: center;\n    display: block;\n    font-size: 26px;\n    margin-top: 10px;\n    color: black;\n    margin-top: 30px;\n}\n\n.most_follwed {\n    background: #FF7A00;\n    width: 95%;\n    height: 350px;\n    margin: 0 auto;\n    position: absolute;\n    top: 40px;\n    z-index: 0;\n    border-radius: 10px;\n}\n\n.most_follwed_img {\n    position: relative;\n    top: 20px;\n    margin-left: -30px;\n}\n\n.most_follwed_name {\n    position: relative;\n    z-index: 2;\n    text-align: center;\n    display: block;\n    font-size: 18px;\n    margin-top: 30px;\n    color: black;\n}\n\n.section-heading__1 {\n    font-size: 60px;\n}\n\n\n/* ========================== Account Page Css Start ============================= */\n.dark-light-mode {\n    position: absolute;\n    right: 24px;\n    top: 24px;\n}\n\n.account {\n    position: relative;\n}\n\n.account__img {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n}\n\n/* @media screen and (max-width: 991px) {\n    .account__img {\n        display: none;\n    }\n} */\n\n/* .account__left {\n    width: 43%;\n    padding: 32px;\n    position: relative;\n}\n\n@media screen and (max-width: 991px) {\n    .account__left {\n        width: 60%;\n    }\n}\n\n.account__left::before {\n    position: absolute;\n    content: \"\";\n    width: 675px;\n    height: 552px;\n    background: linear-gradient(152deg, rgba(246, 246, 246, 0.3) 17.12%, rgba(94, 53, 242, 0.3) 105.91%);\n    filter: blur(100px);\n    left: -290px;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: -1;\n} */\n\n/* Image section, taking 55% of the screen width */\n/* Main styles for larger screens */\n.account__left {\n    width: 50%;\n    padding: 32px;\n    position: relative;\n    height: 100vh;\n    /* Ensures the image section fills the full height */\n    overflow: hidden;\n}\n\n.account__right {\n    width: 50%;\n    height: 100vh;\n    padding: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n\n\n.account__left::before {\n    position: absolute;\n    content: \"\";\n    width: 675px;\n    height: 552px;\n    background: linear-gradient(152deg, rgba(246, 246, 246, 0.3) 17.12%, rgba(94, 53, 242, 0.3) 105.91%);\n    filter: blur(100px);\n    left: -290px;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: -1;\n}\n\n.account__img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    /* Make sure the image fills its container */\n}\n\n.account__right_box {\n    min-height: 500px;\n}\n\n/* Right side form section */\n.account__right {\n    width: 50%;\n    /* Form section takes 45% of the screen width */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #F4F4F4;\n    height: 100vh;\n    /* Ensure the form section fills the screen height */\n}\n\n.account-content {\n    width: 100%;\n    max-width: 400px;\n    /* Restrict the form width */\n}\n\n/* Heading for login form */\n.login-heading {\n    font-size: 24px;\n    font-weight: 700;\n    text-align: center;\n    /* color: black; */\n}\n\n/* Form field styling */\n.common-input {\n    width: 100%;\n    padding: 12px 16px;\n    border-radius: 8px;\n    /* Rounded corners */\n    border: 1px solid #d1d1d1;\n    background-color: #f6f6f6;\n    outline: none;\n}\n\n.common-input:focus {\n    border-color: var(--main);\n    /* Purple focus border */\n    box-shadow: 0 0 5px rgba(94, 53, 242, 0.2);\n}\n\n/* Styling for the submit button */\n.btn-main {\n    background-color: var(--main);\n    color: #fff;\n    border: none;\n    border-radius: 8px;\n    padding: 12px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    font-family: \"Happy Monkey\", system-ui;\n}\n\n.btn-main:hover {\n    background-color: #4b29b0;\n}\n\n.btn-outline-light {\n    background-color: #fff;\n    color: #5e35f2;\n    border: 1px solid #5e35f2;\n    border-radius: 8px;\n    padding: 12px;\n}\n\n.btn-outline-light:hover {\n    background-color: #f0f0f0;\n}\n\n/* Forgot password link */\n.forgot-password {\n    font-size: 14px;\n    color: var(--main-bg) !important;\n}\n\n\n.account__right {\n    flex-grow: 1;\n    padding-left: 32px;\n    padding-right: 32px;\n    padding-bottom: 300px;\n    position: relative;\n}\n\n@media screen and (max-width: 991px) {\n    .account__right {\n        padding-bottom: 80px;\n    }\n}\n\n@media screen and (max-width: 575px) {\n    .account__right {\n        padding-bottom: 60px;\n    }\n}\n\n@media screen and (max-width: 575px) {\n    .account__right {\n        padding-left: 24px;\n        padding-right: 24px;\n    }\n}\n\n.account-thumb {\n    max-width: 572px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.account-content {\n    max-width: 600px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.sign_btn {\n    /* border-radius: 43px; */\n\n    background: linear-gradient(94deg, #FFA553 0%, #FF7A00 100%);\n    box-shadow: 0px 5px 10px 0px rgba(144, 144, 144, 0.25);\n}\n\n.cicrle_btn {\n    /* width: 53px;\n    height: 53px; */\n    background: var(--main-bg);\n}\n\n.btN_login {\n    background: linear-gradient(90deg, #FFA24C 0%, #FF7D06 100%);\n\n}\n\n.Unbounded {\n    font-family: \"Unbounded\", sans-serif;\n}\n\n.intractive {\n    width: 659px;\n}\n\n.this_flex p {\n    margin-top: 10px;\n    margin-right: 25px;\n}\n\n.spcl_clss {\n    margin-top: -250px;\n}\n\n.spcl_clss .col-lg-6:nth-child(2) {\n    margin-top: -120px;\n}\n\n.spcl_clss a {\n    color: black;\n    border-radius: 54px;\n    background: linear-gradient(94deg, #FF7A00 3.89%, #D74000 96.79%);\n    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);\n}\n\n.header-menu {\n    margin-left: 20%;\n}\n\n.nav-menu__item.activePage>a {\n    color: var(--main-bg);\n    /* color: #FF7A00; */\n}\n\n\n\n\n/* ========================== Course============================= */\n.spl_cards {\n    background-color: #fff;\n    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n    display: flex;\n    border-radius: 16px;\n    background: #FFF;\n    border: none;\n}\n\n.feed_card {\n    background-color: #fff;\n    border-radius: 16px;\n    /* box-shadow: 0 0 15px rgba(0, 0, 0, 0.1); */\n    padding: 20px 30px;\n    background: #FFF;\n    border: none;\n}\n\n\n.spl_cards .course-title {\n    color: #030408;\n    font-family: Poppins;\n    font-size: 36px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 37px;\n    /* 102.778% */\n}\n\n.spl_cards .course-description {\n    color: var(--button-secondary);\n    font-family: Poppins;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 19px;\n    /* 135.714% */\n}\n\n.spl_cards .Stars {\n    color: var(--main-bg);\n    /* font-size: 30px; */\n}\n\n.spl_cards .course-author {\n    color: #000;\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n\n}\n\n.spl_cards .course-time {\n    color: var(--main-bg);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 19px;\n\n\n}\n\n.btn_cousre {\n    color: #040404;\n    font-family: Poppins;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 19px;\n    border-radius: 4px;\n    background: linear-gradient(278deg, #FF7B01 1.43%, #FFA350 91.63%);\n}\n\n.cours_deataisl {\n    color: var(--button-secondary);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n\n}\n\n.course-titles {\n    color: #030408;\n    font-family: Poppins;\n    font-size: 36px;\n    font-style: normal;\n    font-weight: 600;\n}\n\n\n\n.spl_buttonss {\n    margin-right: 10px;\n    border-radius: 8px !important;\n    border: 2px solid var(--button-secondary) !important;\n    margin-top: 10px;\n}\n\n.card_add {\n    border-radius: 16px;\n    background: #FFF;\n    border: none;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n\n}\n\n.other_course-title {\n    color: #030408;\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n}\n\n.card_add {\n    color: var(--button-secondary);\n    font-family: Poppins;\n}\n\n.card_add .class_span span {\n    margin-right: 20px;\n}\n\n\n.btn_cousre {\n    border-radius: 30px;\n    padding: 15px 20px;\n    border-radius: 8px;\n    color: #030408 !important;\n    font-family: Poppins;\n    font-size: 16px;\n    /* width: 80%; */\n    background: linear-gradient(93deg, #FFA34F 0.91%, #FF7A00 100%);\n}\n\n.course-checkout {\n    color: #030408;\n    font-family: Poppins;\n    font-size: 36px;\n    font-style: normal;\n    font-weight: 600;\n}\n\n\n.card_add .cousrse_p {\n\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 19px;\n    /* 118.75% */\n}\n\n.check_class {\n    border-bottom: 3px solid #D9D9D9;\n}\n\n.check_class_1 {\n    height: 4px;\n    width: 100%;\n    border-radius: 8px;\n    background: #D9D9D9;\n    margin-top: 20px;\n}\n\n.check_class p {\n    margin-bottom: 10px;\n}\n\n.feed_img {\n    width: 56px;\n    height: 56px;\n}\n\n.feed_img img {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n\n\n.feed_imgs {\n    /* width: 314px; */\n    height: 314px;\n}\n\n.feed_imgs img {\n    width: 100%;\n    height: 100%;\n    border-radius: 16px;\n    object-fit: cover;\n}\n\n.feed_details_img {\n    width: 740px;\n    height: 738px;\n    margin: 80px auto;\n}\n\n.feed_details_img img {\n    width: 100%;\n    height: 100%;\n    border-radius: 8px;\n    object-fit: cover;\n}\n\n.upload_modal .modal-content {\n    border-radius: 16px;\n    background: #F9F5F2;\n}\n\n.upload_modal .form-control {\n    /* border-radius: 16px; */\n    background: #F9F5F2;\n    border: transparent;\n}\n\n.upload_modal .modal-header {\n    border-bottom: transparent;\n}\n\n.upload_modal .modal-footer {\n    border-top: transparent;\n}\n\n\n.upload_popup .modal-body textarea {\n    min-height: 250px;\n}\n\n.btn_cls {\n    background: transparent url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\") center / 1em auto no-repeat;\n\n}\n\n.uplaod_close {\n    background-color: var(--main-bg);\n    color: var(--white) !important;\n    opacity: 1;\n    border-radius: 50%;\n    margin-right: 10px !important;\n\n}\n\n.upload_media_titlle {\n    color: #000;\n    font-size: 33px;\n\n}\n\n.upload_popup_medai .modal-body {\n    min-height: 400px;\n}\n\n/* Style for the first image */\n.upload_popup_medai2 .modal-body .uplad_img:first-of-type {\n    width: 462px;\n    height: 456px;\n    margin: 20px;\n}\n\n.upload_popup_medai2 .modal-body .uplad_img:first-of-type img {\n    width: 100%;\n    height: 100%;\n    border-radius: 8px;\n    object-fit: cover;\n}\n\n.upload_popup_medai2 .modal-body .uplad_img:first-of-type span {\n    display: none;\n}\n\n\n/* Style for all other images */\n.upload_popup_medai2 .modal-body .uplad_img:not(:first-of-type) {\n    width: 187px;\n    height: 247px;\n    border-radius: 8px;\n    margin: 20px;\n\n}\n\n.upload_popup_medai2 .modal-body .uplad_img:nth-of-type(2) {\n    padding: 5px;\n    border: 2px solid #FFA553;\n}\n\n/* Style for all other images */\n.upload_popup_medai2 .modal-body .uplad_img:not(:first-of-type) img {\n    width: 100%;\n    height: 100%;\n    border-radius: 8px;\n    object-fit: cover;\n}\n\n.upload_popup_medai3 .modal-body .uplad_img {\n    width: 286px;\n    height: 259px;\n    margin: 20px;\n}\n\n.upload_popup_medai3 .modal-body .uplad_img img {\n    width: 100%;\n    height: 100%;\n    border-radius: 8px;\n    object-fit: cover;\n}\n\n\n\n\n@media (min-width: 992px) {\n\n    .modal-lg,\n    .modal-xl {\n        --bs-modal-width: 994px;\n    }\n}\n\n.learn_withcard {\n    background-color: #fff;\n    border-radius: 16px;\n    /* box-shadow: 0 0 15px rgba(0, 0, 0, 0.1); */\n    padding: 20px 30px;\n    background: #FFF;\n    border: none;\n}\n\n.learn_withcard .img {\n    width: 186px;\n    height: 186px;\n}\n\n.learn_withcard .img img {\n    border-radius: 50%;\n}\n\n.learm-tilte {\n    color: #000;\n    font-size: 24px;\n    font-weight: 600;\n}\n\n.learm-tilte2 {\n    color: #FF7A00;\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.course_video .imgss {\n    width: 267px;\n    height: 153px\n}\n\n.course_video .imgss img {\n    width: 100%;\n    height: 100%;\n    border-radius: 8px;\n    object-fit: cover;\n}\n\n.course_video_text {\n    color: #030408;\n    font-size: 20px;\n    font-weight: 500;\n}\n\n.course_video_time {\n    font-size: 16px;\n    font-weight: 500;\n    color: #030408;\n}\n\n.comment_box_input {\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    border-bottom: 1px solid black !important;\n}\n\n.comment_box .row {\n    margin-bottom: 20px;\n}\n\n.comment_box .sp_row {\n    width: 50%;\n}\n\n\n.replay {\n    margin-top: 30px;\n    color: #000;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.comment_box .feed_img {\n    width: 42px;\n    height: 42px;\n}\n\n.share_button {\n    /* height: 44px; */\n    border-radius: 28px !important;\n    color: white !important;\n    padding: 9px 25px !important;\n    background: linear-gradient(278deg, #FF7B01 1.43%, #FFA350 91.63%) !important;\n}\n\n.upnext {\n    color: #FF7A00 !important;\n    font-size: 22px !important;\n}\n\n/* ======================== All Product Section Css Start ====================== */\n/* Filter Tab Css Start */\n.filter-tab {\n    margin-bottom: 32px;\n}\n\n@media screen and (max-width: 1199px) {\n    .filter-tab {\n        gap: 24px;\n    }\n}\n\n@media screen and (max-width: 1199px) {\n    .filter-tab {\n        gap: 16px;\n    }\n}\n\n.filter-tab__right {\n    gap: 24px;\n}\n\n@media screen and (max-width: 1199px) {\n    .filter-tab__right {\n        gap: 16px;\n    }\n}\n\n@media screen and (max-width: 991px) {\n    .filter-tab__button:hover {\n        background-color: transparent !important;\n        border-color: var(--white-one) !important;\n        color: var(--black) !important;\n    }\n}\n\n.filter-tab__button.active {\n    background-color: var(--white-one) !important;\n    border-color: var(--white-one) !important;\n    color: var(--black) !important;\n}\n\n.filter-form {\n    display: none;\n}\n\n/* Filter Tab Css End */\n/* List & Grid Buttons Start */\n@media screen and (max-width: 991px) {\n    .list-grid {\n        order: -1;\n    }\n}\n\n.list-grid__button {\n    width: 36px;\n    height: 36px;\n    border: 1px solid var(--gray-five);\n    border-radius: 8px;\n    font-size: 22px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: 0.2s linear;\n}\n\n.list-grid__button.active {\n    border-color: var(--black) !important;\n    background: var(--black) !important;\n    color: var(--white) !important;\n}\n\n/* List & Grid Buttons End */\n/* List & Grid Card Css Start */\n.list-view .list-grid-wrapper>div {\n    width: 100%;\n}\n\n.list-view .list-grid-wrapper .product-item {\n    display: flex;\n}\n\n.list-view .list-grid-wrapper .product-item__content {\n    flex-grow: 1;\n}\n\n/* List & Grid Card Css End */\n/* Filter Sidebar Css Start */\n.filter-sidebar {\n    background: var(--white);\n    padding: 32px 16px;\n    border-radius: 8px;\n    position: relative;\n}\n\n.common-check .form-check-input:checked::before {\n    visibility: hidden;\n}\n\n/* @media screen and (max-width: 991px) {\n    .filter-sidebar {\n        position: fixed;\n        left: 0;\n        top: 0;\n        z-index: 999;\n        border-radius: 0;\n        width: 300px;\n        transform: translateX(-100%);\n        transition: 0.2s linear;\n        height: 100vh;\n        overflow-y: auto;\n        padding-top: 48px;\n    }\n} */\n\n.filter-sidebar.show {\n    transform: translateX(0);\n}\n\n.filter-sidebar__item:last-child .filter-sidebar__content {\n    margin-bottom: 0;\n}\n\n.filter-sidebar__content {\n    margin-bottom: 44px;\n}\n\n@media screen and (max-width: 1199px) {\n    .filter-sidebar__content {\n        margin-bottom: 32px;\n    }\n}\n\n@media screen and (max-width: 991px) {\n    .filter-sidebar__content {\n        margin-bottom: 24px;\n    }\n}\n\n.filter-sidebar__button {\n    margin-bottom: 16px;\n    padding-bottom: 16px;\n    width: 100%;\n    text-align: left;\n    position: relative;\n    color: var(--heading-color);\n}\n\n.filter-sidebar__button.active::after {\n    transform: rotate(180deg);\n}\n\n.filter-sidebar__button::before {\n    position: absolute;\n    content: \"\";\n    width: calc(100% + 32px);\n    height: 1px;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    background: var(--gray-five);\n}\n\n.filter-sidebar__button::after {\n    position: absolute;\n    content: \"\\f107\";\n    font-weight: 900;\n    font-family: \"Line Awesome Free\";\n    right: 0;\n    top: 0px;\n    transition: 0.2s linear;\n}\n\n.filter-sidebar-list__item {\n    margin-bottom: 16px;\n}\n\n.filter-sidebar-list__item:last-child {\n    margin-bottom: 0;\n}\n\n.filter-sidebar-list__text {\n    font-size: 0.875rem;\n    color: var(--black-three);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    transition: 0.2s linear;\n}\n\n.filter-sidebar-list__text:hover {\n    color: var(--main);\n}\n\n.filter-sidebar-list__text:hover .form-check-label {\n    color: var(--main);\n}\n\n.filter-sidebar-list__text .common-check {\n    margin-bottom: 0;\n}\n\n.filter-sidebar-list__text .form-check-label {\n    transition: 0.2s linear;\n}\n\n.learn_withcard .Stars img {\n    width: 20px;\n    height: auto;\n}\n\n\n/* Optional custom style to adjust button appearance for pill display */\n.filter-sidebar__pills {\n    white-space: nowrap;\n    /* padding-bottom: 8px; */\n}\n\n.filter-sidebar__pills::-webkit-scrollbar {\n    display: none;\n    /* Hide scrollbar on webkit browsers */\n}\n\n.btn-outline-primary_1 {\n    padding: 7px 0;\n    padding-left: 10px;\n    padding-right: 25px;\n    border-radius: 8px !important;\n    background: #E3E3E3;\n    width: auto;\n    height: 40px;\n}\n\n.btn-outline-primary_1::after {\n    top: 8px;\n    right: 5px;\n}\n\n.spaldrop_down {\n    position: absolute;\n    width: 90%;\n    margin: 0 5%;\n    padding: 20px;\n    border-radius: 8px;\n    background: #D9D9D9;\n    z-index: 9;\n}\n\n/* Filter Sidebar Css End */\n/* ======================== All Product Section Css End ====================== */\n/* ======================== Dashboard start ====================== */\n\n.dashboard_right {\n    border-right: 3px solid #E3E3E3;\n    /* transition: 0.2s linear;\n    width: 312px;\n    height: 100vh;\n    overflow-y: auto;\n    position: sticky;\n    z-index: 999;\n    top: 0; */\n\n}\n\n.sidebar-list {\n    padding-right: 20px;\n}\n\n.padding_100 {\n    padding-top: 70px;\n}\n\n\n.sidebar-list__item {\n    margin-bottom: 15px;\n}\n\n.sidebar-list__link {\n    width: 100%;\n    color: var(--body-color);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    border-radius: 16px;\n    transition: 0s;\n    background-color: var(--white);\n    border: 1px solid transparent;\n}\n\n.sidebar-list__icon {\n    width: 24px;\n    height: auto;\n    position: relative;\n}\n\n.sidebar-list__item.activePage .sidebar-list__link,\n.sidebar-list__item:hover .sidebar-list__link {\n    color: var(--heading-color);\n    /* background-color: black;\n     */\n    color: #000;\n    border: 1px solid var(--main);\n}\n\n.sidebar-list__item.activePage .sidebar-list__icon .icon,\n.sidebar-list__item:hover .sidebar-list__icon .icon {\n    visibility: hidden;\n    opacity: 0;\n}\n\n.sidebar-list__item.activePage .sidebar-list__icon .icon-active,\n.sidebar-list__item:hover .sidebar-list__icon .icon-active {\n    visibility: visible;\n    opacity: 1;\n}\n\n.sidebar-list__icon {\n    width: 24px;\n    height: auto;\n    position: relative;\n}\n\n.sidebar-list__icon .icon {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.sidebar-list__icon .icon-active {\n    visibility: hidden;\n    opacity: 0;\n}\n\n\n\n.dashboard_search_input {\n    height: 70px;\n    border-radius: 16px !important;\n}\n\n.dashboard_search .btn {\n    position: absolute;\n    right: 15px;\n    top: 50%;\n    width: 40px;\n    height: 40px;\n    transform: translateY(-50%);\n}\n\n.dashboard_profile {\n    width: 70px;\n    height: 70px;\n}\n\n.dashboard_profile img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.dashboard_card {\n    border-radius: 16px;\n    background: var(--white);\n    /* min-height: 6000px; */\n}\n\n.dashboard_card .dasboard_profile {\n    width: 130px;\n    height: 130px;\n}\n\n.dashboard_card .dasboard_profile img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.btn-outline-light {\n    border-radius: 8px;\n    border: 2px solid #E3E3E3 !important;\n    color: #030408;\n}\n\n.profiel_text {\n    width: 292px\n}\n\nhr {\n    height: 3px;\n    background-color: #dbdcdd;\n    border: none;\n}\n\n.dashboard_sub_card {\n    border-radius: 8px;\n    border: 3px solid #F5F6F8;\n    padding: 20px;\n}\n\n.profile_text_1 {\n    color: #040404;\n}\n\n.profile_text_2 {\n    color: #040404;\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.dash_borad_input {\n    border-radius: 4px !important;\n    background: #F5F6F8 !important;\n    height: 50px !important;\n}\n\n.dash_borad_input_1 {\n    height: 46px !important;\n    border-radius: 8px !important;\n    background: rgba(144, 144, 144, 0.25) !important;\n    padding-right: 90px;\n\n}\n\n.dash_borad_input_boost {\n    height: 85px !important;\n    border-radius: 8px !important;\n    background: rgba(144, 144, 144, 0.25) !important;\n    font-size: 20px;\n    padding-left: 40px;\n\n}\n\n.dash_borad_input_boost::placeholder {\n    font-size: 20px;\n    /* padding-left: 20px; */\n}\n\ninput::placeholder {\n    color: var(--button-secondary);\n    font-family: Poppins;\n    font-size: 16px;\n}\n\n.font-weight {\n    font-weight: 500;\n}\n\n.dashboard_right::-webkit-scrollbar {\n    width: 5px;\n}\n\n/* Track */\n.dashboard_right::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    /* box-shadow: inset 0 0 5px grey;  */\n\n}\n\n/* Handle */\n.dashboard_right::-webkit-scrollbar-thumb {\n    background: #e0dfdf;\n    border-radius: 10px;\n}\n\n/* Handle on hover */\n.dashboard_right::-webkit-scrollbar-thumb:hover {\n    background: #afafaf;\n}\n\n.img-cover {\n    object-fit: cover;\n\n}\n\n.dashboard_subitel {\n    color: #FF7C05;\n    /* font-size: 16px; */\n}\n\n.dashboard_input_cust {\n    background-color: #E3E3E3 !important;\n}\n\n.text-white {\n    color: var(--white) !important;\n}\n\n.dashboard_card .chat_icons {\n    width: 54px;\n    height: 54px;\n}\n\n.dashboard_card .chat_icons img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.single-line-text {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.circle_dot {\n    position: absolute;\n    width: 18px;\n    height: 18px;\n    background: #50FA01;\n    border-radius: 20px;\n    border: 2px solid #FFF;\n    right: 0px;\n    bottom: 0px;\n}\n\n.group_img {\n    position: absolute;\n    left: 35px;\n    top: 25px;\n}\n\n/* ===================== Dashboard Sidebar Start ======================= */\n.dashboard-sidebar {\n    padding: 32px;\n    padding-left: 0;\n    /* background-color: var(--white); */\n    /* border-right: 5px solid var(--black); */\n    transition: 0.2s linear;\n    width: 312px;\n    height: 100vh;\n    overflow-y: auto;\n    position: sticky;\n    top: 0;\n}\n\n.dashboard-sidebar::-webkit-scrollbar {\n    width: 6px;\n}\n\n.dashboard-sidebar::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.dashboard-sidebar::-webkit-scrollbar-thumb {\n    background: #e8e8e8;\n    border-radius: 10px;\n}\n\n.dashboard-sidebar::-webkit-scrollbar-thumb:hover {\n    background: #d1d1d1;\n}\n\n@media screen and (max-width: 991px) {\n    .dashboard-sidebar.active {\n        transform: translateX(0);\n    }\n\n    .dashboard-sidebar {\n        /* padding: 32px; */\n        padding-left: 20px;\n        background-color: var(--white);\n        /* border-right: 5px solid var(--black); */\n    }\n\n    .sidebar-list {\n        padding-left: 20px;\n    }\n}\n\n@media screen and (max-width: 1399px) {\n    .dashboard-sidebar {\n        padding: 24px;\n        padding-left: 0;\n    }\n}\n\n@media screen and (max-width: 991px) {\n    .dashboard-sidebar {\n        position: fixed;\n        left: 0;\n        top: 0;\n        z-index: 99;\n        transform: translateX(-100%);\n    }\n}\n\n.dashboard-sidebar__close {\n    position: absolute;\n    right: 4px;\n    top: 4px;\n    font-size: 20px;\n}\n\n.dashboard-sidebar .logo img {\n    max-width: 166px !important;\n}\n\n.dashboard-sidebar .logo.favicon {\n    display: none;\n}\n\n.dashboard-sidebar .logo.favicon img {\n    max-width: 44px;\n}\n\n/* User Profile Css Start */\n.user-profile {\n    position: relative;\n    text-align: center;\n}\n\n.user-profile__thumb {\n    width: 40px;\n    height: 40px;\n    overflow: hidden;\n    border-radius: 50%;\n}\n\n.user-profile__button {\n    position: relative;\n}\n\n.user-profile .user-profile-dropdown {\n    border-radius: 8px;\n    transition: 0.2s linear;\n    background-color: hsl(var(--white));\n    box-shadow: var(--box-shadow);\n    width: 200px;\n    position: absolute;\n    right: 0;\n    z-index: 9;\n    top: 100%;\n    margin-top: 15px;\n    padding: 15px;\n    transform: scale(0.9);\n    visibility: hidden;\n    opacity: 0;\n    border: 1px solid hsl(var(--gray-five));\n}\n\n.user-profile .user-profile-dropdown::before {\n    position: absolute;\n    content: \"\";\n    width: 14px;\n    height: 14px;\n    top: -7px;\n    right: 16px;\n    transform: rotate(45deg);\n    border: 1px solid hsl(var(--gray-five));\n    background-color: hsl(var(--white));\n    border-radius: 3px;\n    border-bottom: 0;\n    border-right: 0;\n}\n\n@media screen and (max-width: 991px) {\n    .user-profile .user-profile-dropdown {\n        transform: unset;\n        top: 43px;\n    }\n}\n\n.user-profile .user-profile-dropdown.show {\n    visibility: visible;\n    opacity: 1;\n    transform: scale(1);\n}\n\n.account {\n    position: relative;\n}\n\n.account__img {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n}\n\n@media screen and (max-width: 991px) {\n    .account__img {\n        display: none;\n    }\n}\n\n.account__left {\n    width: 43%;\n    padding: 32px;\n    position: relative;\n}\n\n@media screen and (max-width: 991px) {\n    .account__left {\n        width: 60%;\n    }\n}\n\n.account__left::before {\n    position: absolute;\n    content: \"\";\n    width: 675px;\n    height: 552px;\n    background: linear-gradient(152deg, rgba(246, 246, 246, 0.3) 17.12%, rgba(94, 53, 242, 0.3) 105.91%);\n    filter: blur(100px);\n    left: -290px;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: -1;\n}\n\n.account__right {\n    flex-grow: 1;\n    padding-left: 32px;\n    padding-right: 32px;\n    padding-bottom: 300px;\n    position: relative;\n}\n\n@media screen and (max-width: 991px) {\n    .account__right {\n        padding-bottom: 80px;\n    }\n}\n\n@media screen and (max-width: 575px) {\n    .account__right {\n        padding-bottom: 60px;\n    }\n}\n\n@media screen and (max-width: 575px) {\n    .account__right {\n        padding-left: 24px;\n        padding-right: 24px;\n    }\n}\n\n.account-thumb {\n    max-width: 572px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.account-content {\n    max-width: 500px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n/* ========================== Account Page Css End ============================= */\n/* ===================== Dashboard Start ======================= */\n.dashboard-nav,\n.dashboard-body__content,\n.dashboard-footer {\n    padding-left: 32px;\n    padding-right: 32px;\n}\n\n@media screen and (max-width: 1399px) {\n\n    .dashboard-nav,\n    .dashboard-body__content,\n    .dashboard-footer {\n        padding-left: 24px;\n        padding-right: 24px;\n    }\n}\n\n.dashboard-footer {\n    margin-top: auto !important;\n}\n\n.dashboard {\n    background-color: hsl(var(--gray-seven));\n}\n\n.dashboard-body {\n    width: calc(100% - 312px);\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n}\n\n@media screen and (max-width: 991px) {\n    .dashboard-body {\n        width: 100%;\n    }\n}\n\n.dashboard-body__content {\n    margin: 32px 0;\n}\n\n.dashboard-body__item {\n    margin-bottom: 32px;\n}\n\n.dashboard-body__item:last-child {\n    margin-bottom: 0;\n}\n\n/* Sidebar Collapse */\n@media (min-width: 992px) {\n    .dashboard.active .dashboard-sidebar {\n        width: auto;\n    }\n\n    .dashboard.active .dashboard-sidebar .logo {\n        display: none;\n    }\n\n    .dashboard.active .dashboard-sidebar .logo.favicon {\n        display: block;\n    }\n\n    .dashboard.active .dashboard-sidebar .sidebar-list__link {\n        width: 44px;\n        height: 44px;\n        padding: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .dashboard.active .dashboard-sidebar .sidebar-list__link .text {\n        display: none;\n    }\n\n    .dashboard.active .bar-icon {\n        display: none;\n    }\n\n    .dashboard.active .arrow-icon {\n        display: block;\n    }\n}\n\n/* Sidebar Collapse End */\n/* Dashboard Widget Css Start */\n.dashboard-widget {\n    padding: 16px 24px;\n    border-radius: 8px;\n    background-color: transparent;\n    position: relative;\n    z-index: 1;\n    transition: 0.2s linear;\n}\n\n@media screen and (max-width: 1399px) {\n    .dashboard-widget {\n        padding: 16px;\n    }\n}\n\n.dashboard-widget:hover {\n    box-shadow: 0px 20px 30px 0px rgba(197, 196, 201, 0.25);\n    background: var(--main-gradient);\n}\n\n.dashboard-widget:hover .dashboard-widget__shape.one {\n    visibility: hidden;\n    opacity: 0;\n}\n\n.dashboard-widget:hover .dashboard-widget__shape.two {\n    visibility: visible;\n    opacity: 1;\n}\n\n.dashboard-widget::before {\n    position: absolute;\n    content: \"\";\n    width: calc(100% - 2px);\n    height: calc(100% - 2px);\n    background: hsl(var(--white));\n    left: 1px;\n    top: 1px;\n    border-radius: inherit;\n    z-index: -1;\n    transition: 0.2s linear;\n}\n\n.dashboard-widget__shape {\n    position: absolute;\n    right: 0;\n    top: 16px;\n    transition: 0.2s linear;\n}\n\n.dashboard-widget__shape.two {\n    visibility: hidden;\n    opacity: 0;\n}\n\n.dashboard-widget__icon {\n    width: 72px;\n    height: 72px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    background-color: hsl(var(--gray-seven));\n}\n\n@media (min-width: 992px) and (max-width: 1399px) {\n    .dashboard-widget__icon {\n        width: 60px;\n        height: 60px;\n    }\n}\n\n@media (min-width: 992px) and (max-width: 1399px) {\n    .dashboard-widget__number {\n        font-size: 22px;\n    }\n}\n\n/* Dashboard Widget Css End */\n\n/* ======================== Dashboard End ====================== */\n\n\n\n/* Chat row styling */\n.chat_row {\n    padding: 20px;\n    background: var(--main-bg);\n}\n\n.chat_row .course_video_time {\n    color: var(--white);\n    /* border-radius: 20px; */\n}\n\n.dashboard_card .btn-main {\n    background-color: var(--white) !important;\n    /* border-radius: 20px; */\n}\n\n\n.chat_bubble {\n    padding: 10px;\n    margin-bottom: 8px;\n    max-width: 60%;\n    border-radius: 22px;\n    /* Default for all bubbles */\n}\n\n/* Left-aligned chat bubbles */\n.chat_bubble_left {\n    background: #D9D9D9;\n    color: #040404;\n    align-self: flex-start;\n    border-radius: 22px 22px 22px 22px;\n    /* Full radius for left bubbles by default */\n}\n\n/* Right-aligned chat bubbles */\n.chat_bubble_right {\n    align-self: flex-end;\n    color: white;\n    background: linear-gradient(120deg, #FFA553 0.98%, #FF7A00 97.64%);\n    border-radius: 22px 22px 22px 22px;\n    /* Full radius for right bubbles by default */\n}\n\n/* Last left-aligned chat bubble */\n.p-4 .chat_bubble_left:last-child {\n    border-radius: 22px 22px 22px 0px;\n    /* Square bottom-left corner */\n}\n\n/* Last right-aligned chat bubble */\n.p-4 .chat_bubble_right:last-child {\n    border-radius: 22px 0px 22px 22px;\n    /* Square bottom-right corner */\n}\n\n.bg-white {\n    background: var(--white) !important;\n}\n\n.dashboard_chatbox {\n    border-radius: 8px !important;\n}\n\n.dashboard_card .chat_icons_group {\n    width: 84px;\n    height: 84px;\n    position: relative;\n    margin-bottom: 35px;\n}\n\n.dashboard_card .chat_icons_group img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.custm_navpills .nav-link {\n    color: #040404;\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n\n}\n\n.custm_navpills .nav-link.active,\n.custm_navpills .show>.nav-link {\n    color: var(--black);\n    border-radius: 28px;\n    padding: 10px 40px;\n    background: linear-gradient(98deg, #FFA553 9.49%, #FF7A00 93.9%);\n}\n\n.text-black {\n    color: black;\n}\n\n.dasboard_profile_qr {\n    background: #F5F6F8;\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n}\n\n.dasboard_profile_qr img {\n    width: 57px;\n    height: 57px;\n    object-fit: cover;\n\n}\n\n.teacher_experince {\n    width: 32px;\n    height: 32px;\n    /* border-radius: 4px; */\n    border-radius: 4px;\n    border: 0.5px solid #787877;\n    background: #FFF;\n}\n\n.teacher_experince img {\n    border-radius: 4px;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.height_150 {\n    height: 150px;\n}\n\n.height_370 {\n    height: 370px;\n    border-radius: 8px;\n    background: rgba(144, 144, 144, 0.25);\n    margin-top: 20px;\n}\n\n#courseDescription {\n    height: 150px !important;\n}\n\n.btn-secondary {\n    background: var(--button-secondary) !important;\n}\n\n.boost_profile {\n    width: 157px;\n    height: 157px;\n}\n\n.boost_profile img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n}\n\n.cust_radio {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    width: 30px;\n    height: 30px;\n    border: 3px solid gray;\n    /* Orange border */\n    border-radius: 50%;\n    /* Make it circular */\n    outline: none;\n    cursor: pointer;\n    position: relative;\n}\n\n.cust_radio:checked {\n    border: 3px solid #FF7A00;\n}\n\n.cust_radio:checked::before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 14px;\n    height: 14px;\n    background-color: #FF7A00;\n    /* Inner orange dot */\n    border-radius: 50%;\n    transform: translate(-50%, -50%);\n}\n\n\n.bg_dashboard_boost {\n    background-color: #F9F5F2;\n}\n\n\ninput[type=\"range\"] {\n    -webkit-appearance: none;\n    width: 100%;\n    background-color: #ddd;\n    height: 6px;\n    border-radius: 3px;\n    outline: none;\n}\n\n/* Style for the slider thumb */\ninput[type=\"range\"]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 20px;\n    /* Increase size of the thumb */\n    height: 20px;\n    background-color: var(--main-bg);\n    /* Set color of the thumb */\n    border-radius: 50%;\n    cursor: pointer;\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);\n    /* Optional: add a subtle shadow */\n}\n\ninput[type=\"range\"]::-moz-range-thumb {\n    width: 20px;\n    height: 20px;\n    background-color: var(--main-bg);\n    border-radius: 50%;\n    cursor: pointer;\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);\n}\n\n.call {\n    border-radius: 7px !important;\n    background: #D9D9D9 !important;\n    color: var(--button-secondary) !important;\n}\n\n.whatsapp {\n    border-radius: 7px !important;\n    color: var(--white) !important;\n    background: linear-gradient(95deg, #00FF1A 1.97%, #00750C 99.72%) !important;\n}\n\n.btn {\n    border: transparent;\n}\n\n.boost_cards {\n    border-radius: 16px;\n    background: #FFF;\n    height: 309px;\n}\n\n.boost_imgs {\n    border-radius: 16px 16px 0 0;\n    height: 80%;\n    width: 100%;\n    object-fit: cover;\n}\n.course_video  {\n\n    border-radius: 16px;\n    padding: 10px;\n    height: 50%;\n    width: 100%;\n    object-fit: cover;\n\n}\n\n.btn_boost {\n    /* height: 32px !important; */\n    /* padding: 30px; */\n    border-radius: 4px !important;\n    background: #FF7A00 !important;\n    color: white !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
